export const ItTranslation = {
  lang: 'it',
  data: {
    MANAGE_RETURNS: {
      TITLE: 'Gestione resi',
      SEARCH_PLACEHOLDER: 'Cerca reso...',
      CREATE_NEW: 'Crea nuovo',
      DOWNLOAD_EXCEL: 'Scarica Excel',
      COMING_SOON: 'Disponibile a breve',
      CREATE: {
        TITLE: 'Crea nuovo reso',
        ON_BACK: 'Torna ai resi',
        SECTION_TITLE: 'Inserisci informazioni del carrello',
        RETURN_CREATED: 'Reso creato',
        FORM_INVALID: 'Compila i campi obbligatori',
      },
      CREATE_ITEMS: {
        SECTION_TITLE: 'Seleziona gli articoli da rendere',
        SEARCH_PLACEHOLDER: 'Cerca articoli',
        FILTERS: 'Filtri',
        SMART_SELECTION: 'Selezione intelligente',
        VIEW_ALL: 'Tutti',
        VIEW_SELECTED: 'Selezionati',
        SAVE_AS_DRAFT: 'Salva come bozza',
        SAVE_AND_SEND: 'Salva e invia richiesta',
        COLUMNS: {
          FULFILLMENT_NUMBER: 'Numero evasione',
          ORDER_ID: 'ID ordine',
          SKU: 'SKU',
          CODE_XIII: 'Codice XIII',
          DELIVERY_DATE: 'Data consegna',
          WAREHOUSE: 'Magazzino',
          QTY_DELIVERED: 'Qtà consegnata',
          AVAILABLE_QTY: 'Qtà disponibile',
          TOT_SELECTED: 'Tot selezionati',
          EAN: 'EAN',
          STATUS: 'Stato',
          QTY_SELECTED: 'Qtà selezionata',
          UNIT_PRICE: 'Prezzo unitario',
          TOT_PRICE: 'Prezzo totale',
          MAX_RETURNABLE: 'Max restituibile',
          SET_QTY: 'Imposta qtà',
        },
        NO_ITEMS_SELECTED: 'Seleziona almeno un articolo da rendere',
        INVALID_QTY: 'Controlla le quantità da rendere',
        STORE_CONTEXT_MISSING: 'Impossibile determinare lo store: gli articoli non possono essere caricati. Ricarica la pagina o contatta il supporto.',
        PRE_VALIDATION: {
          FAILED: 'La richiesta non può essere inviata: controlla i problemi segnalati',
          TITLE: 'Alcuni articoli non possono essere resi',
          AVAILABLE_QTY: 'disponibili: {{qty}}',
          LINE_REASONS: {
            UNKNOWN: 'Non restituibile per un motivo non specificato',
            NOT_POSITIVE_QUANTITY: 'La quantità deve essere maggiore di zero',
            EXCEEDS_AVAILABLE: 'La quantità supera quella restituibile',
            NO_AVAILABILITY_INFO: 'L\'articolo non è più disponibile per il reso',
            OUTSIDE_RETURN_WINDOW: 'La finestra di reso per questo articolo è scaduta',
            ORDER_NOT_RETURNABLE: 'L\'ordine di provenienza non è in uno stato restituibile',
            DUPLICATE_LINE: 'Lo stesso articolo compare più volte nella richiesta',
            NOT_FOR_REQUESTED_CUSTOMER_OR_STORE: 'L\'articolo appartiene a un altro cliente o store',
          },
          SET_ISSUES: {
            UNKNOWN: 'La richiesta è stata rifiutata per un motivo non specificato',
            NO_ITEMS: 'La richiesta non contiene articoli validi',
            MULTIPLE_WAREHOUSES: 'Gli articoli selezionati appartengono a magazzini diversi',
            WAREHOUSE_NOT_ACTIVE: 'Il magazzino di destinazione non è attivo',
            RETURNS_DISABLED_FOR_STORE: 'I resi sono disabilitati per questo store',
            AMOUNT_EXCEEDS_ROLE_LIMIT: 'L\'importo del reso supera il tuo limite di approvazione',
          },
        },
        FILTER_STYLE_CODE: 'Codice stile',
        FILTER_SIZE: 'Taglia',
        FILTER_ORDER_ID: 'ID ordine',
        FILTER_DELIVERY_DATE: 'Data di consegna',
        FILTER_STATUS: 'Stato',
        FILTER_STATUS_PARTIALLY: 'Parzialmente evaso',
        FILTER_STATUS_TOTALLY: 'Totalmente evaso',
        SMART_NO_MATCH: 'Nessun item corrisponde ai codici inseriti',
        WAREHOUSE_LOCKED: 'Selezione annullata: gli articoli appartengono a un magazzino diverso da quello già selezionato',
        SMART_RESULT: '{{selected}} item selezionati, {{unmatched}} codici non trovati, {{skipped}} esclusi (warehouse diversa)',
        SMART_MODAL: {
          TITLE: 'Selezione intelligente',
          CODE_TYPE_LABEL: 'Scegli il tipo di codice che inserirai:',
          STYLE_CODE: 'Codice stile',
          CODE_XIII: 'Codice XIII',
          ORDER_ID: 'ID ordine',
          CODES_LABEL: 'Inserisci i tuoi codici qui sotto.',
          CODES_PLACEHOLDER: 'Scrivi o incolla i codici qui, separati da virgole o spazi.',
          APPLY: 'Applica selezione intelligente',
        },
        SAVE_MODAL: {
          TITLE: 'Salva e invia richiesta',
          WARNING: 'Se continui non potrai più modificare le tue modifiche.',
          SEE_EDITINGS: 'Vedi le tue modifiche',
          CANCEL: 'Annulla',
          CONFIRM: 'Salva e invia richiesta',
          COLUMNS: {
            SKU: 'Codice SKU',
            EAN: 'EAN',
            OLD_QTY: 'Qtà precedente',
            NEW_QTY: 'Nuova qtà',
          },
        },
      },
      COLUMNS: {
        NAME: 'Colonne',
        RETURN_NAME: 'Nome',
        ID: 'ID',
        DATE: 'Data',
        CUSTOMER: 'Cliente',
        POINT_OF_SALE: 'Punto vendita',
        AGENCY: 'Agenzia',
        PCS_DELIVERED: 'Pz consegnati',
        PCS_TO_RETURN: 'Pz da rendere',
        TOTAL: 'Totale',
        RETURN_REQUEST: 'Richiesta di reso',
      },
      FORM: {
        BASKET_NAME: 'Nome carrello',
        CUSTOMER: 'Cliente',
        REASON: 'Motivo del reso',
        NOTES: 'Note (opzionale, max 300 caratteri)',
        BASKET_NAME_HINT: 'max 200 caratteri',
        OPTIONAL: 'opzionale',
        TEXT_PLACEHOLDER: 'Testo...',
        BASKET_NAME_PLACEHOLDER: 'Inserisci il nome del carrello...',
        NOTES_PLACEHOLDER: 'Scrivi le tue note...',
      },
      STATUS: {
        DRAFT: 'Bozza',
        CREATED: 'Inviato a ERP',
        WAITING_APPROVAL: 'In attesa di approvazione',
        APPROVED: 'Approvato',
        FAILED: 'Fallito',
        REJECTED: 'Rifiutato',
      },
      STATUS_INFO: {
        DRAFT: 'Il reso è ancora modificabile',
        WAITING_APPROVAL: 'Un utente interno deve approvare il reso',
        CREATED: 'In attesa di approvazione da ERP',
        APPROVED: 'Approvato da ERP',
        REJECTED: 'Il reso è stato rifiutato da un utente interno',
        FAILED: 'Il reso è stato rifiutato da ERP',
      },
      DETAIL: {
        BACK_TO_RETURNS: 'Torna ai resi',
        TITLE: 'Dettaglio reso',
        CUSTOMER_INFO: 'Info cliente',
        NAME: 'Nome',
        NOTES: 'Note',
        REASON: 'Motivo',
        RMA_NUMBER: 'Numero RMA',
        TOT_QTY: 'Qtà totale',
        TOT_RETAIL: 'Totale retail',
        CUSTOMER: 'Cliente',
        BILLING_ADDRESS: 'Indirizzo di fatturazione',
        SHIPPING_ADDRESS: 'Indirizzo di spedizione',
        VAT: 'Partita IVA',
        AGENCY: 'Agenzia',
        DELETE_DRAFT: 'Elimina bozza',
        SEND_REQUEST: 'Invia richiesta',
        DOWNLOAD_REPORT: 'Scarica report',
        NOTES_MODAL_TITLE: 'Note (max 300 caratteri)',
        NOTES_SAVED: 'Note salvate',
        REQUEST_SENT: 'Richiesta di reso inviata',
        DRAFT_DELETED: 'Bozza eliminata',
        DELETE_FAILED: 'Eliminazione non riuscita',
        DELETE_DRAFT_CONFIRM: 'Sei sicuro di voler eliminare questa bozza? L\'operazione non è reversibile.',
        DELETE_RETURN: 'Elimina reso',
        DELETE_RETURN_CONFIRM: 'Sei sicuro di voler eliminare questo reso? L\'operazione non è reversibile.',
        RETURN_DELETED: 'Reso eliminato',
        RESTORE_DRAFT: 'Ripristina bozza',
        DRAFT_RESTORED: 'Bozza ripristinata',
        CREATED_BANNER_TITLE: 'Richiesta di reso approvata.',
        CREATED_BANNER_BODY: 'Approvato da {{user}} il {{date}} • Motivo: {{reason}}.',
        CREATED_BANNER_BODY_TRAIL_ONLY: 'Approvato da {{user}} il {{date}}.',
        REJECTED_BANNER_TITLE: 'Richiesta di reso rifiutata.',
        REJECTED_BANNER_BODY: 'Rifiutato da {{user}} il {{date}} • Motivo: {{reason}}.',
        REJECTED_BANNER_BODY_TRAIL_ONLY: 'Rifiutato da {{user}} il {{date}}.',
        FAILED_BANNER_TITLE: 'Reso rifiutato da ERP.',
        BANNER_BODY_REASON_ONLY: 'Motivo: {{reason}}.',
        ITEMS: 'Articoli',
        ITEMS_COLUMNS: {
          SKU: 'SKU',
          EAN: 'EAN',
          STYLE: 'Stile',
          COLOR: 'Colore',
          SIZE: 'Taglia',
          ORDER_ID: 'ID ordine',
          FULFILLMENT: 'Spedizione',
          RETURN_QTY: 'Q.tà resa',
          INVOICE_ID: 'ID fattura',
        },
        EDIT_NAME: 'Modifica nome (max 200 caratteri)',
        NAME_SAVED: 'Nome salvato',
        ADD_ITEMS: 'Aggiungi item',
        EDIT_ITEMS: 'Modifica articoli',
        CLOSE_SELECT_MODE: 'Chiudi modalità selezione',
        EDIT_SELECTED_ITEMS: 'Modifica articoli selezionati',
        CANCEL: 'Annulla',
        GO_BACK: 'Torna indietro',
        ITEMS_SELECTED: 'selezionati',
        ITEMS_UPDATED: 'Articoli aggiornati',
        SAVE_AND_EXIT: 'Salva ed esci',
        SAVE_AND_SEND_REQUEST: 'Salva e invia richiesta',
        SAVE_RECAP_WARNING: 'Se continui non potrai più modificare le tue modifiche.',
        SEE_QUANTITY_CHANGES: 'Vedi modifiche di quantità',
        SEE_DELETED_ITEMS: 'Vedi articoli eliminati',
        NO_QUANTITY_CHANGES: 'Nessuna modifica di quantità',
        NO_DELETED_ITEMS: 'Nessun articolo eliminato',
        APPROVE: 'Approva',
        REJECT: 'Rifiuta',
        APPROVE_RETURN: 'Approva reso',
        REJECT_RETURN: 'Rifiuta reso',
        REJECTION_REASON: 'Inserisci un motivo (max 200 caratteri)',
        APPROVAL_REASON: 'Inserisci un motivo (facoltativo, max 200 caratteri)',
        RETURN_APPROVED: 'Reso approvato',
        RETURN_REJECTED: 'Reso rifiutato',
        ITEMS_ADDED: 'Articoli aggiunti al reso',
        APPROVE_RANGE_INFO: 'Con la conferma di questo reso, secondo il range configurato nelle impostazioni dello store:',
        RETURNED_AMOUNT: 'Importo reso',
        PURCHASED_AMOUNT: 'Importo acquistato',
        RETURNABLE_AMOUNT: 'Importo restituibile',
        APPROVING_RETURN: 'Stai approvando il reso #{{id}}.',
        REJECTING_RETURN: 'Stai per rifiutare il reso #{{id}}. Questa azione non può essere annullata.',
        PRODUCT_TITLE: 'Prodotto',
        MAX_RETURNABLE_QTY: 'Q.tà max resa',
        CURRENT_QTY: 'Q.tà attuale',
        NEW_QTY: 'Nuova quantità',
        ALL_ITEMS_REMOVED: 'Tutti gli articoli selezionati verranno rimossi.',
        ITEMS_SEARCH_PLACEHOLDER: 'Cerca articoli...',
        SELECTED_ITEMS: 'Articoli selezionati',
        GROUP_BY: 'Raggruppa per',
        GROUP_BY_NONE: 'Nessuno',
        GROUP_BY_ORDER: 'Ordine',
        GROUP_BY_PRODUCT: 'Prodotto',
        GROUP_ORDER_HEADER: 'Ordine {{id}}',
        GROUP_UNKNOWN: 'Sconosciuto',
        GROUP_EMPTY: 'Nessun articolo corrisponde alla ricerca o ai filtri correnti',
      },
    },
    CULTURE: {
      TITLE_MODAL: 'Seleziona la lingua',
      ITALIAN: 'Italiano',
      ENGLISH: 'Inglese',
      FRENCH: 'Francese',
      SPANISH: 'Spagnolo',
      GERMAN: 'Tedesco',
    },
    PRODUCTS_LIST: {
      ACTIONS: 'Azioni su tutti i prodotti',
      HANDLE_IMAGES: 'Gestisci immagini'
    },
    PRICE_LIST_DETAIL: {
      INFORMATION: 'Informazioni',
      NAME: 'Nome',
      ASSOCIATED_CUSTOMERS_COUNT: 'Clienti associati',
      TYPE: 'Tipo',
      PRICE_LIST_TYPE: 'Tipo listino',
      CUSTOM_PRICE_LIST: 'Listino personalizzato',
      DEFAULT_PRICE_LIST: 'Listino predefinito',
      STORE: 'Negozio',
      INCLUDED_VARIANTS: 'Varianti incluse',
      EXCLUDED_VARIANTS: 'Varianti escluse',
      PRODUCT_LIST: 'Elenco prodotti',
      VARIANTS: 'Varianti',
      BACK_TO_PRICE_LISTS: 'Torna ai listini',
      PARENT_PRICE_LIST: 'Price list di riferimento',
    },
    MENU: {
      UTILITIES: {
        UTILITIES: 'Strumenti',
        BULK_OPERATIONS: 'Operazioni',
      },
      DASHBOARD: 'Dashboard',
      ORDERS: 'Ordini',
      CARTS: 'Carrelli',
      PROMOTIONS: 'Promozioni',
      CUSTOMIZATION_REQUESTS: 'Richieste personalizzazione',
      RETURNS: 'Resi',
      AUTOMATIC_DISCOUNTS: 'Sconti automatici',
      CUSTOMER_DISCOUNTS: 'Sconto cliente',
      STORECHANNEL_DISCOUNT: 'Sconti invincibile',
      GOK_MODE: 'Gok',
      DIRECT_MODE: 'Ordine diretto',
      VOUCHERS: 'Vouchers',
      COMMERCIAL_AGREEMENTS: 'Accordi commerciali',
      CUSTOMERS_DISCOUNTS: 'Sconti clienti',
      AGENTS: 'Agenti',
      AGENCY_INFO: 'Info agenzia',
      CUSTOMER_INFO: 'Info cliente',
      COMMERCIAL_INFO: 'Info commerciali',
      FINANCIAL_INFO: 'Info finanziarie',
      USERS: 'Utenti',
      GENERAL_FIELDS: 'Campi generali',
      SHIPPING_ADDRESS:'Indirizzo di consegna',
      CATEGORIES: 'Gruppo di Classificazione Cliente',
      PAYMENT_TERMS: 'Termini di pagamento',
      COMPANY_FORMS: 'Modulo Aziendale',
      COURIERS: 'Corrieri',
      DOWNLOADS: {
        DOWNLOADS: 'Downloads',
        REPORTS: 'Reports'
      },
      PRODUCTS: {
        NAME: 'Prodotti',
        PRODUCTS_LIST: 'Elenco prodotti',
        INVENTORY_VISIBILITY: 'Inventary visibility',
        ASSORTMENTS: 'Assortimenti',
        IMPORT_PRODUCTS: 'Importa prodotti',
        BULK_EDITOR: 'Editor massivo',
        VARIANT_BULK_EDITOR: 'Editor varianti',
      },
      SETTINGS: {
        NAME: 'Impostazioni',
        STORE_SETTINGS: 'Del negozio',
        PRICE_LIST: 'Listino prezzi',
        TIERS: 'Tiers',
        SALES_CAMPAIGNS: 'Campagne vendita',
        TERMS_OF_SALE: 'Termini di vendita',
        SEASON_REFERENCE: 'Season Reference',
        PACKAGE_GROUP: 'Package Group',
        TRANSPORT_AGENCY: 'Agenzia di trasporto',
        ORDER_LABEL: 'Order label (opzionale)',
        DEFAULT: 'Predefinito',
        EMAIL_SETTINGS: 'Impostazioni e-mail',
        EMAIL_FOR_CHANNEL: 'E-mail per canale',
        OVERRIDE_EMAIL_INFO: 'Di seguito puoi specificare delle email differenti per ogni canale di vendita. Se non viene specificata un\'email per un canale, verrà utilizzata l\'email predefinita.',
        SHIPPING_COST_SETTINGS: 'Impostazioni costi di spedizione',
        FREE_SHIPPING_THRESHOLD: 'Soglia per spedizione gratuita',
        SHIPPING_COST: 'Costo di spedizione',
        AVOID_REPLACEMENT_SHIPPING_COSTS: 'Nessuna spesa di spedizione sui cambi merce',
        AVOID_REPLACEMENT_SHIPPING_COSTS_HINT:
          'Vale anche per il costo del corriere. Si applica ai carrelli confermati da ora in poi: gli ordini già confermati non cambiano.',
        RETURN_SETTINGS: 'Impostazioni resi',
        RETURN_AMOUNTS_INFO: 'Importo reso: €X · Importo acquistato: €Y · Importo rimborsabile: €Z.',
        RETURN_WINDOW: 'Finestra di reso',
        RETURN_WINDOW_DISABLED_NOTE: 'Lascia vuoto per disabilitare i resi su questo store.',
        DAYS: 'Giorni',
        INTERNAL_RETURN_APPROVAL_LIMIT: 'Limite di approvazione interna del reso',
        INTERNAL_RETURN_APPROVAL_LIMIT_NOTE: 'I resi sopra il limite impostato possono essere approvati solo dagli admin.',
        INTERNAL_RETURN_APPROVAL_LIMIT_EMPTY_NOTE: 'Lascia vuoto per non applicare alcun limite.',
        INTERNAL_RETURN_APPROVAL_LIMIT_STORE_OWNER: 'Limite store owner — Euro (€)',
        INTERNAL_RETURN_APPROVAL_LIMIT_ADMIN: 'Limite admin — Euro (€)',
        EURO: 'Euro (€)',
        RETURN_NOTIFICATIONS: 'Notifiche di reso',
        RETURN_NOTIFICATIONS_DISABLED_NOTE: 'Lascia vuoto per disabilitare tutte le email di reso.',
        RETURN_NOTIFICATIONS_EMAIL: 'E-Mail di ricezione delle notifiche di reso',
        NUMBER_OF_DAYS_TO_CALCULATE_THE_RE_ORDER_DATE: 'Numero di giorni per calcolare la data di re-order',
        DEFAULT_LIMIT_FOR_STYLE_COLOR_OF_MONOBRAND_STORES: 'Limite di acquisto di default sullo style-color (per i canali di vendita che lo richiedono)',
        MINIMUM_VALUE_FOR_THE_TOTAL_ORDER_AMOUNT: 'Valore minimo di un carrello per creare il corrispettivo ordine (per i canali di vendita che lo richiedono)',
        MINIMUM_REORDER_QUANTITY: 'Quantità minima per re-order (per i canali di vendita che lo richiedono)',
        MINIMUM_REORDER_QUANTITY_TOOLTIP:
          'Questa quantità minima si applica solo ai ruoli Customer e Customer Owner quando ordinano in re-order.',
        FREE_SHIPPING_ORDER_TOTAL_THRESHOLD: 'Valore minimo di un carrello per avere la spedizione gratuita (per i canali di vendita che lo richiedono)',
        GENERAL: 'Generale',
        STORE_NAME: 'Nome',
        DISCOUNT: 'Sconto',
        CURRENCY: 'Valuta',
        SALES_SETTINGS: 'Impostazioni vendita',
        PRE_ORDER_ACTIVE_FROM: 'Pre-order attivo dal',
        PRE_ORDER_ACTIVE_TO: 'Pre-order attivo fino al',
        RE_ORDER_ACTIVE_FROM: 'Re-order attivo dal',
        RE_ORDER_ACTIVE_TO: 'Re-order attivo fino al',
        MAX_CUSTOM_DATES: 'Data di consegna personalizzata possibile fino a',

        BACKGROUND_IMAGE: 'Immagine di sfondo',
        LOGO_IMAGE: 'Immagine logo',
        FAVICON_IMAGE: 'Fav icon',
        ADD: 'Aggiungi',
        CHANGE: 'Cambia',
        SMALL_LOGO: 'Small logo',

        UPLOAD_MEDIA: 'Carica media',
        UPLOAD_FILE: 'Carica file',
        UPLOAD_LINK: 'Carica link',
        VALID_URL: 'Inserisci un URL valido',
        UPLOAD_EXCEL: 'Carica Excel',
        SAVE: 'Salva',
        AVILABLE_FILE_SIZE: 'Dimensione massima del file',

        PRIMARY_COLOR: 'Colore primario',
        MAIL_NOTIFICATIONS: 'E-mail ricevente le notifiche del negozio',
        MAIL_SENDER: 'E-Mail mittente del negozio',
        FOOTER_TEXT: 'Testo footer',
        CART_NAME_MAX_LENGTH: 'Lunghezza massima del nome di un carrello',
        CART_NOTIFICATION_SETTINGS: 'Impostazioni notifiche carrello inattivi',
        CART_NOTIFICATION_THRESHOLD: 'Notifica cancellazione carrello entro giorni',
        CART_NOTIFICATION_DELETION_THRESHOLD: 'Cancella carrello inattivo in giorni',
        DEFAULT_DESIGNER: 'Designer di default',
        KUSTOM_EMAIL: 'E-mail Kustom',
        KUSTOM_PHONE: 'Telefono Kustom',
        KUSTOM_EMAIL_SECONDARY: 'E-mail Kustom secondaria',
        KUSTOM_SETTINGS: 'Impostazioni BasicKustom',
        KUSTOM_MIN_QUANTYTY_FOR_PRODUCT: 'Quantità di acquisto minima per prodotto personalizzato nelle richieste',
        ENABLE_KUSTOM: 'BasicKustom abilitato',
        DISABLE_KUSTOM: 'BasicKustom disabilitato',
        PLEASE_FILL_ALL_REQUIRED_FIELDS: 'Compila tutti i campi obbligatori',
      },
      AGENCIES: 'Agenzie',
      CUSTOMERS: 'Clienti',
      //USERS: 'Utenti',
      LOCATIONS: 'Indirizzi',
      TUTORIAL: {
        NAME: 'Tutorial',
        VIDEO: 'Video',
        DOCUMENTATION: 'Documentazione',
      },
      BY_DATE: 'Data di consegna',
      CUSTOM_DATE: 'Data personalizzata',
      STYLE_CODE: 'Style code',
    },
    IMPORT_PRODUCTS: {
      START_SEARCH: 'Inserisci il testo di ricerca per iniziare l\'importazione',
      DESELECT_ALL: 'Deseleziona tutto',
      RELOAD_PRODUCTS: 'Ricarica prodotti',
      SEARCH_BY: 'Ricerca tramite',
      ID: 'ID',
      NAME: 'Nome',
      SELLING_PERIOD: 'Periodo di vendita',
      PRODUCTS_QUANTITY: 'Quantità prodotti',
      LOAD_MORE_DATA: 'Carica altri dati',
      THERE_IS_NO_MORE_DATA: 'Non ci sono altri dati',
      STATUS: {
        IMPORTED: 'Importato',
        NOT_IMPORTED: 'Non importato',
        IMPORTING: 'Importazione..',
        FAILED: 'Fallito'
      },
      MODAL: {
        TITLE: 'Importa prodotti',
        YOU_HAVE_SELECTED: 'Hai selezionato',
        ITEMS: 'elementi',
        ATTENTTION_YOU_ARE_IMPORTING: 'Attenzione, stai importando',
        MESSAGE: 'stili già importati. Tutte le modifiche su di esso e le sue varianti andranno perse. Sei sicuro?',
        YOU_HAVE_TO_SELECT_AT_LAST_ONE_ITEM: 'Devi selezionare almeno un elemento',
        USE_CUSTOM_DISCOUNT: 'Imposta uno sconto personalizzato per calcolare il prezzo wholesale',
        USE_CUSTOM_DISCOUNT_INFO: 'Se imposti uno sconto personalizzato, questo verrà utilizzato per calcolare il prezzo wholesale di tutte le varianti dei prodotti in importazione, sia per il calcolo del prezzo PRE Order che RE Order. Non impostandolo invece, verrà utilizzata l\'ultima percentuale usata per i prodotti già importati in passato e lo sconto base del negozio corrente per i prodotti mai importati.'
      }
    },
    USERMENU: {
      SHOP: 'Negozio',
      MY_PROFILE: 'Profilo',
      LOGOUT: 'Esci',
      SWITCH_TENANT: 'Cambia paese',
      LOGOUT_CONFIRM: 'Sei sicuro di voler uscire?',
      CANCEL: 'Annulla',
    },
    BACK_TO: {
      SALES_CAMPAIGN: 'Torna alla campagna vendita',
      SALES_CAMPAIGNS: 'Torna alle campagne vendita',
    },
    GENERIC_LABEL: {
      FILTER: 'Filtra',
      SELECT: 'Seleziona',
      SELECT_ALL: 'Seleziona tutto',
      SELECT_SIZE: 'Seleziona taglia',
      APPROVE: 'Approva',
      COPY: 'Copia',
      SALE_CAMPAIGN: 'Campagne vendita',
      CHOOSE_FILE: 'Scegli un file',
      BACK: 'Indietro',
      SYNC_START: 'Sync avviato, attendi qualche minuto ed aggiorna la pagina',
      ADD_NEW: 'Aggiungi nuovo',
      ADD: 'Aggiungi',
      SAVE: 'Salva',
      SAVE_CHANGES: 'Salva modifiche',
      'SAVE AND_SYNC_LATER': 'Salva e sincronizza dopo',
      SAVE_AND_SYNC_NOW: 'Salva e sincronizza ora',
      DELETE: 'Elimina',
      CANCEL: 'Annulla',
      CLOSE: 'Chiudi',
      TRANSFORM_INTO_DRAFT: 'Riconverti in carrello',
      LEAVE_PAGE: 'Lascia la pagina',
      ACTIONS: 'Azioni',
      UPLOAD: 'Carica',
      IMPORT: 'Importa',
      DUPLICATE: 'Duplica',
      CONFIRM: 'Conferma',
      SEND_CONFIRMATION_MAIL: 'Rinvia mail di conferma',
      EDIT: 'Modifica',
      EDIT_ITEMS: 'Modifica articoli',
      EDIT_CART: 'Modifica carrello',
      ACTIVATE: 'Attiva',
      SEND: 'Invia',
      RESEND: 'Reinvia',
      DEACTIVATE: 'Disattiva',
      FORM_ERROR: 'Dati mancanti o errati',
      YES: 'Si',
      NO: 'No',
      PRINT: 'Stampa',
      PRINT_PREVIEW: 'Anteprima di stampa',
      ERROR: 'Errore!',
      ARE_YOU_SURE: 'Sei sicuro?',
      ARE_YOU_SURE_YOU_WANT_TO_PROCEED: 'Sei sicuro di voler procedere?',
      DONE: 'Fatto!',
      REMOVE: 'Rimuovi',
      BLOCKED: 'Bloccato',
      UNBLOCKED: 'Non bloccato',
      USER: 'Utente',
      ACTIVATED: 'Attivato',
      DEACTIVATED: 'Disattivato',
      MAN: 'Uomo',
      WOMAN: 'Donna',
      UNISEX: 'Unisex',
      UNPUBLISH: 'Spubblica',
      CREATE: 'Crea',
      LOSING_CHANGES_MESSAGE: 'Le modifiche non salvate verranno perse. Vuoi procedere?',
      SETTINGS: 'Impostazioni',
      DETAILS: 'Dettagli',
      START_SYNC: 'Avvia sync da ERP',
      THE_VALUE_MUST_BE_BETWEEN: 'Il valore deve essere compreso tra {{min}} e {{max}}',
      MAX_LENGTH: 'Lunghezza massima {{max}} caratteri, caratteri inseriti {{length}}',
      ATTENTION: 'Attenzione!',
      PREVIEW: 'Anteprima',
      DOWNLOAD: 'Scarica {{extension}}',
      APPLY: 'Applica',
      NEXT: 'Avanti',
      SELECT_CODE: 'Seleziona codice',
      DOWNLOAD_REPORT: 'Scarica report',
      EXPORT_ORDERS: 'Esporta ordini',
      ONLY_WITH_STOCK_PRODUCTS: 'Solo prodotti disponibili',
      PRODUCT_TYPE: 'Tipo prodotto',
      REPORTS_MODAL_MESSAGE: 'Imposta eventuali filtri e riceverai il report nella tua casella email.',
      STORE_VARIANTS_REPORT: 'Report varianti prodotto',
      CUSTOMER_REPORT: 'Report clienti',
      FROM_DATE: 'Dal',
      TO_DATE: 'Al',
      SALES_CAMPAIGN: 'Campagna vendita',
      SELECTED_ORDERS: 'Ordini selezionati',
      NO_ORDERS_SELECTED: 'Nessun ordine selezionato',
      SELECTED: 'Selezionati',
      EDIT_SELECTED_ORDERS: 'Modifica ordini',
      DELETE_ORDERS: 'Elimina ordini',
      CANCEL_ORDERS: 'Cancella ordini',
      DELETE_ORDERS_BY_EXCEL: 'Elimina ordini da Excel',
      SUCCESS_DELETE_ORDERS: 'Ordini eliminati con successo',
      UPLOAD_ORDERS_TEMPLATE: 'Carica gli articoli nei tuoi ordini utilizzando il template',
      DOWNLOAD_TEMPLATE: 'Scarica template',
      ERROR_NEGATIVE_NUMBERS: 'Non è possibile inserire numeri negativi o decimali',
      INVALID_QUANTITY: 'Quantità non valida',
      NAME: 'Nome',
      CART_QTY: 'articoli nel carrello',
      BULK_SELECTION: 'Selezione Bulk',
      WORKING_MODE: "Seleziona la modalità di lavoro",
      SELECT_FILTERS: "Seleziona per filtri",
      SELECT_FREE_TEXT: "Seleziona tramite external ID",
      ENTER_ORDER_IDS: "Inserisci gli external ID",
      ENTER_ORDER_IDS_PLACEHOLDER: "Digita o incolla uno o più external ID degli ordini, separati da punto e virgola",
      OTHERS: "Altri",
      DRAG_DROP_REORDER_COLUMNS: 'In questa tabella è possibile riordinare le colonne tramite drag & drop',
      VIEW_PENDING_BULK: 'Visualizza bulk in attesa',
      GO_BACK: 'Torna indietro',
      CART_SUMMARY: 'Riepilogo carrello',
    },
    MANAGE_GENERAL_FIELDS: {
      FIELDS_TYPE: 'Tipo di campi',
      VALUE_SET: 'Valore impostato',
      TABLE:{
        VALUE: 'Valore',
        DECIMAL_VALUE: 'Valore decimale',
        CREATION_TIME: 'Data di creazione',
        LAST_UPDATE: 'Ultimo aggiornamento',
        DELETE_GF: 'Eliminare campo generale',
        ARE_YOU_SURE: 'Sei sicuro di voler eliminare questo campo generale?',
        EDIT_GF: 'Modifica campo generale',
        CREATE_GF: 'Crea nuovo campo generale',
        CODE: 'Codice',
        DESCRIPTION: 'Descrizione',
        ID: 'ID',
        EXTERNAL_ID: 'External ID',
        NAME: 'Nome',
        ORDER: 'Ordine',
        COST: 'Costo',
        IS_PUBLIC: 'Pubblico',
      },
    },
    TABLE: {
      ACTION: {
        NAME: 'Azioni',
        EDIT: 'Modifica',
        DELETE: 'Elimina',
        CREATE_NEW: 'Crea nuovo',
        EXPORT: 'Esporta',
        IMPORT: 'Importa',
        INVITE_USER: 'Invita utente',
        DUPLICATE: 'Duplica',
        VIEW_DETAILS: 'Visualizza dettagli',
        ACTIVATE: 'Attiva',
        DEACTIVATE: 'Disattiva',
        REFRESH: 'Aggiorna',
        ARCHIVE: 'Archivia',
        UPLOAD: 'Carica',
        DOWNLOAD: 'Scarica file',
        DOWNLOAD_LIST: 'Scarica lista',
        CREATE_CART_FROM_EXCEL: 'Crea carrelli da Excel',
        MANAGE_ASSORTMENT: 'Gestisci Assortimenti',
      },
      FILTERS: {
        WITH_CUSTOMIZATION_REQUESTS: 'Con richiesta di personalizzazione',
        BY_CUSTOMIZATION_REQUESTS: 'Per richiesta di personalizzazione',
        FILTERS: 'Filtri',
        CREATOR: 'Creatore',
        REQUESTER: 'Richiedente',
        CUSTOMER_REQUESTER: 'Richiedente Cliente',
        AGENCY_REQUESTER: 'Richiedente Agenzia',
        DESIGNER: 'Designer',
        APPROVED_BY: 'Approvato da',
        APPLY_FILTER: 'Applica filtro',
        ACTIVE_FILTERS: 'Filtri attivi',
        SEARCH: 'Cerca',
        VISIBILITY_TYPE: 'Tipo',
        TYPE: 'Tipo',
        VALIDITY: 'Validità',
        REORDER: 'Re-order',
        PREORDER: 'Pre-order',
        PRE_ORDER: 'Pre-order',
        RE_ORDER: 'Re-order',
        WHOLESALE_PRICE: 'Prezzo wholesale',
        NEW_WHOLESALE_PRICE: 'Nuovo prezzo wholesale',
        FROM: 'Da',
        TO: 'A',
        RETAIL_PRICE: 'Prezzo retail',
        STOCK: 'Magazzino',
        ASSORTMENT: 'Assortimento',
        STYLE_GROUP: 'Style group',
        CITY: 'Città',
        TIER: 'Livello',
        STORE: 'Negozio',
        CUSTOMER: 'Cliente',
        CUSTOMER_TYPE: 'Tipo di cliente',
        AGENCY: 'Agenzia',
        ONLINE_STORES: 'Negozi online',
        WITHOUT_STORE: 'Senza negozio',
        POINT_OF_SALE: 'Punto vendita',
        POS: 'Punto vendita',
        ORDER_STATUS: 'Stato dell\'ordine',
        STATUS: 'Stato',
        PROJECT_TYPE: 'Tipo di progetto',
        LOCATION_TYPE: 'Tipo di indirizzo',
        REGISTERED_DATE: 'Data di registrazione',
        ROLE: 'Ruolo',
        ONLY_INCLUDED: 'Solo inclusi',
        COLORS: 'Colori',
        SIZE: 'Taglia',
        SIZE_GROUP: 'Gruppo taglia',
        NOTES: 'Note',
        HAS_NOTES: 'Con note',
        EXTERNAL_COLLECTIONS: 'Collezioni esterne',
        EXTERNAL_ORDER_ID: 'ID ordine esterno',
        CHANNEL: 'Canale',
        PRODUCTS: 'Prodotti',
        OPERATION_TYPE: 'Tipo di operazione',
        CUSTOMER_AMMINISTRATIVE_STATUS: 'Stato blocco amministrativo',
        SHOW_ONLY_BLOCKED: 'Mostra solo clienti bloccati',
        SHOW_ONLY_WITH_CR: 'Mostra ordini con richieste di personalizzazione associate',
        CHANNEL_ID: 'Id canale',
        CREATED_AFTER: 'Creato dopo il',
        CREATED_BEFORE: 'Creato prima del',
        SELECT_ORDERS: 'Seleziona ordini',
        MANAGEMENT_ORDERS: 'Gestisci ordini',
        GO_BACK_TO_ORDERS: 'Torna agli ordini',
        COMERCIAL_BLOCK: 'Blocco commerciale',
        ORDER: 'Ordine',
        ORDER_BULK_OPERATION_SCOPE: 'Scope operazioni',
        COMPLETED_AT: 'Completato il',
        SHOW_CR_WITH_DESIGNER_NOTIFICATION: 'Mostra solo richieste di personalizzazione con notifica richiedente',
      },

      CUSTOMIZATION_REQUEST: {
        TITLE: 'Richieste di personalizzazione',
        COLUMN: {
          NAME: 'Nome',
          STATUS: 'Stato',
          CUSTOMER: 'Cliente',
          CHANNEL: 'Canale',
          POINT_OF_SALE: 'Punto vendita',
          TOTAL_WHOLESALE: 'Tot. wholesale',
          PRODUCT_NUMBER: 'N° prodotti',
          LAST_UPDATE: 'Ultimo aggiornamento',
          WITH_REQUESTER_NOTIFICATION: 'Con notifica richiedente',
          LAST_UPDATE_REQUESTER: 'Ultimo modifica richiedente',
          LAST_DESIGNER_NOTIFICATION: 'Notifica al richiedente inviata il',
          PROJECT: 'Progetto',
          NOTIFICATIONS: 'Notifiche'
        },
      },

      PRICE_LIST: {
        DEFAULT_PRICE_LIST: 'Listino predefinito',
        CUSTOM_PRICE_LIST: 'Listini personalizzati',
        CREATE_PRICE_LIST: 'Crea listino prezzi',
        NAME: 'Nome',
        PARENT_PRICE_LIST: 'Listino padre',
        TYPE: 'Tipo',
        STORE: 'Negozio',
        ASSOCIATED_CUSTOMERS: 'Selezionare se si vuole procedere con l\'associazione dei clienti a questo listino prezzi',
      },

      PRICE_LIST_DETAIL: {
        COLUMNS: {
          SKU: 'SKU',
          PALETTE: 'Palette',
          TYPE: 'Tipo',
          PRE_ORDER: 'Pre-order',
          RE_ORDER: 'Re-order',
          CURRENCY: 'Valuta',
          DEFAULTRETAILPRICE: 'Prezzo retail predefinito',
          DEFAULTWHOLESALEPRICE: 'Prezzo wholesale predefinito',
          CUSTOMRETAILPRICE: 'Prezzo retail personalizzato',
          CUSTOMWHOLESALEPRICE: 'Prezzo wholesale personalizzato',
        },
      },

      SUPER_BULK: {
        COLUMN: {
          ID: 'Id',
          USER: 'Utente',
          OPERATION_TYPE: 'Tipo di operazione',
          CREATION_TIME: 'Data di creazione',
          START_AT: 'Inizio il',
          CONCLUDED_AT: 'Concluso il',
          STATUS: 'Stato',
        },
        OPERATION_TYPE: {
          UPDATING_VISIBILITY_PRE: 'Aggiornamento visibilità pre-order',
          UPDATING_VISIBILITY_RE: 'Aggiornamento visibilità re-order',
          UPDATING_PRICE: 'Aggiornamento prezzo',
          UPDATING_BLANK_CELL: 'Aggiornamento celle bianche',
          ASSOCIATING_TIER: 'Associazione tier',
          DISASSOCIATING_TIER: 'Disassociazione tier',
          ASSOCIATING_ASSORTMENT: 'Associazione assortment',
          DISASSOCIATING_ASSORTMENT: 'Disassociazione assortment',
          ASSOCIATING_PROMOTION: 'Associazione promozione',
          DISASSOCIATING_PROMOTION: 'Disassociazione promozione',
          UPDATE_PALETTES_STOCK_LIMITS: 'Aggiorna limiti di acquisto per colore (per i canali che lo supportano)'
        }
      },

      BULK_OPERATIONS: {
        NAME: 'Operazioni',
        COLUMNS: {
          ID: 'Id',
          TYPE: 'Tipo',
          CREATOR: 'Creatore',
          CREATED_AT: 'Data di creazione',
          SCOPE: 'Scope',
          STATUS: 'Stato',
          ISSUE: 'Issue',
          ORDER_ITEM_ID: 'ID articolo ordine',
          ORDER_ID: 'ID ordine',
          ORDER_NUMBER: 'Numero ordine',
          CUSTOMER_NAME: 'Nome cliente',
          CUSTOMER_ACCOUNT: 'Account cliente',
          STARTED_AT: 'Iniziato il',
          CONCLUDED_AT: 'Concluso il',
          PROCESSED_ORDER_ITEMS_COUNT: 'Articoli processati',
          PROCESSED_WITH_ISSUES_COUNT: 'Articoli con issue',
          HAS_PENDING: 'Sync pend.'
        },
        GO_TO_ORDER: 'Vai al dettaglio ordine',
      },

      BULK_EDIT_ORDERS_MODAL: {
        INFO_MESSAGE: 'Utilizzando le checkbox puoi modificare più elementi contemporaneamente. Attenzione: al salvataggio verranno salvati tutti gli elementi presenti in questa finestra, indipendentemente dalla selezione effettuata.',
        ADD_NEW_ITEMS: 'Aggiungi nuovi articoli',
        REPLACE_ITEMS: 'Sostituisci articoli',
        REMOVE_ITEMS: 'Rimuovi articoli',
        CURRENT_DATE: 'Data attuale',
        NEW_DATE: 'Nuova data',
        CHANGE_ITEMS_DELIVERY_DATE: 'Cambia data consegna articoli',
        SUCCESS_CHANGE_ITEMS_DELIVERY_DATE: 'Data consegna articoli aggiornata con successo',
        ADD_DELIVERIES: 'Aggiungi consegne',
        ADD_DELIVERIES_DUPLICATE_DATE: 'L’articolo ha già una consegna in questa data',
        SUCCESS_ADD_ITEMS: 'Articoli aggiunti con successo',
        SUCCESS_CHANGE_ITEMS_WHOLESALE_PRICE: 'Prezzi aggiornati con successo',
        INVALID_PRICE: 'Prezzo inserito non valido',
        CHANGE_CUSTOMER_AND_SHIPPING_ADDRESS: 'Cambia cliente e indirizzo di spedizione',
        EDIT_QUANTITY: 'Modifica quantità',
        WHOLESALE_PRICE: 'Prezzo all’ingrosso',
        DISCOUNT: 'Sconto',
        EDIT_NET_PRICE: 'Modifica prezzo netto',
        EDIT_RETAIL_PRICE: 'Modifica prezzo retail',
        CURRENT_UNIT_PRICE: 'Prezzo unitario attuale',
        NEW_UNIT_PRICE: 'Nuovo prezzo unitario',
        NEW_RETAIL_PRICE: 'Nuovo prezzo retail',
        CURRENT_RETAIL_PRICE: 'Prezzo retail attuale',
        RETAIL_PRICE: 'Prezzo retail',
        SUCCESS_REPLACE_ITEMS: 'Articoli sostituiti con successo',
        SUCCESS_CHANGE_ITEMS_QUANTITY: 'Quantità articoli aggiornate con successo',
        SUCCESS_DELETE_ITEMS: 'Articoli eliminati con successo',
        SUCCESS_OPERATION: 'Operazione accodata con successo',
      },

      COMMERCIAL_AGREEMENT: {
        NAME: 'Accordi commerciali',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nome',
          VALID_FROM: 'Valido dal',
          VALID_UNTIL: 'Valido fino al',
          DISCOUNT_PERCENTAGE: '% sconto',
          TOTAL_RETAIL_AMOUNT: 'Tot. retail (€)',
          RESIDUAL_RETAIL_AMOUNT: 'Tot. residuo (€)',
          CUSTOMER_NAME: 'Nome cliente',
          STATUS: 'Stato',
          CONSUMPTION: 'Consumo',
        },
        MODAL_DELETE: {
          TITLE: 'Elimina accordo commerciale',
          MESSAGE: 'Sei sicuro di voler eliminare l\'accordo commerciale?',
          ATTENTION_COMMERCIAL_AGREEMENT_IS_LINKED_ON_VARIOUS_CART: '<strong>Attenzione!</strong> Ci sono {{draftOrdersCount}} carrelli collegati a questo accordo commerciale. Con l\'eliminazione di questo accordo, anche le associazioni verranno rimosse.',
        },
      },

      TERM_OF_SALE: {
        NAME: 'Termini di vendita',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nome',
          STATUS: 'Stato',
          CREATION_TIME: 'Data di creazione',
          LAST_UPDATE_TIME: 'Ultimo aggiornamento',
        },
      },

      FULFILLMENT: {
        GROUP_ELEMENT: {
          SHIPPING_PACKAGE: 'Collo',
          TOTAL_QUANTITY: 'Quantità totale',
          TOTAL_WEIGHT: 'Peso totale',
        },
        COLUMNS: {
          STYLE: 'Stile',
          COLOR: 'Colore',
          SIZE: 'Taglia',
          QUANTITY: 'Qty',
          AMOUNT: 'Importo',
          EAN: 'EAN',
          ORDER_ID: 'ID ordine',
        },
      },

      PROMOTION: {
        NAME: 'Promozioni',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nome',
          VALID_FROM: 'Valido dal',
          VALID_TO: 'Valido fino al',
          TYPE: 'Tipo',
          VALID_ON: 'Valido su',
        },
        MODAL_DELETE_PROMOTION: {
          ARE_YOU_SURE: 'Sei sicuro?',
          ARE_YOU_SURE_DELETE_PROMOTION: 'Sei sicuro di voler eliminare la promozione?',
        },
        INFO_ALLERT: 'Gli sconti automatici che vengono impostati non saranno abilitati sui canali'
      },
      VOUCHERS: {
        NAME: 'Vouchers',
        COLUMNS: {
          ID: 'Id',
          CODE: 'Codice',
          DESCRIPTION: 'Descrizione',
          CONSTRAINT_TYPE: 'Vincolo',
          AMOUNT: 'Valore',
          THRESHOLD: 'Soglia',
          VALID_FROM: 'Valido dal',
          VALID_TO: 'Valido fino al',
          RESIDUAL_AMOUNT: 'Credito rimanente',
          STATUS: 'Status'
        },
        MODAL_DELETE_VOUCHER: {
          ARE_YOU_SURE: 'Sei sicuro?',
          ARE_YOU_SURE_DELETE_VOUCHER: 'Sei sicuro di voler eliminare il voucher?',
          ARE_YOU_SURE_DELETE_CUSTOMER: 'Sei sicuro di disassociare il voucher dal cliente?',
        },
        INFO_ALLERT: 'I voucher che vengono impostati non saranno abilitati sui canali',
      },

      PRIVILEGES_CASH: {
        COLUMNS: {
          EXTERNAL_ID: 'ID',
          NAME: 'Nome',
          INITIAL_AMOUNT_WITH_VAT: 'Importo iniziale con IVA',
          RESIDUAL_AMOUNT_WITH_VAT: 'Credito rimanente con IVA',
          RESIDUAL_AMOUNT_WITHOUT_VAT: 'Credito rimanente senza IVA',
          VALID_FROM: 'Valido dal',
          VALID_TO: 'Valido fino al',
          STATUS: 'Stato',
        },
        STATUS: {
          IMPORTABLE: 'Importabile',
          ALREADY_IMPORTED: 'Già importato',
        },
      },

      DISCOUNT: {
        NAME: 'Sconti',
      },

      CART: {
        NAME: 'Carrello',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nome',
          VARIANTS: 'Varianti',
          POS: 'Punto vendita',
          TOTAL: 'Totale',
          TOTAL_RETAIL: 'Totale retail',
          DATE: 'Data',
          TYPE: 'Tipo',
          AGENCY_CODE: 'Agenzia',
          CHANNEL_NAME: 'Canale',
          PCS: 'Pcs',
          SEASON_REFERENCE: 'Season reference',
          PACKAGE_GROUP: 'Package group',
          NOTE: 'Note',
          EXTERNAL_ID: 'External ID',
        },
        ASTERISK_MESSAGE: 'Totali calcolati su prezzi retail perchè appartenenti ai canali',
        MISSING_EXCEL_FILE_MESSAGE: 'Per continuare è necessario caricare un file Excel',
        MISSING_EXCE_CODE_MESSAGE: 'Seleziona un tipo di codice per poter scaricare il template',
        UPLOAD_DONE: 'Operazione avviata con successo! Riceverai una mail con il risultato dell\'operazione.',
        MODAL_IMPORT: {
          IMPORT_CART_FROM_FILE_XLSX: 'Importa carrello da file XLSX',
          CART_REPORT_UPLOADED: 'Report del carrello caricato',
          CUSTOMER: 'Cliente',
          POINT_OF_SALE: 'Punto vendita',
          CART_NAME: 'Nome del carrello',
          TYPE: 'Tipo',
          ALTERNATIVE_SHIPPING_ADDRESS: 'Indirizzo di spedizione alternativo',
          PRODUCT: 'Prodotto',
          AGENCY: 'Agenzia'
        },
        MODAL_DUPLICATE_CART: {
          DUPLICATE_CART: 'Duplica carrello',
          DUPLICATE: 'Duplica',
        },
        MODAL_DELETE_CART: {
          ARE_YOU_SURE: 'Sei sicuro?',
          ARE_YOU_SURE_DELETE_CART: 'Sei sicuro di voler eliminare il carrello?',
        }
      },

      ADMIN_DOWNLOADS: {
        NAME: 'Download amministrativi',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nome',
          EXTENTION: 'Tipo',
          UPLOAD_DATE: 'Data upload',
          CREATOR: 'Creatore',
        },
        ACTION: {
          DOWNLOAD: 'Download',
          DELETE: 'Elimina',
          UPLOAD_FILE: 'Carica file',
        },
        MODAL_DELETE_FILE: {
          ARE_YOU_SURE: 'Sei sicuro?',
          ARE_YOU_SURE_DELETE_FILE: 'Sei sicuro di voler eliminare il file?',
        },
      },

      ORDER: {
        NAME: 'Ordini',
        COLUMNS: {
          STATUS: 'Stato',
          PENDING_BULK: 'Operazioni',
          OPERATIONS: 'Operazioni',
          POINTS_OF_SALES: 'Punti vendita',
          AGENCY_CODE: 'Codice agenzia',
          CUSTOMER: 'Cliente',
          GOK: 'GOK',
          REASSORTMENT: 'Riassortimento',
          PRODUCT_EXCHANGE: 'Cambio merce'
        }
      },

      ASSORTMENTS: {
        NAME: 'Assortimenti',
        COLUMNS: {
          ID: 'Id',
          TITLE: 'Titolo',
          CHANNEL_NAME: 'Canale',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
        }
      },

      VARIANT_BULK_EDITOR: {
        NAME: 'Editor varianti',
        INCLUDE_BY: 'Seleziona per: ',
        INCLUDE_BY_ASSORTMENT: 'Assortimento',
        INCLUDE_BY_COLLECTION: 'Collezione',
        INCLUDE_BY_TIER: 'Tier',
        SELECTED: 'Selezionato',
        EDIT_SELECTED: 'Modifica selezionati',
        DESELECT_ALL: 'Deseleziona tutto',
        YOU_HAVE_JUST_SELECTED: 'Hai appena selezionato',
        NEW_VARIANTS_FROM_ASSORTMENT: 'nuove varianti da assortimento',
        NEW_VARIANTS_FROM_COLLECTION: 'nuove varianti da collezione',
        NEW_VARIANTS_FROM_TIER: 'nuove varianti da tier',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_ASSORTMENT: 'Puoi selezionare tutte le varianti di un dato assortimento',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_COLLECTION: 'Puoi selezionare tutte le varianti di una data collezione',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_TIER: 'Puoi selezionare tutte le varianti di un dato tier',
        NO_ASSORTMENT_TO_VIEW: 'Nessun assortimento da visualizzare',
        NO_COLLECTION_TO_VIEW: 'Nessuna collezione da visualizzare',
        NO_SELECTED_VARIANTS: 'Nessuna variante selezionata',
        ORDERS_FROM_LIST: 'Ordini dalla lista',
        CONFIRM_LEAVE_PAGE: {
          ARE_YOUR_SURE: 'Sei sicuro?',
          IF_YUO_LEAVE_PAGE_YOU_WILL_LOSE_ALL_CHANGES: 'Se uscirai dalla pagina perderai tutte le modifiche',
        },
        UNPUBLISH_ALL_FOR_PRE_ORDER: 'Spubblica tutte le varianti pre-order',
        ARE_YOU_SURE: 'Sei sicuro?',
        ARE_YOU_SURE_UNPUBLISH_ALL_VARIANTS_FROM_PRE_ORDER: 'Sei sicuro di voler spubblicare tutte le varianti da pre-order?',
        UNPUBLISH_ALL_FOR_PRE_ORDER_WARNING: 'Questa azione verrà applicata a tutti i prodotti',
        MESSAGE_SUCCESS_UNPUBLISH: 'Tutte le varianti da pre-order sono state spubblicate',
        MESSAGE_SUCCESS_SEND_EMAIL: 'Il report delle varianti pre-order è stato inviato con successo',
        DOWNLOAD_REPORT_VARIANTS_ON_PRE_ORDER: 'Scarica report varianti pre-order',
        DOWNLOAD_REPORT_VARIANTS_ON_RE_ORDER: 'Scarica report varianti re-order',
        DOWNLOAD_REPORT_VARIANTS: 'Scarica report varianti',
        DOWNLOAD_REPORTS: 'Download report',
        PUBLISHED_VARIANTS: 'Per pubblicazione e canale di vendita',
        REPORT_OF_VARIANTS: 'Report varianti',
        DOWNLOAD_REPORT_OF_VARIANTS: 'Scarica report varianti',
        ARE_YOU_SURE_DELETE_ORDERS: 'Sei sicuro di voler eliminare questo ordine?',
      },

      TIERS: {
        NAME: 'Tiers',
        CREATE_MODAL: {
          ADD_NEW_TIER: 'Aggiungi nuovo livello',
          EDIT_TIER: 'Modifica livello',
          NAME: 'Nome',
          DESCRIPTION: 'Descrizione',
        },
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nome',
          DESCRIPTION: 'Descrizione',
          CREATED_ON: 'Creato il',
          CREATED_BY: 'Creato da',
        },
        DELETE_MODAL: {
          TITLE: 'Sei sicuro?',
          DESCRIPTION: 'Sei sicuro di voler eliminare questo livello?',
        },
        ARCHIVE_MODAL_DESCRIPTION: 'Sei sicuro di voler archiviare questo tier? L\'operazione non è reversibile.'
      },

      SEASON_REFERENCE: {
        NAME: 'Season Reference',
        CREATE_EDIT: {
          NAME: 'Nome',
          DATE_FROM: 'Valido Dal',
          DATE_TO: 'Fino Al',
        },
        TABLE: {
          ID: 'Id Esterno',
          NAME: 'Nome',
          DATE_FROM: 'Valido Dal',
          DATE_TO: 'Fino Al',
        },
        CREATE_OR_EDIT: {
          CREATE_NEW: 'Crea Nuovo',
          EDIT: 'Modifica',
          CANCEL: 'Annulla',
          SAVE: 'Salva',
        },
        DELETE_MODAL: {
          DELETE_SR: 'Eliminare season reference',
          SURE: 'Vuoi eliminare questa season reference?',
          DELETE: 'Elimina'
        }
      },

      SHOWCASES: {
        NAME: 'Showcases',
        CREATE_EDIT: {
          NAME: 'Nome',
          DATE_FROM: 'Valido Dal',
          DATE_TO: 'Fino Al',
        },
        TABLE: {
          NAME: 'Nome',
          STATUS: 'Stato',
          ACTIVE: 'Attivo',
          INACTIVE: 'Non Attivo'
        },
        CREATE_OR_EDIT: {
          CREATE_NEW: 'Crea Nuovo',
          EDIT: 'Modifica',
          CANCEL: 'Annulla',
          SAVE: 'Salva',
        },
        AUTOMATIC_DISCOUNTS: {
          TITLE: 'Aggiungi sconto automatico',
          ARE_YOU_SURE: 'Sei sicuro/a di voler rimuovere lo showcase dallo Sconto Automatico?',
          ALREADY_ADDED_TITLE: 'Già aggiunto',
          ALREADY_ADDED: 'Showcase è già associato a questo Sconto automatico.'
        },
        ASSORTMENTS: {
          TITLE: 'Aggiungi Assortimento',
          ARE_YOU_SURE: 'Sei sicuro/a di voler rimuovere lo showcase dall\'assortimento?',
          ALREADY_ADDED: 'Questo Showcase è già associato a questo Assortimento.'
        },
        DESCRIPTION: {
          NAME: 'Seleziona lo Showcase per il quale è disponibile l\'assortimento:'
        },
        DELETE_MODAL: {
          DELETE_SR: 'Eliminare Show Case',
          SURE: 'Vuoi eliminare questo ShowCase?',
          DELETE: 'Elimina'
        }
      },

      AGENCIES: {
        NAME: 'Agenzie',
        CHANGE_AGENCY_ASSOCIATION: 'Cambia associazione agenzia/punti vendita',
        FROM_AGENCY: 'Dall\'agenzia',
        TO_AGENCY: 'All\'agenzia',
        MODAL_INFO: 'Qui puoi spostare massivamente il legame di tutti i punti vendita (e carrelli relativi) con un\'agenzia ad un\'altra',
        COLUMNS: {
          VAT: 'P.IVA',
          AGENCY_CODE: 'Codice',
          NAME: 'Nome',
          CITY: 'Città',
          ORDERS_YTD: 'Ordini (YTD)',
          TOTAL_YTD: 'Totale (YTD)',
          STATUS: 'Stato',
        },
        MODAL_DELETE_AGENCY: {
          ARE_YOU_SURE: 'Sei sicuro?',
          ARE_YOU_SURE_DELETE_AGENCY: 'Sei sicuro di voler eliminare questa agenzia?',
        },
        POS_UPDATE: 'Punti vendita aggiornati: ',
        CARTS_UPDATE: 'Carrelli aggiornati: '
      },

      CUSTOMERS: {
        NAME: 'Clienti',
        COLUMNS: {
          VAT: 'P.IVA',
          VAT_NUMBER: 'Partita IVA',
          EXTERNAL_ID: 'ID Esterno',
          ALTERNATIVE_VAT: 'P. IVA Alternativa',
          ALTERNATIVE_GLN: 'GLN Alternativa',
          NAME: 'Nome',
          CITY: 'Città',
          POS: 'Punto vendita',
          POS_PLURAL: 'Punti vendita',
          ORDERS_YTD: 'Ordini (YTD)',
          TOTAL_YTD: 'Totale (YTD)',
          STATUS: 'Stato',
          RELOAD_PAGE: 'Ricarica pagina',
        },
        INFO_SECTION: {
          INFO: 'Info Cliente',
          COMMERCIAL_INFO: 'Info Commerciali',
          FINANCIAL_INFO: 'Info Finanziarie',
          CUSTOMER_CLASSIFICATION: 'Classificazione cliente',
          TAX_COMPLIANCE: 'Tax & Compliance',
          PREFIX_VAT: 'Prefisso VAT',
          VAT_WITHOUT_PREFIX: 'VAT senza prefisso',
          DEFAULT_TRANSACTION_SPECIFICATION: 'Specifica transazione predefinita',
          TRANSACTION_TYPE: 'Tipo di transazione',
          IBAN: 'IBAN',
          SWIFT_CODE: 'Codice SWIFT',
          BANK_NAME: 'Nome della banca',
          BANK_ACCOUNT_NUMBER: 'Numero conto corrente bancario',
          BANK_ACCOUNT_ID: 'ID conto corrente bancario',
          ROUTING_NUMBER: 'Routing number',
          ROUTING_TYPE: 'Routing type',
          FISCAL_CODE: 'Codice Fiscale',
          ALTERNATIVE_ADDRESS: 'Indirizzo alternativo',
          ABI: 'ABI',
          CAB: 'CAB',
          BANKING_DETAILS: 'Dettagli bancari',
          SAVE_ERP: 'Salva ed Invia a ERP',
          BUSINESS_INFO: 'Business Info',
          ACCOUNT_NUMBER: 'Numero Account',
          GENERATE: 'Genera auto',
          ACCOUNT_NUMBER_USED: 'Account number inserito già in uso!',
          VAT_ALREADY_USED: 'VAT inserito già in uso!',
          EMAIL_ALREADY_USED: 'Email già in uso!',
          CUSTOMERS_GROUP: 'Gruppo di clienti',
          SALES_TAX_GROUP:'Gruppo di imposte sulle vendite',
          COMPANY_NAME: 'Nome Azienda',
          PAYMENT_METHOD_CODE: 'Codice metodo di pagamento',
          LOGISTICS_TRANSACTIONS: 'Logistica & transazioni',
          PACKAGE_GROUPING_MODE: 'Modalità raggruppamento pacchi',
          DELIVERY_TERMS: 'Termini di consegna',
          CURRENCY_CODE: 'Codice valuta',
          SUBJECTED_FACTORING: 'Factor',
          CREDIT_LIMIT: 'Credit limit',
          PAYMENT_TERMS_CODE: 'Codice termine di pagamento',
          ADMINISTRATIVEEMAIL_MISSING: 'Dettaglio contatti: Email amministrativa mancante',
          PHONE_MISSING: 'Dettaglio contatti: Telefono mancante',
          MOBILE_MISSING: 'Dettaglio contatti: Cellulare mancante',
          FAX_MISSING: 'Dettaglio contatti: Fax mancante',
          EMAIL_MISSING: 'Dettaglio contatti: Email mancante',
          COMMERCIALEMAIL_MISSING: 'Dettaglio contatti: Email commerciale mancante',
          PEC_MISING: 'Dettaglio contatti: PEC mancante',
          WEBSITE_MISSING: 'Dettaglio contatti: Sito web mancante',
          FACEBOOK_MISSING: 'Dettaglio contatti: Facebook mancante',
          INSTAGRAM_MISSING: 'Dettaglio contatti: Instagram mancante',
          TWITTER_MISSING: 'Dettaglio contatti: Twitter mancante',
          LINKEDIN_MISSING: 'Dettaglio contatti: LinkedIn mancante',
          MISSING_POS_NAME: 'Nome mancante in almeno un punto vendita',
          MISSING_USER: 'Creare un utente o inserirne uno esistente',
          MISSING_CONTACTS_POS: 'Dati mancanti nei contatti del punto vendita',
          MISSING_CONTACTS_POS_FRANCE: 'Inserire almeno una mail di tipo amministrativo',
          MISSING_LOCATION_POS: 'Dati mancanti in indirizzo del punto vendita',
          MISSING_CHANNELS_IN_DROPDOWN: 'Per ogni punto vendita, attivare almeno uno store ed inserire almeno un canale di vendita per ogni store attivo',
          MISSING_ONLINESTORES_POS: 'Dati mancanti in Online store del punto vendita',
          PAYMENT: 'Pagamento',
          SDI_CODE: 'Codice SDI',
          OFFICE_PA_CODE: 'Codice ufficio PA',
          PEC_EMAIL: 'Email PEC',
          CENTRAL_OF_PAYMENT: 'Account del centro di pagamento',
          CENTRAL_OF_PAYMENT_NUMBER: 'Numero di centro di pagamento',
          INVOICING_ACCOUNT_NUMBER: 'Account di fatturazione',
          COMPANY_FORM: 'Modulo Aziendale',
          KNOWN_AS: 'Conosciuto Come',
          GROUP_REPS: 'Gruppo di Rappresentanti',
          SWITCH_1: 'Questo cliente può essere assegnato come "Account di fatturazione" per altri clienti',
          SWITCH_2: 'Questo cliente può essere assegnato come come "Account di centro di pagamento" per altri clienti',
          BILLING_LOCATION: 'Indirizzo di Fatturazione',
          ADDRESS: 'Indirizzo',
          PROVINCE: 'Provincia',
          POSTAL_CODE: 'Codice Postale',
          EXTERNAL_LOCATION_ID: 'External Location ID',
          CITY: 'Città',
          COUNTRY: 'Paese',
          COMPANY_IDENTIFICATION: 'Identificazione Azienda',
          SIREN_NUMBER: 'Numero Siren',
          SIRET_NUMBER: 'Numero Siret',
          GLN_NUMBER: 'Numero Cliente GLN',
          TOOLTIP_DETAIL_CONTACTS: 'Inserire almeno un contatto per ogni tipo elencato sotto',
          TOOLTIP_TAX_COMPLIANCE: 'Inserire un VAT valido e univoco',
          TOOLTIP_COMPANY_OWNER: 'E\' necessario creare/selezionare un utente',
          CONTACTS_DETAIL: 'Dettaglio Contatti',
          ADMINISTRATIVE: 'Amministrativo',
          TYPE: 'Tipo',
          VALUE: 'Valore',
          ANALYTICS: 'Analisi',
          CLASSIFICATION_GROUP: 'Gruppo di Classificazione Cliente',
          GROUP_CODE: 'Codice Gruppo Cliente',
          SUB_CODE: 'Codice Sottogruppo Cliente',
          SINGBOARD: 'Cartello Cliente',
          HOLDING: 'Tenuta Cliente',
          NOT_POSSIBLE_SAVE: 'Impossibile salvare',
          SAVE_CHANGES: 'Vuoi salvare le modifiche?',
          MISSING_FIELDS: 'I seguenti campi non risultano compilati:',
          COMPLETE_USER: 'E\' necessario compilare anche un Utente',
          MISSING_FIELDS_EMPTY:'E\' possibile inviare ad ERP, tutti i campi obbligatori sono stati compilati ✅',
          ALREADY_SENT: '✅ Cliente già inviato, non ci sono modifiche',
          SELECT_COUNTRY: 'Seleziona un paese',
          ADD_LOCATION_BEFORE_CONTACTS: "Compila e salva la sezione <strong>\"Indirizzo di Fatturazione\"</strong> prima di inserire i contatti"
        },
        SUMMARY: {
          ORDER_INSIGHTS: 'Insights acquisti',
          CARTS_ORDERS_PLACED: 'Ordini & Carrelli'
        },
        GOK: {
          NEW_GOK: 'Nuovo Gok',
          EDIT_GOK: 'Modifica Gok',
          NAME: 'Nome',
          TOTAL_AMOUNT: 'Importo totale',
          DISACTIVE: 'Inattivo',
          EMAIL: 'Email contatto Gok',
          MODIFY_EMAIL: 'Modifica Email',
          VALID_FROM: 'Valido dal',
          VALID_TO: 'Valido fino al',
          RESIDUAL: 'Residuo',
          ORIGINAL_AMOUNT: 'Importo Originale',
          STATUS: 'Stato',
          TITLE_MODAL: 'Eliminare Gok',
          MESSAGE: 'Sei sicuro di voler eliminare questo Gok?',
          CANT_ELIMINATE: 'Non è possibile eliminare/modificare questo Gok in quanto sia già stato usato',
          IMPOSSIBLE: 'Date non disponibili',
          DATE_RANGE: 'Esiste già un GOK attivo nel periodo selezionato. Scegli un intervallo di date che non si sovrapponga a quelli esistenti.',
          ACTIVATE_GOK: 'Gok attivo',
          NUMBER:'Numero Gok',
          MODIFY_GOK_NUMBER:'Modifica numero Gok',
          ADD_GOK_NUMBER: 'Aggiungi numero gok per attivarne la creazione'
        },
        ATTACHMENTS: {
          TITLE: 'Attachments',
          NAME: 'Nome',
          CODE: 'Codice',
          COMMENTS: 'Commenti',
          CREATION_TIME: 'Data di creazione',
          TITLE_MODAL: 'Eliminare attachments',
          MESSAGE: 'Sei sicuro di voler eliminare questo attachment?',
          VIEW_ATTACHMENTS: 'Visualizza attachments',
        },
        COMMERCIAL_BLOCK: {
          TITLE: 'Blocco commerciale cliente',
          DESCRIPTION: 'Attivando il blocco commerciale sul cliente, nessuno tranne gli utenti con i ruoli StoreOwner, StoreUser e Admin sarà in grado di confermare il carrello.',
          RESTRICTION_CAUSE: 'Causa di restrizione',
          BLOCK_USER: 'Blocca Utente',
        },
        ORDER_CONFIRMATION_EMAIL: {
          TITLE: 'Mail di conferma ordine',
          BLOCK_BY_DEFAULT: 'Non inviare la mail di conferma ordine',
          DESCRIPTION: 'Se attivo, quando si conferma un carrello di questo cliente l\'opzione "Non mandare email di conferma" è già selezionata. Chi conferma può comunque toglierla.',
          TOOLTIP_NOT_RECEIVED: 'Non la ricevono più: i contatti email dell\'indirizzo di fatturazione del cliente e i contatti dell\'agenzia.',
          TOOLTIP_STILL_RECEIVED: 'La ricevono comunque: chi conferma l\'ordine (anche il cliente stesso, se conferma dalla vetrina, o un agente) e l\'indirizzo notifiche dello store, in copia nascosta.',
          TOOLTIP_EXCEPTIONS: 'La mail parte a tutti come prima se chi conferma toglie la spunta e per gli ordini creati in bulk.',
        },
        MODAL_DELETE_CUSTOMER: {
          ARE_YOU_SURE: 'Sei sicuro?',
          ARE_YOU_SURE_DELETE_CUSTOMER: 'Sei sicuro di voler eliminare questo cliente?',
        },
        MODAL_IMPORT_CUSTOMER: 'Importa cliente tramite Id Post Office',
        CREATE_CUSTOMER: 'Creazione cliente'
      },

      USERS: {
        NAME: 'Utenti',
        COLUMNS: {
          NAME: 'Nome',
          EMAIL: 'Email',
          ROLE: 'Ruolo',
          COMPANY: 'Azienda',
          TYPE: 'Tipo',
          STATUS: 'Stato',
          GOK_NUMBER: 'Numero Gok'
        }
      },

      LOCATION: {
        NAME: 'Indirizzi',
        PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: 'Compila tutti i campi obbligatori',
        PLEASE_FILL_IN_ALL_STOCK_LIMIT_FIELDS: 'Compila tutti i campi dei limiti di stock',
        PLEASE_ENABLE_AT_LEAST_ONE_STORE_AND_ITS_CHANNEL: 'Abilita almeno un negozio e il suo canale',
        PLEASE_ENABLE_AT_LEAST_ONE_CHANNEL: 'Seleziona almeno un canale di vendita per ogni negozio abilitato',
        POINT_OF_SALE: 'Punti vendita',
        SHIPPING_LOCATION: 'Indirizzi di spedizione',
        CREATE_MODAL: {
          CREATE_NEW_POINT_OF_SALE: 'Crea nuovo punto vendita',
          CREATE_NEW_SHIPPING_ADDRESS: 'Crea nuovo indirizzo di spedizione',
        },
        COLUMNS: {
          NAME: 'Nome',
          CITY: 'Città',
          STORES: 'Negozi',
          ORDERS_YTD: 'Ordini (YTD)',
          TOTAL_YTD: 'Totale (YTD)',
          COUNTRY: 'Paese',
          ADDRESS: 'Indirizzo',
        },
        MODAL_DELETE_POS: {
          ARE_YOU_SURE: 'Sei sicuro?',
          ARE_YOU_SURE_DELETE_POINT_OF_SALE: 'Sei sicuro di voler eliminare questo punto vendita?',
        },
        MODAL_DELETE_SA: {
          ARE_YOU_SURE: 'Sei sicuro?',
          ARE_YOU_SURE_DELETE_SHIPPING_ADDRESS: 'Sei sicuro di voler eliminare questo indirizzo di spedizione?',
        },
      },

      PRODUCT_LIST: {
        NAME: 'Elenco prodotti',
        COLUMNS: {
          STYLE: 'Articolo',
          NAME: 'Nome',
          WHOLE_SALE: 'Pre-order wholesale',
          RETAIL: 'Pre-order retail',
          ALL_IMAGES_HIDDEN: 'Immagini nascoste',
          STOCK: 'Magazzino',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
        },
        PRICE: 'Prezzo',
        VARIANTS: 'Varianti',
        INCLUDED: 'Incluse',
        SELECTED: 'selezionate',
        BY_PRODS: 'Per prodotto',
        BY_DATE: 'Data di consegna',
      },

      VARIANT: {
        COLUMNS: {
          SKU: 'SKU',
          SIZE: 'Taglia',
          COLOR: 'Colore',
          STOCK_QTY: 'Quantità (q.ty)',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
          STOCK_LIMIT: 'Limite stock',
        },
      },
      SALES_CAMPAIGNS: {
        COLUMNS: {
          NAME: 'Nome',
          CAMPAIGN_VALIDITY: 'Validità campagna',
          REORDER_VALIDITY: 'Validità riordino',
          STORE_REORDER_START: 'Inizio riordino negozio',
          APPLY_REORDER_SPENDING_LIMIT_ONLY_TO_AUTOMATIC_DISCOUNT_ITEMS:
            'Applica il limite di spesa del riordino solo agli articoli con sconto automatico',
          STORE_REORDER_END: 'Fine riordino negozio',
          UNLIMITED_REORDER: 'Varianti con riordino illimitato',
          UNLIMITED_REORDER_TOOLTIP:
            'Selezionando queste varianti ne consentirai il riordino illimitato.',
          LIMITED_REORDER_PIECES: 'Varianti con limite massimo pezzi riordinabili',
          LIMITED_REORDER_PIECES_TOOLTIP:
            'Selezionando queste varianti applicherai il limite massimo di pezzi riordinabili per ciascuna.',
          PERCENTAGE: 'Percentuale di riordino per questa campagna',
          REORDER_PERCENTAGE: 'Percentuale di riordino',
          REORDER_PIECES_PERCENTAGE: 'Percentuale massima pezzi da riordinare per variante',
          PREORDER_SPENDING_LIMIT: 'Limite di spesa Pre-order',
          PREORDER_PERCENTAGE: 'Percentuale di spesa Pre-order',
          PREORDER_SPENDING_LIMIT_TOOLTIP: 'Percentuale massima di spesa in pre-order consentita su ciascuna variante selezionata, calcolata sulla spesa della stessa variante nella campagna precedente.',
          PREORDER_TIER_PERCENTAGES: 'Percentuale di spesa Pre-order per tier',
          PREORDER_TIERS_DESCRIPTION: 'La percentuale vale per i punti vendita del tier. Tier senza percentuale e punti vendita senza tier: nessun limite.',
          PREORDER_TIER: 'Tier',
          PREORDER_TIER_ARCHIVED: 'Archiviato',
          PREORDER_TIER_NO_LIMIT: 'Nessun limite',
          PREORDER_TIERS_SAVE_FIRST: 'Salva la campagna per impostare le percentuali per tier.',
          PREORDER_TIERS_EMPTY: 'Nessun tier sul canale pre-order di questo store: il limite di spesa pre-order non si applica.',
          PREORDER_TIERS_SEARCH: 'Cerca tier...',
          PREORDER_BASELINE_CAMPAIGN: 'Campagna precedente',
          SELECT_PREVIOUS_CAMPAIGN: 'Seleziona una campagna precedente',
          PREORDER_AVAILABLE_VARIANTS: 'Varianti disponibili',
          PREORDER_AVAILABLE_VARIANTS_TOOLTIP: 'Seleziona le varianti da sottoporre al limite: solo quelle selezionate saranno vincolate dalla percentuale; le altre restano illimitate in pre-order.',
          INSERT_PERCENTAGE: 'Inserisci percentuale',
          DESCRIPTION: 'Descrizione',
          START_DATE: 'Data inizio',
          END_DATE: 'Data fine',
          SHOP_SELLING_PERIOD_START: 'Inizio vendite in negozio',
          SHOP_SELLING_PERIOD_END: 'Fine vendite in negozio',
          DELIVERY_PERIOD_START: 'Inizio consegne',
          DELIVERY_PERIOD_END: 'Fine consegne'
        },
        CREATE_MODAL: {
          EDIT_SALE_CAMPAIGN: 'Modifica campagna vendita',
          ADD_NEW_SALE_CAMPAIGN: 'Aggiungi campagna vendita'
        },
        ERROR_MODAL:{
          TITLE: 'Errore',
          DESCRIPTION: 'Compila tutti i campi obbligatori'
        },
        DELETE_MODAL: {
          TITLE: 'Sei sicuro?',
          DESCRIPTION: 'Sei sicuro di voler eliminare questa campagna vendita?'
        },
        RULE: {
          COLUMN: {
            ID: 'Id',
            NAME: 'Nome',
            ROLES_BYPASSING: 'Ruoli che bypassano la regola',
            TIER: 'Tier',
            LAST_MODIFICATION_TIME: 'Ultima modifica',
            STATUS: 'Stato',
          },
        },
      },
      REPORTS: {
        NAME: 'Reports',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nome',
          TYPE: 'Tipo',
          CREATOR: 'Creatore',
          COMPLETED_AT: 'Data di completamento',
        },
      },
    },
    SALES_CAMPAIGNS: {
      NAME: 'Nome',
      VALIDITY: 'Validità',
      COMMERCIAL_RULES: 'Regole commerciali',
      PRE_ORDER: 'Pre-order',
      RE_ORDER: 'Re-order',
      VARIANT_UNLIMITED_REORDER_TAG_ADDED: 'Variante associata al riordino illimitato.',
      VARIANT_UNLIMITED_REORDER_TAG_REMOVED: 'Variante rimossa dal riordino illimitato.',
      VARIANT_UNLIMITED_REORDER_TAG_ERROR: 'Impossibile aggiornare il tag della variante. Riprova.',
      UNLIMITED_REORDER_TAG_NOT_FOUND: 'Tag riordino illimitato non trovato. Contatta il supporto.',
      VARIANT_PREORDER_LIMITED_SAVED: 'Varianti pre-order salvate con successo.',
      VARIANT_PREORDER_LIMITED_ERROR: 'Impossibile salvare le varianti pre-order. Riprova.',
      VARIANT_LIMITED_REORDER_PIECES_SAVED: 'Varianti con limite pezzi riordinabili salvate con successo.',
      VARIANT_LIMITED_REORDER_PIECES_TAG_ERROR: 'Impossibile aggiornare il tag della variante con limite pezzi. Riprova.',
      LIMITED_REORDER_PIECES_TAG_NOT_FOUND: 'Tag limite pezzi riordinabili non trovato. Contatta il supporto.',
      NEW_RULE: 'Nuova regola',
      DELETE_ASSORTMENT_SUCCESSFULLY: 'Assortimento eliminato con successo',
      DELETE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Vincolo di pacchetto eliminato con successo',
      CREATE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Vincolo di pacchetto creato con successo',
      UPDATE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Vincolo di pacchetto aggiornato con successo',
      ENABLED_CONSTRAINT_VALUE_SUCCESSFULLY: 'Vincolo a valore abilitato con successo',
      DELETE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Vincolo a valore eliminato con successo',
      CREATE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Vincolo a valore creato con successo',
      UPDATE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Vincolo a valore aggiornato con successo',
      DELETE_FILTER_SUCCESSFULLY: 'Filtro eliminato con successo',
      CREATE_FILTER_SUCCESSFULLY: 'Filtro creato con successo',
      UPDATE_FILTER_SUCCESSFULLY: 'Filtro aggiornato con successo',
      UPDATE_RULE_SUCCESSFULLY: 'Regola aggiornata con successo',

      RULES: {
        CONSTRAINT_VALUE_NOT_ENABLED: 'Vincolo non abilitabile per questo assortimento in quanto già attivo su un\'altro assortimento',
        CONSTRAINT_VALUE_INFO_MESSAGE: 'Questo vincolo si scatenerà su ogni carrello legato a questa regola commerciale.',
        CONSTRAINT_VALUE_ENABLED: 'Vincolo valore abilitato',
        NO_ASSORTMENTS: 'Nessun assortimento configurato, aggiungi un assortimento per gestire i vincoli',
        NO_CONSTRAINT_PACKAGE: 'Non hai ancora inserito nessun vincolo di pacchetto su questo assortment',
        NO_CONSTRAINT_VALUE: 'Attiva questa funzionalità per inserire il vincolo a valore su questo assortimento',
        NO_CONSTRAINT_FILTER: 'Puoi impostare dei filtri per determinare gli articoli con cui calcolare il totale wholesale',
        CONSTRAINTS_CONFIGURATION: 'Configurazione vincoli',
        TITLE: 'Regole',
        RULE: 'Regola: {{ruleName}}',
        NAME: 'Nome',
        TIER: 'Tier',
        ROLES_BYPASSING: 'Ruoli che bypassano la regola',
        ADD_ASSORTMENT: 'Aggiungi assortimento',
        ADD_CONSTRAINT: 'Aggiungi vincolo',
        ADD_RULE: 'Aggiungi regola',
        CONSTRAINTS_PACKAGE: 'Vincoli di pacchetto',
        QUANTITY: 'Quantità',
        STYLES_CODE: 'Prodotti',
        CONSTRAINT_VALUE: 'Vincolo a valore',
        PERCENTAGE: 'Percentuale',
        TYPE: 'Tipo',
        CONDITION: 'Condizione',
        VALUE: 'Valore',
        VALUE_RULE_WHEN_CALCULATE_TOTAL_WHOLESALE_INFORMATION: 'Il valore wholesale degli articoli appartenenti a questo assortment, rispetto al totale wholesale del carrello, deve essere maggiore o uguale al',
        VALUE_RULE_INFORMATION: 'Filtri per determinare gli articoli dell\'ordine su cui valutare il vincolo a valore: ',
        ADD_OR_REMOVE: 'Aggiungi/Rimuovi',
        ADD_FILTER: 'Aggiungi filtro',
        ACTIVATE: 'Attiva regola',
        DISABLE: 'Disattiva regola'
      },
      TYPE: {
        WHERE_STYLE_GROUP: 'Dove style group',
        WHERE_SIZE_GROUP: 'Dove size group',
      },
      CONDITION: {
        IS: 'è',
        IS_NOT: 'non è',
      },
    },
    PICK_LIST: {
      TO_INCLUDE: 'Da includere',
      INCLUDED: 'Incluse',
      VARIANTS_SELECTED: 'Varianti selezionate: {{quantity}}',
      ALL: 'tutte',
      SELECTED_ALL: 'Seleziona tutto',
      CLICK_FOR_OPEN_REPORT: 'Clicca per aprire il report',
      INCLUDE: 'Includi',
      EXCLUDE: 'Escludi',
      VARIANTS: 'Varianti {{quantity}}',
      SUCCESS_VARIANTS_DISASSOCIATE: '{{quantity}} varianti disassociate con successo',
      SUCCESS_VARIANTS_ASSOCIATE: '{{quantity}} varianti associate con successo',
      NO_OTHER_DATA: 'Non ci sono altri dati',
      NO_DATA_FOUND: 'Nessun dato trovato',
      SELECT_ALL_MODAL: {
        TITLE: 'Modalità tutto selezionato',
        MESSAGE: '<strong>Attenzione!</strong> Selezionando questa modalità verranno selezionati tutti i prodotti e le varianti disponibili per i filtri selezionati. <br> Potrai comunque escludere prodotti e varianti dalla lista di selezione.',
        NOT_SHOW_AGAIN: 'Non mostrare più',
        CONFIRM: 'Conferma',
      },
      SELECT_ALL_CANCELED: 'Seleziona tutto annullato',
      REPORT_SELECTED_MODAL: {
        TITLE: 'Report selezione',
        NOT_SELECTED: 'Non è ancora stata selezionata nessuna variante o prodotto-colore',
        YOU_ARE_SELECTING: 'Stai selezionando {{quantity}} {{what}}',
        YOU_ARE_EXCLUDING: 'escludendo {{quantity}} {{what}}',
        PRODUCT_STYLE_COLOR: 'prodotto-colore',
        VARIANTS: 'varianti',
        YOU_ARE_SELECTING_ALL_VARIANTS_FOR_THIS_FILTERS: 'Stai selezionando tutte le varianti per questi filtri',
        YOU_ARE_SELECTING_THE_ENTIRE_CATALOGUE_AVAILABLE: 'Stai selezionando l\'intero catalogo disponibile',
        FROM_THE_SELECTION_YOU_ARE: 'Dalla selezione stai',
        EXCLUDING_PRODUCTS_STYLE_COLOR: 'escludendo {{quantity}} prodotti-colore',
        EXCLUDING_VARIANTS: 'escludendo {{quantity}} varianti',
        NOT_VARIANT_OR_PRODUCT_STYLE_COLOR_HAS_BEEN_SELECTED_YET: 'Non è ancora stata selezionata nessuna variante o prodotto-colore',

      },
      SAVE_INCLUDE_EXCLUDE_MODAL: {
        ARE_YOU_SURE: 'Sei sicuro?',
      }
    },
    COMMERCIAL_AGREEMENT_DETAIL: {
      CONTINUE_WITHOUT_COMMERCIALAGREEMENT: "Continua senza selezione",
      BACK_TO_COMMERCIAL_AGREEMENTS: 'Torna agli accordi commerciali',
      CREATE_NEW_COMMERCIAL_AGREEMENT: 'Crea nuovo accordo commerciale',
      COMMERCIAL_AGREEMENT: 'Accordo commerciale: {name}',
      COMMERCIAL_AGREEMENT_INFO: 'Informazioni sull\'accordo commerciale',
      NAME: 'Nome',
      VALID_FROM: 'Valido dal',
      VALID_UNTIL: 'Valido fino al',
      DISCOUNT_PERCENTAGE: '% sconto',
      TOTAL_RETAIL_AMOUNT: 'Tetto di spesa (valore retail, €)',
      CUSTOMER: 'Cliente',
      CHANNEL: 'Canale',
      ERRORS: {
        COMPILE_ALL_REQUIRED_FIELDS: 'Compila tutti i campi obbligatori',
      },
    },
    TERM_OF_SALE_DETAIL: {
      BACK_TO_TERMS_OF_SALE: 'Torna ai termini di vendita',
      CREATE_NEW_TERM_OF_SALE: 'Crea nuovo termine di vendita',
      TERM_OF_SALE: 'Termine di vendita',
      NAME: 'Nome',
      SET_AS_ACTIVE: 'Imposta come attivo',
      TERMS_AN_CONDITIONS_BY_LANGUAGE: 'Termini e condizioni per lingua',
      PLEASE_SELECT_A_DEFAULT_LANGUAGE: 'Seleziona una lingua di default utilizzando il menù azioni presente a fianco del nome della lingua selezionata',
      PLEASE_WRITE_A_TERM_OF_SALE_FOR_THE_DEFAULT_LANGUAGE_OR_SELECT_ANOTHER_DEFAULT_LANGUAGE: 'Scrivi un termine di vendita per la lingua di default o seleziona un\'altra lingua di default',
      PLEASE_ENTER_A_VALID_TERM_OF_SALE_NAME: 'Inserisci un nome valido per il termine di vendita',
      TERM_OF_SALE_UPDATE_SUCCESS: 'Termine di vendita aggiornato con successo',
      TERM_OF_SALE_CREATE_SUCCESS: 'Termine di vendita creato con successo',
      NAME_ALREADY_EXISTS: 'Il nome esiste già',
      ENTER_THE_TERM_OF_SALE: 'Inserisci il termine di vendita',
      NAME_REQUIRED: 'Nome obbligatorio',
      NAME_INVALID: 'Nome non valido',
      TERM_OF_SALE_DELETE_SUCCESS: 'Termine di vendita eliminato con successo',
      ARE_YOU_SURE: 'Sei sicuro?',
      ARE_YOU_SURE_DELETE_TERM_OF_SALE: 'Sei sicuro di voler eliminare questo termine di vendita?',
      ERROR_IS_APPLIED_TO_ORDERS: 'Questo termine di vendita non può essere modificato o eliminato in quanto è stato associato ad uno o più ordini',
    },
    TIER_DETAIL: {
      BACK_TO_TIERS: 'Torna ai tiers',
      CREATE_NEW_TIER: 'Crea nuovo tier',
      NAME: 'Nome',
      INFORMATION: 'Informazioni',
      DESCRIPTION: 'Descrizione',
      INCLUDE_VARIANTS: 'Includi varianti',
      INCLUDED_VARIANTS: 'Varianti incluse',
      ASSOCIATE_VARIANTS: 'Associa varianti',
      DISASSOCIATE_VARIANTS: 'Disassocia varianti',
      PLEASE_FILL_ALL_REQUIRED_FIELDS: 'Compila tutti i campi obbligatori',
      TIER_UPDATE_SUCCESS: 'Tier aggiornato con successo',
      TIER_CREATE_SUCCESS: 'Tier creato con successo',
      VARIANTS_DISASSOCIATED_SUCCESS: 'Varianti disassociate con successo',
      VARIANTS_ASSOCIATED_SUCCESS: 'Varianti associate con successo',
      REMOVE_POS_FROM_TIER: 'Sei sicuro di voler rimuovere il punto vendita dal tier?',
      POS_ALREADY_ASSOCIATED: 'Punto vendita già associato al tier',
      OPTION_DESCRIPTION: 'Attivando questa opzione, i punti vendita con questo tier associato vedranno non solo le varianti di questo tier, ma anche quelle senza alcun tier associato, per il canale di vendita impostato.',
      INFO_ALLERT: {
        INCLUDE_VARIANTS: 'Seleziona le varianti da includere nel tier, e poi clicca salva per aggiornare il tier.',
        INCLUDED_VARIANTS: 'Queste sono le varianti incluse nel tier. Seleziona le varianti da disassociare dal tier, e poi clicca salva per aggiornare il tier.',
      },
      DETAIL: 'Dettaglio',
      ASSOCIATED_VARIANTS: 'Varianti associate',
      ARCHIVED_TIER: 'Tier archiviato #{{tierName}}',
      WORK_IN_PROGRESS_MESSAGE: 'Qui potrai visualizzare le varianti che erano associate a questo tier. Stiamo lavorando per voi.',
      CHANNEL: 'Canale',
      ARE_YOU_SURE_SAVE_STORE_POINTS_OF_SALE: 'Sei sicuro di voler associare i punti vendita selezionati al Tier corrente?',
      SELECTED_STORE_POINTS_OF_SALE: 'Punti vendita selezionati',
      STORE_POINTS_OF_SALE_SAVED: 'Punti vendita salvati con successo',
    },
    LOCATION_DETAIL: {
      POINT_OF_SALE_INFO: 'Informazioni sul punto vendita',
      BACK_TO_POS: 'Torna ai punti vendita',
      ADDRESS_INFO: 'Informazioni sull\'indirizzo',
      PURCHASE_STATS: {
        NAME: 'Statistiche di acquisto',
        TOTAL_CUSTOMER_REVENUE: 'Ricavo totale del cliente',
        FROM_PRE_ORDER: 'Per pre-order',
        FROM_RE_ORDER: 'Per re-order',
        TOTAL_MARGIN: 'Margine totale',
        TOTAL_ORDERS: 'Ordini totali',
        AVERAGE_ORDER_VALUE: 'Valore medio dell\'ordine',
      },
      SUMMER_STOCK_LIMIT: 'Limite di magazzino estivo',
      WINTER_STOCK_LIMIT: 'Limite di magazzino invernale',
      SUMMER_START_MONTH: 'Mese di inizio estivo',
      WINTER_START_MONTH: 'Mese di inizio invernale',
      SUMMER_START_DAY: 'Giorno di inizio estivo',
      WINTER_START_DAY: 'Giorno di inizio invernale',
      STOCK_LIMIT: 'Limite di magazzino',
      THE_WAREHOUSE_LIMIT_MUST_BE_SET_FOR_THE_CHANNELS: 'Il limite di magazzino deve essere impostato per i canali',
      ONLINE_STORES_ENABLED: 'Negozi online abilitati',
      USE_NAME_IN_ORDER_HEADER: 'Usa il nome del punto vendita nella bolla degli ordini',
      BACK_TO_LOCATIONS: 'Torna agli indirizzi',
      NAME: 'Nome',
      TIER: 'Livello',
      AGENCY: 'Agenzia',
      CHANNEL: 'Canale',
      YOU_CANT_EDITINFO_ABOUT_ADDRESS: 'Non puoi modificare le informazioni sull\'indirizzo se è in attesa di approvazione per un negozio!',
      YOU_CANT_ACTIVEATE_THIS_ADDRESS_IF_ITS_CUSTOMER_IS_NOT_APPROVED: 'Non puoi attivare questo indirizzo se il cliente non è approvato!',
      MISSING_STOCK_LIMIT: 'Attenzione! per poter attivare l\'indirizzo su canale Plug&Sell devi prima completare la sezione relativa ai limiti di stock!',
      ERROR_MODAL: {
        TITLE: 'Attenzione!',
        DESCRIPTION: 'Campi mancanti per salvare le modifiche, completare i dati per procedere',
      }
    },
    CONTACT: {
      NAME: 'Contatto',
      NEW_CONTACT: 'Nuovo contatto',
      EDIT_CONTACT: 'Modifica contatto',
      CONTACT_INFO: 'Informazioni sul contatto',
    },
    USER_DETAIL: {
      USER_INFO: 'Informazioni sull\'utente',
      REGISTERED_SINCE: 'Registrato dal',
      NAME_SURNAME: 'Nome e cognome',
      NAME_SURNAME_ERROR: 'Nome e cognome obbligatori',
      EMAIL_ERROR: 'Email obbligatoria',
      ROLES_ERROR: 'Ruolo obbligatorio',
      STORE_ERROR: 'Negozio obbligatorio',
      CUSTOMER_ERROR: 'Cliente obbligatorio',
      AGENCY_ERROR: 'Agenzia obbligatoria',
      USER_ROLE: 'Ruolo',
      AGENCY: 'Agenzia',
      CUSTOMER: 'Cliente',
      BACK_TO_USERS: 'Torna agli utenti',
      MY_PROFILE: 'Il mio profilo',
      INVITE_USER: 'Invita utente',
      SEND_INVIATION: 'Invia invito',
      USER_STATUS: 'Stato utente',
      RESEND_INVITATION: 'Invia nuovamente l\'invito',
      INVITATION_RESENT_COMPLETED: 'Invito inviato con successo',
      INVITATION_RESENT_ERROR: 'Errore durante l\'invio dell\'invito',
      MODAL_CONFIRM: {
        ARE_YOU_SURE: 'Sei sicuro?',
        ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_USER: 'Sei sicuro di voler disattivare questo utente?',
      }
    },
    WORK_IN_PROGRESS_TITLE: 'Stiamo lavorando per voi: manutenzione straordinaria dalle ore {{fromHour}} del {{fromDate}}. Torneremo online alle {{toHour}} del {{toDate}}',
    ORDER_DETAIL: {
      EXTRA_COSTS_INFO: 'Qui puoi personalizzare i costi di spedizione e/o personalizzazione. Se non valorizzati, i relativi costi verranno popolati in base alle impostazioni di default. Se, ad esempio, non vuoi far pagare le spese di spedizione per questo carrello, inserisci 0 nel relativo campo.',
      COURIER_COSTS_INFO: 'Attualmente si stanno applicando i costi di spedizione associati al corriere {{transportAgencyName}} di €{{transportAgencyCost}}.',
      CUSTOMIZATION_COSTS: 'Costi di personalizzazione',
      MANAGE_EXTRA_COSTS: 'Gestisci costi extra',
      BULK_OPERATIONS_STATUS_SYNCING: 'Questo ordine è attualmente in fase di aggiornamento ({{processingCount}} operazioni in coda). Tutte le operazioni sono temporaneamente disabilitate fino al completamento della sincronizzazione.',
      BULK_OPERATIONS_STATUS_SYNCING_2: 'Questo ordine è attualmente in fase di aggiornamento. Tutte le operazioni sono temporaneamente disabilitate fino al completamento della sincronizzazione.',
      BULK_OPERATIONS_STATUS_AWATING: 'Questo ordine ha {{processingCount}} operazioni da elaborare in coda.',
      HAS_OPERATION_PENDING_MESSAGE: 'Spiacente! Quest\'ordine non è più modificabile in quanto uno dei job in coda è già iniziato. Ritorna a modificare l\'ordine quando tutti i suoi job in coda sono terminati e riaggiorna la pagina per visualizzare i dettagli.',
      STATS: {
        TOTAL_WHOLESALE: 'Totale wholesale',
        TOTAL_RETAIL: 'Totale retail',
        TOTAL_NET: 'Totale netto',
        TOTAL_NET_IVA: 'Totale netto (tasse incluse)',
        VAT_MARKUP: 'RE',
        VAT: 'IVA',
        TOTAL_ORDERED: 'Totale ordinato',
        TOTAL_DISCOUNT: 'Sconto tot. su wholesale',
        TOTAL_PIECES: 'Pezzi',
        TOTAL_MARGIN: 'Margine',
        TOTAL_COST: 'Costo',
        TOTAL_CUSTOMER_DISCOUNT: 'Sconto cliente',
        TOTAL_COMMERCIAL_DISCOUNT: 'Sconto commerciale',
        TOTAL_FINANCIAL_DISCOUNT: 'Sconto finanziario',
        TOTAL_STORECHANNEL_DISCOUNT: 'Sconto invincibile',
        TOTAL_AGREEMENT_DISCOUNT: 'Sconto acc. comm.',
        TOTAL_AUTO_DISCOUNT: 'Sconti automatici',
        TOTAL_VOUCHER_AMOUNT: 'Valore voucher',
        DISCOUNT: 'Sconto',
        CHOOSE_DOWNLOAD_TYPE: 'Scegli il tipo di download',
        DOWNLOAD_TYPE_MESSAGE: 'Al termine del processo, riceverai un\'email al tuo indirizzo con il file allegato non appena sarà disponibile',
        TOTAL_SERVICES: 'Totale servizi',
        SHIPPING_COST: 'Costo spedizione',
        SHIPPING_COST_COURIER: 'Costo spedizione del corriere',
        SHIPPING_COST_SET: 'Costo spedizione impostato',
        SOME_ORDERITEMS_HAS_NO_COST: 'Qualche articolo del carrello non ha costo specificato, quindi questa funzionalità non è disponibile',
        PENDING_OPERATION: 'Non puoi svolgere operazioni sul carrello in quanto ci sono caricamenti di righe d\'ordine tramite excel file in elaborazione.',
        CHOOSE_EXCEL_PROPS_TITLE: 'Scegli le proprietà',
        CHOOSE_EXCEL_PROPS: 'Scegli le colonne da visualizzare nel foglio dell\'excel dedicato alle righe d\'ordine',
        CUSTOM_DATE: 'Data personalizzata',
        EDIT_CUSTOM_DATE: 'Personalizza data',
        NO_CUSTOM_DATE: 'Data non personalizzabile',
        SELECTED_ITEMS: 'righe d\'ordine selezionate',
        REQUESTED_SALES_PRICE: 'Prezzo di vendita richiesto',
        COLUMNS: {
          IMAGE: 'Immagine',
          NAME: 'Colonne',
          SKU: 'Sku',
          COLOR: 'Colore',
          COLOR_CODE: 'Code colore',
          COLOR_NAME: 'Nome colore',
          SIZE: 'Taglia',
          UNIT_WHOLESALE: 'Wholesale unit.',
          UNIT_NET: 'Netto unit.',
          UNIT_COST: 'Costo unit.',
          UNIT_MARGIN: 'Margine unit.',
          TOTAL_RETAIL: 'Retail tot.',
          TOTAL_WHOLESALE: 'Wholesale tot.',
          TOTAL_NET: 'Netto tot.',
          TOTAL_COST: 'Costo tot.',
          TOTAL_MARGIN: 'Margine tot.',
          TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Sconto da retail',
          TOTAL_DISCOUNT_PERCENTAGE: 'Sconto da wholesale',
          CUSTOMER_DISCOUNT: 'Sconto cliente',
          AGREEMENT_DISCOUNT: 'Sconto accordo comm.',
          FINANCIAL_DISCOUNT: 'Sconto finanziario',
          STORECHANNEL_DISCOUNT: 'Sconto inv.',
          DISCOUNT_BY_QTY: 'Sconto by qty',
          DISCOUNT_BY_VALUE: 'Sconto by value',
          COMMERCIAL_DISCOUNT: 'Sconto commerciale',
          MARGIN_PERCENTAGE: 'Margin',
          QTY: 'Qty',
          EAN: 'EAN',
          SIZE_GROUP: 'Gruppo taglia',
          PRODUCT_CODE: 'Codice prodotto',
          VARIANT_CODE: 'Codice varianti',
          PRODUCT_TITLE: 'Nome prodotto',
          DATE: 'Data',
          ORDERED_QTY: 'Qty ordinata',
          CANCELED_QTY: 'Qty annullata',
          NOT_FULFILLED_QTY: 'Qty non evasa',
          FULFILLED_QTY: 'Qty evasa',
          FULFILLMENT_STATUS: 'Stato consegna',
          GROUP_GENERAL: 'Generali',
          GROUP_UNITARY: 'Unitario (€)',
          GROUP_TOTALS: 'Totali (€)',
          GROUP_PERCENT: 'Percentuali (%)',
          GROUP_FULFILLMENT: 'Evasione',
          STYLE_GROUP: 'Style group',
          NOTE: 'Note',
          DELIVERY_DATE: 'Data consegna',
          REPLACE_EAN: 'Sostituisci EAN',
          CANCELLATION_REASON: 'Motivo cancellazione',
        },
      },
      UPLOADS: {
        UPLOADED: 'Caricamento file eseguito! Una mail ti notificherà il completamento dell\'operazione.',
        TITLE: 'Uploads',
        MESSAGE1: 'Qui puoi caricare articoli al tuo carrello tramite file excel (.xlxs, .xls). Nella colonna "Code", per identificare la variante, potrai inserire o una lista di codici EAN o una lista di codici SKU.',
        MESSAGE1_1: 'La colonna "Requested Price" è opzionale e può essere utilizzata per specificare un prezzo di vendita desiderato al fine di calcolare lo sconto commerciale sulla riga d\'ordine.',
        MESSAGE2: 'Nella colonna "Code", il mio file conterrà codici:',
        MESSAGE3: 'Vuoi eseguire l\'upload del file:',
        OPERATION_ERRORS_DETAILS: 'Dettaglio errore operazione',
        DEFAULT_ERROR_MESSAGE: 'Si è verificato un errore durante l\'elaborazione del file.',
        COLUMNS: {
          ID: 'Id',
          CREATED_BY: 'Creato da',
          CREATED_ON: 'Creato il',
          STARTED_ON: 'Iniziato il',
          CONCLUDED_ON: 'Concluso il',
          STATUS: 'Stato',
          FILE_ROW_INDEX: 'Riga nel file'
        }
      },
      FULFILLMENT: {
        FULFILLMENTS: 'Evasioni',
        TITLE: 'Evasione #{{fulfillmentNumber}}',
        FULFILLMENT_STATUS: 'Stato evasione',
        FULFILLMENT_DATE: 'Data evasione',
        COURIER: 'Corriere',
        TRACKING_NUMBER: 'Numero di tracciamento',
        TRACK_DELIVERY: 'Traccia spedizione',
        DOWNLOAD_DELIVERY_NOTE: 'Scarica bolla',
        SHIPPED: 'Spedito',
        DELIVERED: 'Consegnato',
      },

      ORIGINAL_MODIFIED_INFORMATION: 'Informazione modificata, originale: {{originalValue}}',
      COMMERCIAL_BLOCK_INFO: 'Sul cliente corrente è attivo un blocco amministrativo.',
      NO_CART_CONF: 'Questo carrello non può essere confermato.',
      PAYMENT_TERM: 'Termine di pagamento',
      ALREADY_FULFILLED_QUANTITY: 'Articoli provenienti da ordini di impianto',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_CUSTOMER_IS_NOT_APPROVED: 'Non puoi confermare questo carrello perché il cliente non è approvato',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_POINT_OF_SALE_IS_NOT_APPROVED: 'Non puoi confermare questo carrello perché il punto vendita non è approvato',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_HAS_NOT_ITEMS: 'Non puoi confermare questo carrello perché non ha articoli',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_LOWER_CART_VALUE: 'Non puoi confermare questo carrello perché il totale del carrello è inferiore al valore minimo consentito in questo negozio',
      SOME_ORDER_ITEMS_IS_NOT_AVAILABLE_FOR_CURRENT_REQUESTED_QUANTITY: 'Alcuni articoli dell\'ordine non sono disponibili per la quantità richiesta',
      PREORDER_NO_BASELINE: 'Nessuna spesa di riferimento nella campagna precedente per le varianti selezionate: nessun budget pre-order da mostrare.',
      PREORDER_ADMITTED: 'Pre-order entro il limite di spesa ({{percentage}}%) per le varianti selezionate. Speso {{used}} su un massimo di {{max}} - residuo {{remaining}}.',
      PREORDER_NOT_ADMITTED_NO_BASELINE: 'Pre-order oltre il limite di spesa ({{percentage}}%) per le varianti selezionate. (Varianti non acquistate nella campagna precedente: non riordinabili.)',
      PREORDER_NOT_ADMITTED: 'Pre-order oltre il limite di spesa ({{percentage}}%) per le varianti selezionate. Speso {{used}} su un massimo di {{max}} - superato di {{exceeded}}.',
      REORDER_ADMITTED: 'Questo carrello è un riordino nella campagna di vendita "{{campaignName}}". Riordino massimo consentito: {{maxPrice}} ({{percentage}}%) - Residuo disponibile: {{remaining}}.',
      REORDER_NOT_ADMITTED: 'Attenzione! Questo carrello è un riordino nella campagna di vendita "{{campaignName}}". Riordino massimo consentito: {{maxPrice}} ({{percentage}}%) - Superato di: {{exceeded}}.',
      REORDER_ADMITTED_INTERNAL_USER: 'Come utente interno, puoi comunque procedere con la conferma.',
      REORDER_NOT_ADMITTED_FOR_CUSTOMER_EXTERNAL_USER: 'Attenzione! Non puoi confermare questo carrello. Contatta il servizio clienti all\'indirizzo email "{{shopEmail}}" per risolvere il problema.',
      GOK_NOT_ADMITTED: 'Attenzione! Questo carrello ha superato il limite massimo di {{totalAmount}}. Importo residuo disponibile: {{residualAmount}} - Superato di: {{exceeded}}.',
      SUMMARY: 'Riepilogo',
      ORDER_ITEMS: 'Dettaglio articoli',
      ORDER_TYPE: 'Tipo di ordine',
      REORDER_TYPE: 'Tipo di re-order',
      ORDER_STATUS: 'Stato dell\'ordine',
      CHANNEL_NAME: 'Nome del canale',
      CHANNEL: 'Canale',
      CUSTOMER: 'Cliente',
      CUSTOMER_LOCATION: 'Indirizzo cliente',
      POINT_OF_SALE: 'Punto vendita',
      AGENT: 'Agente',
      AGENCY: 'Agenzia',
      USER: 'Utente',
      USER_EMAIL: 'Email utente',
      SHIPPING_ADDRESS: 'Indirizzi spedizione',
      CREATED_ON: 'Creato il',
      CONFIRMED_ON: 'Confermato il',
      DELIVERY_DATE: 'Data di consegna',
      EXTERNAL_ID: 'ID esterno',
      REASON: 'Causale',
      ORDER_REASON: 'Causale ordine',
      MANUAL_DISCOUNT: 'Sconto manuale',
      CUSTOMIZATION_REQUEST: 'Richiesta di personalizzazione',
      NAME: 'Nome',
      AMOUNT: 'Importo',
      NOTE: 'Note',
      SELECT_ACTION_TYPE: 'Seleziona tipo di azione',
      BACK_TO_ORDERS: 'Torna agli ordini',
      BACK_TO_CARTS: 'Torna ai carrelli',
      SAVED_NOTE: 'Nota salvata',
      ESTIMATED_DELIVERY_DATE: 'Data consegna prevista',
      DELETE_ORDER: 'Elimina ordine',
      CANCEL_ORDER: 'Annulla ordine',
      RESEND_ORDER_CONFIRMATION: 'Rinvia conferma ordine',
      ARE_YOU_SURE_YOU_WANT_TO_DELETE_SELECTED_ORDERS: 'Sei sicuro di voler eliminare gli ordini selezionati?',
      ADD_ITEMS: 'Aggiungi articoli',
      EDIT_ITEMS: 'Modifica articoli',
      EDIT_SELECTED: 'Modifica selezionati',
      DELETE_NOT_FULFILED_ITEMS: 'Cancella articoli inevasi',
      ARE_YOU_SURE_YOU_WANT_TO_DELETE_SELECTED_ITEMS: 'Sei sicuro di voler cancellare i seguenti articoli?',
      CLOSE_SELECT_MODE: 'Chiudi modalità selezione',
      SUCCESS_RESEND_ORDER_CONFIRMATION: 'Rinvio conferma ordine avvenuto con successo',
      INVOICING_NUMBER_FULL_NAME: 'Numero account fattura',
      CENTRAL_PAYMENT_NUMBER_FULL_NAME: 'Numero pagamento centralizzato',
      MODAL: {
        ARE_YOU_SURE: 'Sei sicuro?',
        CONFIRM: 'Conferma',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: 'Sei sicuro di voler eliminare?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CART: 'Sei sicuro di voler eliminare questo carrello?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_DISCOUNT: 'Sei sicuro di voler rimuovere lo sconto?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_VARIANT: 'Sei sicuro di voler rimuovere questa variante?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_SELECTED_VARIANTS: 'Sei sicuro di voler rimuovere queste varianti selezionate?',
        SET_MAXIMUM_QUANTITY_FOR_THIS_SELECTED_VARIANTS: 'Attenzione! Confermando verrà impostata per ogni variante selezionata, la sua relativa quantità massima disponibile.',
      },
      DISCOUNT: {
        DISCOUNT_AMOUNT: 'Sconto aggiuntivo',
        DESCRIPTION_COMMERCIAL_DISCOUNT: 'Questo sconto verrà applicato agli elementi selezionati',
        DESCRIPTION_FINANCIAL_DISCOUNT: 'Questo sconto verrà applicato ad ogni elemento del carrello'
      },
      MODAL_EDIT_ORDERITEM: {
        EDIT_ORDER_ITEM: 'Modifica articolo',
        ORDER_QTY: 'Qty ordinata',
        MAXIMUM_QUANTITY_AVAILABLE_FOR_THIS_VARIANT_ON_DATE: 'Quantità massima disponibile per questa variante in data',
        IS: 'è:',
        YOU_ARE_BUYING_THIS_VARIANT_WHIT_BLANCK_CELL_OPTION: 'Stai acquistando questa variante con opzione in cella bianca',
        MAX_AMOUNT_EXCEEDED: 'Importo massimo superato',
        MINIMUM_ONE_PIECE: 'Minimo un pezzo',
        THE_QUANTITY_OF_THE_VARIANT_MUST_BE_A_MULTIPLE_OF: 'La quantità della variante deve essere un multiplo di:',
        THE_QUANTITY_ENTERED_IS_LESS_THAN_THE_MINIMUM_ALLOWED: 'La quantità inserita è inferiore al minimo consentito',
        THE_MINIMUM_ORDER_QUANTITY_OF_THE_VARIANT_IS: 'La quantità minima ordinabile della variante è:',
        LOSE_CUSTOM_DELIVERY_DATES: 'Modificando le quantità di questa riga d\'ordine, perderai le date personalizzate impostate! Ricorda di reimpostarla in fase di conferma d\'ordine!',
      },
      MODAL_ORDER_NAME_CHANGE: {
        CHANGE_ORDER_NAME: 'Modifica nome ordine',
      },
      MODAL_HANDLE_DATE: {
        HANDLE_DATE_BUTTON: 'Gestisci date',
        HANDLE_DATE: 'Gestisci data di richiesta consegna originale sulle righe d\'ordine',
        OVERWRITE_ORIGINAL_DATE: 'Usa questa data per sovrascrivere la data di richiesta consegna originale sulle righe d\'ordine selezionate. In questo modo i controlli sulle quantità disponibili per i relativi articoli verranno effettuati su questa nuova data. Attenzione! Modificando tale data, eventuali date di consegna personalizzate andreanno perse!'
      },
      MODAL_SHIPPING_VARIANTS_DATE_: {
        LIST_VARIANTS_FROR_DELIVERY_DATE: 'Lista varianti per data di consegna',
      },
      BUTTONS: {
        EDIT: 'Modifica info ordine',
        ADD_DISCOUNT_FINANCIAL: 'Aggiungi sconto finanziario',
        ADD_DISCOUNT_COMMERCIAL: 'Aggiungi sconto commerciale',
        REMOVE_DISCOUNT_FINANCIAL: 'Rimuovi sconto finanziario',
        REMOVE_DISCOUNT_COMMERCIAL: 'Rimuovi sconto commerciale',
        DISCOUNT_OPTIONS: 'Opzioni sconto',
        CONFIRM_ORDER: 'Conferma ordine',
        CONTINUE: 'Continua acquisti',
        DUPLICATE_CART: 'Duplica carrello',
        SAVE_NOTE: 'Salva note',
        RENAME_ORDER: 'Rinomina ordine',
        REMOVE_CUSTOM_DATE: 'Rimuovi data personalizzata',
        SKIP_AUTOMATIC_DISCOUNT: 'Ignora sconti automatici',
        SKIP_CUSTOMER_DISCOUNT: 'Ignora sconto cliente',
        ACTIVATE_AUTOMATIC_DISCOUNT: 'Attiva sconti automatici',
        ACTIVATE_CUSTOMER_DISCOUNT: 'Attiva sconto cliente',
        ACTIVATE_STORECHANNEL_DISCOUNT: 'Attiva sconti Invincibile',
        SKIP_STORECHANNEL_DISCOUNT: 'Ignora sconti invincibile',
        OPTIONS_ITEMS: 'Opzioni articoli',
        REMOVE_ITEMS: 'Rimuovi articoli',
        SET_MAXIMUM_QUANTITY: 'Imposta quantità massima',
        COMMERCIAL_AGREEMENT: 'Accordo commerciale',
        HANDLE_NOTE_BUTTON: 'Gestisci note',
        EDIT_ORDER_HEADER: 'Modifica intestazione ordine',
        CONFIRM_CART: 'Attivando questa opzione, tutti i carrelli inseriti nel file verranno automaticamente confermati e trasformati in ordini.',
        OPTIONS: 'Opzioni',
      },
      MODAL_CONFIRMATION_MAIL: {
        TITLE: 'Invia mail di conferma',
        SEND: 'Invia',
        ACTIVATE_MAIL: 'Inserisci destinatari personalizzati',
        TO: 'A',
        CC: 'CC',
        CCN: 'CCN',
        TOOLTIP_MSG: 'Se non inserisci destinatari personalizzati, la mail di conferma verrà inviata agli indirizzi di default',
        ADD: 'Aggiungi',
        SNACKBAR_MESSAGE: 'Il valore immesso non è un indirizzo di posta valido'
      },
      MODAL_ACTIVATE_AUTOMATIC_DISCOUNT: {
        TITLE: 'Attiva sconti automatici',
        DESCRIPTION: 'Sei sicuro? Continuando si attiveranno eventuali sconti automatici per il carrello corrente.'
      },
      MODAL_ACTIVATE_CUSTOMER_DISCOUNT: {
        TITLE: 'Attiva sconto cliente',
        DESCRIPTION: 'Sei sicuro? Continuando si attiverà l\'eventuale scontio cliente per il carrello corrente.'
      },
      MODAL_SKIP_AUTOMATIC_DISCOUNT: {
        TITLE: 'Ignora sconti automatici',
        DESCRIPTION: 'Sei sicuro? Continuando verranno ignorati eventuali sconti automatici per il carrello corrente.'
      },
      MODAL_SKIP_CUSTOMER_DISCOUNT: {
        TITLE: 'Ignora sconto cliente',
        DESCRIPTION: 'Sei sicuro? Continuando verrà ignorato l\'eventuale sconto cliente per il carrello corrente.'
      },
      MODAL_ACTIVATE_STORECHANNEL_DISCOUNT: {
        TITLE: 'Attiva sconti invincibile',
        DESCRIPTION: 'Sei sicuro? Continuando si attiveranno eventuali sconti invincibile (store-channel) per il carrello corrente.'
      },
      MODAL_SKIP_STORECHANNEL_DISCOUNT: {
        TITLE: 'Ignora sconti invincibile',
        DESCRIPTION: 'Sei sicuro? Continuando verranno ignorati eventuali sconti invincibile (store-channel) per il carrello corrente.'
      },
      SHOW_ONLY_UNAVAILABLE: 'Mostra solo articoli con quantità disponibile minore di quella richiesta',
      ADD_MANUAL_DISCOUNT_MANUAL: 'Inserisci % sconto aggiuntivo',
      ADD_MANUAL_DISCOUNT_CALCULATED: 'Calcola da % di sconto desiderata dal retail',
      ADD_MANUAL_DISCOUNT_CALCULATED2: 'Calcola da wholesale unitario desiderato',
      ADD_MANUAL_DISCOUNT_CALCULATED3: 'Calcola da % di margine desiderata',
      INSERT_PERCENTAGE: 'Inserisci percentuale',
      INSERT_DESIRED_WHOLESALE: 'Inserisci wholesale desiderato',
      HIDE_CANCELLED: 'Nascondi righe d\'ordine annullate',
      COMMERCIAL_DISCOUNT_APPLIED: 'Sconto commerciale applicato su {{orderItemsCount}} {{itemsTranslation}} d\'ordine',
      COMMERCIAL_DISCOUNT_INSUFFICIENT: 'Lo sconto inserito deve essere superiore allo sconto di default dal retail per gli articoli selezionati. Per applicare uno sconto inferiore a quello attuale, rimuovere prima lo sconto esistente e poi applicare quello nuovo.',
      ITEM: 'riga',
      ITEMS: 'righe',
      SOME_ORDERITEMS_HAS_NO_COST: 'Qualche articolo del carrello non ha costo specificato, quindi questa funzionalità non è disponibile',
      PENDING_OPERATION: 'Non puoi svolgere operazioni sul carrello in quanto ci sono caricamenti di righe d\'ordine tramite excel file in elaborazione.',
      PENDING_BULK_OPERATIONS: 'Questo ordine ha {{count}} operazioni in attesa.',
      CHOOSE_EXCEL_PROPS_TITLE: 'Scegli le proprietà',
      CHOOSE_EXCEL_PROPS: 'Scegli le colonne da visualizzare nel foglio dell\'excel dedicato alle righe d\'ordine',
      CHOOSE_DOWNLOAD_TYPE: 'Scegli il tipo di download',
      DOWNLOAD_TYPE_MESSAGE: 'Al termine del processo, riceverai un\'email al tuo indirizzo con il file allegato non appena sarà disponibile',
      CUSTOM_DATE: 'Data personalizzata',
      EDIT_CUSTOM_DATE: 'Personalizza data',
      NO_CUSTOM_DATE: 'Data non personalizzabile',
      SELECTED_ITEMS: 'righe d\'ordine selezionate',
      ALERT_CART_SHIPPING_COST: 'A questo carrello verranno applicati i costi di spedizione <strong>{{shippingCost}}</strong> (IVA esclusa); per averle gratuite devi aggiungere ancora <strong>{{threshold}}</strong>.',
      ALERT_CART_SHIPPING_COST_NO_COST: 'A questo carrello verranno applicati i costi di spedizione; per averle gratuite devi aggiungere ancora <strong>{{threshold}}</strong>.',
      ALERT_CART_SHIPPING_COST_WITH_VOUCHER: 'Se utilizzi un voucher, non ti saranno addebitate.',
      COLUMNS: {
        IMAGE: 'Immagine',
        NAME: 'Colonne',
        SKU: 'Sku',
        COLOR: 'Colore',
        COLOR_CODE: 'Code colore',
        COLOR_NAME: 'Nome colore',
        SIZE: 'Taglia',
        UNIT_WHOLESALE: 'Wholesale unit.',
        UNIT_RETAIL: 'Retail unit.',
        GENDER: 'Genere',
        UNIT_NET: 'Netto unit.',
        UNIT_COST: 'Costo unit.',
        UNIT_MARGIN: 'Margine unit.',
        TOTAL_RETAIL: 'Retail tot.',
        TOTAL_WHOLESALE: 'Wholesale tot.',
        TOTAL_NET: 'Netto tot.',
        TOTAL_COST: 'Costo tot.',
        TOTAL_MARGIN: 'Margine tot.',
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Sconto da retail',
        TOTAL_DISCOUNT_PERCENTAGE: 'Sconto da wholesale',
        CUSTOMER_DISCOUNT: 'Sconto cliente',
        AGREEMENT_DISCOUNT: 'Sconto accordo comm.',
        FINANCIAL_DISCOUNT: 'Sconto finanziario',
        STORECHANNEL_DISCOUNT: 'Sconto inv.',
        DISCOUNT_BY_QTY: 'Sconto by qty',
        DISCOUNT_BY_VALUE: 'Sconto by value',
        COMMERCIAL_DISCOUNT: 'Sconto commerciale',
        MARGIN_PERCENTAGE: 'Margin',
        QTY: 'Qty',
        EAN: 'EAN',
        SIZE_GROUP: 'Gruppo taglia',
        PRODUCT_CODE: 'Codice prodotto',
        PRODUCT_TITLE: 'Nome prodotto',
        DATE: 'Data',
        ORDERED_QTY: 'Qty ordinata',
        CANCELED_QTY: 'Qty annullata',
        NOT_FULFILLED_QTY: 'Qty non evasa',
        FULFILLED_QTY: 'Qty evasa',
        FULFILLMENT_STATUS: 'Stato consegna',
        GROUP_GENERAL: 'Generali',
        GROUP_UNITARY: 'Unitario (€)',
        GROUP_TOTALS: 'Totali (€)',
        GROUP_PERCENT: 'Percentuali (%)',
        GROUP_FULFILLMENT: 'Evasione',
        STYLE_GROUP: 'Style group',
        NOTE: 'Note',
        CUSTOMIZATION_REQUEST: 'Richiesta personalizzazione',
      },
    },
    REGISTRATION: {
      WELCOME: 'Benvenuto in',
      REGISTER_NEW: 'Registra un nuovo',
      BACK_TO_HOME: 'Indietro',
      LOGOUT: 'Logout',
      CUSTOMER: 'Cliente',
      CUSTOMER_INFO: 'Informazioni cliente',
      AGENCY: 'Agenzia',
      AGENCY_INFO: 'Informazioni agenzia',
      INFO_SETUP: 'Aggiungi informazioni generali',
      STEPPER: {
        REQUIRED_INFOTO_CREATE: 'Per creare un nuovo cliente senza mandarlo a ERP, le informazioni necessarie sono: ',
        REQUIRED_INFOTO_CREATE2: 'Numero Account (Tab: Info cliente), Nome Azienda (Tab: Info cliente), Conosciuto Come (Tab: Info cliente), Indirizzo di fatturazione (Tab: Info cliente), Email amministrativa (Tab: Info cliente), almeno punto vendita (Tab: Indirizzi spedizione). ',
        REQUIRED_INFOTO_CREATE3: 'Ricorda! Il punto vendita puoi crearlo direttamente dai dati di fatturazione e non verrà duplicato sull\'ERP. Dallo step Indirizzi spedizione potrai poi salvare i dati.',
        ADD_NEW: 'Aggiungi nuovo',
        CONTACT_INFO: 'Informazioni contatti',
        ADD_CONTACT_INFO: 'Aggiungi contatti',
        PAYMENT_INFO: 'Informazioni pagamento',
        ADD_PAYMENT_INFO: 'Aggiungi pagamento',
        POINT_OF_SALE: 'Punti vendita',
        NEW_POINT_OF_SALE: 'Nuovo punto vendita',
        ADD_POINT_OF_SALE: 'Aggiungi punto vendita',
        ENABLED_ONLINE_STORE: 'Online store attivi',
        USE_BILLING: 'Usa indirizzo di fatturazione',
        FINANCIAL_STATUS: 'Stato finanziario',
        COMPANY_FINANCIAL_STATUS: 'Stato finanziaro dell\'azienda',

        FINISH_REGISTRATION: 'Termina registrazione',
        FINISH_REGISTRATION_TEXT: 'Una volta inviata la richiesta di registrazione, questa verrà presa in carico.',
        SEND_REGISTRATION_REQUEST: 'Invia richiesta di registrazione',

        NEXT_STEP: 'Prossimo',
        PREV_STEP: 'Precedente',
        SEND_REQUEST: 'Manda richiesta',
        OWNER: 'Titolare',
        OWNER_SUB: 'Titolare dell\'azienda',
        SEND_USER_INVITATION: 'Manda e-mail d\'invito al titolare',
        POS_WITHOUT_STORE: 'Devi abilitare ogni punto vendita per almeno un negozio online ed un corrispettivo channel',
        FORWARDED_REQUEST: 'La tua richiesta è stata inoltrata al servizio clienti',
        USER: {
          EXISTING: 'Scegli un utente esistente',
          NEW: 'Crea un nuovo utente',
          SELECT_USER: 'Seleziona utente',
          EXISTING_EMAIL: 'E-mail già esistente'
        }
      }
    },
    PRODUCT_DETAIL: {
      IMAGES_VISIBILITY_ACTION: 'Nascondi immagini di questo prodotto',
      IMAGES_VISIBILITY_INFO: 'Attivando questa opzione, le immagini delle varianti del prodotto non verranno mostrate al cliente in nessuna sezione dell’app (come lista prodotti, pagina dettaglio o schermate di conferma ordine). L’impostazione ha priorità rispetto alla visibilità configurata per le singole immagini di variante, che puoi gestire nel dettaglio di ogni singola variante.',
      IMAGES_VISIBILITY: 'Visibilità immagini',
      BACK_TO_PRODUCTS_LIST: 'Torna all\'elenco dei prodotti',
      STYLE_CARD: 'Scheda prodotto',
      NAME: 'Nome',
      CODE: 'Codice',
      GENDER: 'Genere',
      DESCRIPTION: 'Descrizione',
      PRODUCT_DESCRIPTION: 'Descrizione prodotto',
      OPEN_IN_BULK: 'Apri nell\'editor varianti',
      COLOR: 'colore',
      COLORS: 'colori',
      SETTINGS_PRODUCT: 'Impostazioni di acquisto',
      SETTING_BASICKUSTOM: 'Impostazioni BasicKustom',
      MESSAGE_FOR_MAKE_PRODUCT_CUSTOMIZABLE: 'Per rendere questo prodotto personalizzabile, seleziona una palette di riferimento',
      MESSAGE_FOR_MAKE_PRODUCT_CUSTOMIZABLE_WITH_PLAYERS: 'Imposta questo flag se vuoi dare all\'utente la possibilità di aggiungere le informazioni relative ai giocatori su questo prodotto.',
      BUY_MULTIPLIER: 'Moltiplicatore di acquisto per i canali: {{channels}}',
      BUY_MINIMUM_PER_ORDER: 'Quantità di acquisto minima (per i canali di vendita che lo richiedono)',
      ADD_ORDER_ITEMS: 'Aggiungi articoli all’ordine',
      ORDER_ITEM_WITHOUT_WHOLESALE_PRICE: 'Attenzione! Alcune varianti selezionate non possiedono un prezzo wholesale definito e non potranno essere aggiunte.',
      VARIANTS: {
        NAME: 'Varianti',
        COLUMNS: {
          VARIANT: 'Variante',
          QTY: 'Quantità',
          NEW_QTY: 'Nuova quantità',
          SKU: 'Sku',
          WHOLE_SALE: 'Wholesale',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
        }
      },
      IMPORT_STATUS: {
        NAME: 'Stato dell\'importazione',
        START: 'Inizio',
        END: 'Fine',
        ERROR: 'Si è presentato il seguente errore: ',
        RESTART_IMPORT: 'Riavvia importazione',
        MODAL_TEXT: 'Attenzione! Tutti i cambiamenti relativi questo prodotto e le sue varianti andranno persi. Sei sicuro?',
        RETAIL_DISCOUNT_PERCENTAGE: '% di sconto da retail',
        LAST_RETAIL_DISCOUNT_PERCENTAGE: 'Ultimo sconto base utilizzato'
      },
      MODAL_DELETE: {
        ARE_YOU_SURE: 'Sei sicuro?',
        ARE_YOU_SURE_TO_REMOVE_STOCK_LIMIT: 'Sei sicuro di voler rimuovere il limite di stock',
        ARE_YOU_SURE_TO_REMOVE_MINIMUM_PRE_ORDER: 'Sei sicuro di voler rimuovere il minimo pre-order',
        ARE_YOU_SURE_TO_REMOVE_MINIMUM_RE_ORDER: 'Sei sicuro di voler rimuovere il minimo re-order',
        ARE_YOU_SURE_TO_REMOVE_ALL_LIMITS: 'Sei sicuro di voler rimuovere tutti i limiti',
        FOR: 'per',
        STYLE_COLOR: 'colore ?',
        STYLE_COLORS: 'colori ?',
      },

      SETTING_LIMIT: 'Impostazione vincoli',
      SETTING_STOCK_LIMIT: 'Impostazione limite di stock',
      SETTING_MINIMUM_PRE_ORDER: 'Impostazione minimo pre-order',
      SETTING_MINIMUM_RE_ORDER: 'Impostazione minimo re-order',
      ADD_OR_EDIT_STOCK_LIMIT: 'Aggiungi/modifica limite di stock',
      ADD_OR_EDIT_MINIMUM_PRE_ORDER: 'Aggiungi/modifica minimo pre-order',
      ADD_OR_EDIT_MINIMUM_RE_ORDER: 'Aggiungi/modifica minimo re-order',
      REMOVE_STOCK_LIMIT: 'Rimuovi limite di stock',
      REMOVE_MINIMUM_PRE_ORDER: 'Rimuovi minimo pre-order',
      REMOVE_MINIMUM_RE_ORDER: 'Rimuovi minimo re-order',
      REMOVE_ALL_LIMITS: 'Rimuovi tutti i limiti',
      MODAL_LIMIT: {
        STOCK_LIMIT: 'Limite stock',
        MINIMUM_QTY_PRE_ORDER: 'Minimo pre-order',
        MINIMUM_QTY_RE_ORDER: 'Minimo re-order',
        SETTING_STOCK_LIMIT: 'Impostazione limite di stock',
        SETTING_MINIMUM_PRE_ORDER: 'Impostazione minimo pre-order',
        SETTING_MINIMUM_RE_ORDER: 'Impostazione minimo re-order',
        LIMIT_ENABLED_FOR_CHANNELS: 'Limite abilitato per i canali: {{channels}}',
        THE_QUANTITY_INSERTED_IS_NOT_VALID_MINIMUM_VALUE_IS_TWO: 'La quantità inserita non è valida, il valore minimo è 2',
      },
    },
    PRODUCT_AND_VARIANT: {
      REORDER: 'Riordina',
    },
    TAG_MANAGER: {
      NAME: 'Gestione tag',
    },
    MEDIA_CONTAINER: {
      START_SYNC: 'Avvia sync immagini',
      NAME: 'Media',
      VISIBLE_IMAGE: 'Immagine visibile',
      SET_AS_COVER: 'Imposta come copertina',
      NO_MEDIA_TO_VIEW: 'Nessun media da visualizzare',
      UPLOAD_MEDIA: 'Carica media',
      SHOW_ALL_MEDIA: 'Mostra tutti i media',
      HIDE_ALL_MEDIA: 'Nascondi tutti i media',
    },
    BULK_MEDIA_EDIT: {
      SHOW: 'Mostra',
      HIDE: 'Nascondi',
      INFO: 'Mostra o nascondi tutti i media (prodotto e varianti)',
      NO_PRODUCT_SELECTED: 'Nessun prodotto selezionato',
      MESSAGE_SUCCESS_HIDE_1: 'Tutte le immagini dei prodotti selezionati sono state rese invisibili',
      MESSAGE_SUCCESS_VISIBILE_1: 'Tutte le immagini dei prodotti selezionati sono state rese visibili',
      MESSAGE_SUCCESS_VISIBILE_2: 'Tutte le immagini del prodotto e delle varianti sono state rese visibili',
      MESSAGE_SUCCESS_HIDE_2: 'Tutte le immagini del prodotto e le varianti sono state rese invisibili',
    },
    VARIANT_DETAIL: {
      BACK_TO_PRODUCT_DETAIL: 'Torna al dettaglio del prodotto',
      VARIANT: 'Variante',
      SELECT_VARIANT: 'Seleziona variante',
      COLOR: 'Colore',
      SIZE: 'Taglia',
      SKU_CODE: 'Codice SKU',
      EAN_CODE: 'Codice EAN',
      AVAILABLE_QTY: 'Quantità in stock',
      COST: 'Costo',
      BLANK_CELLS_SETTINGS: 'Impostazioni celle bianche',
      BLANK_CELLS_END_DATE: 'Data di fine celle bianche',
      BLANK_CELLS_DELIVERY_DATE: 'Data di consegna celle bianche',
      TIERING: 'Tiering',
      TIER_DESCRIPTION: 'Seleziona i tier per i quali è disponibile il prodotto:',
      EXTERNAL_COLLECTIONS_ID: 'ID collezioni esterne',
      FROM: 'Da',
      TO: 'A',
      DETAIL: 'Dettaglio',
      LABELS: 'Etichette',
      PURPOSES: 'Scopi',
      TEAMS: 'Squadre',
      CATEGORIES: 'Categorie',
      PRICING: 'Prezzi',
      RE_ORDER: 'Re-order',
      PRE_ORDER: 'Pre-order',
      WHOLE_SALE_PRICE_NO_VAT: 'Prezzo wholesale (senza IVA)',
      SUGGESTED_RETAIL_PRICE_VAT: 'Prezzo retail suggerito (con IVA)',
      PERCENTAGE_DISCOUNT_OF_RETAIL: '% di sconto da retail',
    },
    VISIBILITY: {
      NAME: 'Visibilità',
      PUBLISH_ON_PRE_ORDER: 'Pubblica su pre-order',
      PUBLISH_ON_RE_ORDER: 'Pubblica su re-order',
      BLOCK_AUTOMATIC_PUBLISH_ON_RE_ORDER: 'Blocca pubblicazione automaticamente su re-order',
      AUTOMATIC_PUBLISH_DESCRIBE: 'Se disattivato, quando la variante avrà quantità re-order disponibile, verrà pubblicata automaticamente'
    },
    ASSORTMENT_DETAIL: {
      NAME: 'Assortimento',
      BACK_TO_ASSORTMENTS: 'Torna agli assortimenti',
      ASSORTMENT_CARD: 'Scheda assortimento',
      ASSORTMENT_NAME: 'Nome',
      ID: 'ID',
      EDIT_ORDER: 'Modifica ordine',
      DESCRIPTION: 'Descrizione (opzionale)',
      TIERING: 'Tiering',
      TIER_DESCRIPTION: 'Seleziona i tier per i quali è disponibile l\'assortimento:',
      CHANNEL: 'Canale',
      SELECT_THE_CHANNEL_FIRST: 'Seleziona prima il canale',
      CHANNEL_DESCRIPTION: 'Seleziona i canali per i quali è disponibile l\'assortimento:',
      INCLUDE_PRODUCTS: {
        NAME: 'Includi prodotti',
        MANUAL: 'Manuale (statico)',
        AUTOMATED: 'Automatico (dinamico)',
        PROPERTY: {
          CODE: 'Codice',
          SIZE: 'Taglia',
          COLOR: 'Colore',
          TIER: 'Tier',
          PRICE: 'Prezzo',
          BRAND: 'Marca',
          GENDER: 'Genere',
          SEASON: 'Stagione',
          TAG: 'Tag',
          CATEGORY: 'Categoria',
          LABEL: 'Label',
          EXTERNAL_COLLECTION_ID: 'ID collezione esterna',
          PRODUCT_CODE: 'Codice prodotto',
        },
        OPERATOR: {
          EQUALS: 'Uguale',
          NOT_EQUALS: 'Non uguale',
          GREATER_THAN: 'Maggiore di',
          LESS_THAN: 'Minore di',
          GREATER_OR_EQUAL: 'Maggiore o uguale',
          LESS_OR_EQUAL: 'Minore o uguale',
          CONTAINS: 'Contiene',
          NOT_CONTAINS: 'Non contiene',
          STARTS_WITH: 'Inizia con',
          ENDS_WITH: 'Termina con',
        },
        GENDER: {
          MAN: 'Uomo',
          WOMAN: 'Donna',
          UNISEX: 'Unisex'
        }
      },
      ASSORTMENT_PRODUCTS: 'Prodotti dell\'assortimento',
      ASSORTMENT_INFO_1: 'L\'ordine di questo elenco influisce sul modo in cui i prodotti vengono visualizzati nell\'elenco dei prodotti 4Shop. ',
      ASSORTMENT_INFO_2: 'Per modificare l\'ordine dei prodotti, devi prima salvare le modifiche alle varianti dell\'assortimento, incluse le regole automatiche dell\'assortimento.',
      UNDO_PRODUCTS_ORDER: 'Annulla ordine prodotti',
      SAVE_PRODUCTS_ORDER: 'Salva ordine prodotti',
      FEATURED: 'In evidenza',
      ORDER: 'Ordine',
      MANAGE_ORDER_TITLE: 'Gestisci Ordine Assortimenti',
      MANAGE_ORDER_DESCRIPTION: 'Trascina gli assortimenti per riordinarli oppure modifica i valori nella vista lista.',
      LIST_VIEW: 'Lista',
      DRAG_VIEW: 'Trascina',
      SAVE_ORDER: 'Salva Ordine',
      SELECT_CHANNEL_TO_MANAGE: 'Seleziona un canale per gestire l\'ordine degli assortimenti',
      MANAGE_ORDER_SAVE_SUCCESS: 'Ordine assortimenti salvato con successo',
      SELECT_CHANNEL_FIRST: 'Seleziona prima un filtro canale',
      SELECTED: 'selezionati',
      REORDER: 'Riordina',
      REORDER_TITLE: 'Riordina Assortimenti',
      DUPLICATE_ORDER_WARNING: 'Due o più assortimenti hanno lo stesso valore di ordine. Correggi prima di salvare.',
      SEARCH_ASSORTMENT: 'Cerca assortimento...',
      MANAGE_MODAL_SELECT_DESCRIPTION: 'Seleziona gli assortimenti che vuoi riordinare per questo canale',
      CLEAR_ALL_ORDERS: 'Rimuovi tutti gli ordini',
    },
    AUTOMATED_INCLUDES: {
      ALL_CONDITION: 'Tutte le condizioni',
      ANY_CONDITION: 'Qualsiasi condizione',
      PROPERTY: 'Proprietà',
      OPERATOR: 'Operatore',
      VALUE: 'Valore',
    },
    BULK_EDITOR_DETAIL: {
      CHOOSE_PROPS: 'Scegli le proprietà da modificare',
      BACK_TO_SELECT_VARIANTS: 'Torna alla selezione delle varianti',
      EDIT_INFO: 'Puoi modificare più varianti contemporaneamente selezionandole. Tieni premuto il pulsante Maiusc per selezionare più velocemente gruppi di varianti.',
      COLUMNS: {
        COLOR: 'Colore',
        SIZE: 'Taglia',
        SKU: 'SKU',
        RE_ORDER: 'Re-order',
        PRE_ORDER: 'Pre-order',
        AUTO_RE_ORDER: 'Blocca re-order automatico',
        BLANK_CELLS_END: 'Data di fine celle bianche',
        BLANK_CELLS_DELIVERY: 'Data di consegna celle bianche',
        TAGS: 'Etichette',
        TIERS: 'Tiers',
        PRICES: 'Prezzi',
      },
      RECAP_MODAL: {
        TITLE: 'Conferma modifiche',
        MESSAGE: 'Stai per aggiornare {{count}} varianti. Controlla le modifiche qui sotto prima di salvare.',
        NO_CHANGES: 'Nessuna modifica rilevata.',
        VARIANTS: 'varianti',
        CHANGE: 'Modifica',
      },
    },
    SUPER_BULK_EDITOR_DETAIL: {
      CREATE_OPERATION: 'Crea operazione',
      MANUAL_CODE: 'Manuale',
      AUTO_CODE_BY_ASSORTMENT: 'Per assortimento',
      LIST_OPERATION: 'Lista operazioni',
      SELECT_THE_TYPE_OF_CODE: 'Seleziona la tipologia dei codici',
      SELECT_TYPE_OF_CODE_DESC: 'In questa sezione selezioni la tipologia dei codici che inserirai per ricavare la lista di varianti su cui effettuare le operazioni',
      BEFORE_SELECT_THE_TYPE_OF_CODE: 'Seleziona prima la tipologia dei codici',
      INSERT_CODES: 'Inserisci i codici',
      INSERT_CODES_DESC: 'In questa sezione inserisci una lista di codici in base alla tipologia precedentemente selezionata, separandoli con un ";" o andando a capo per ogni codice',
      REPORT_VALIDATION: 'Report di validazione',
      BEFORE_INSERT_CODES_AND_VALIDATED: 'Inserisci prima i codici e valida',
      TOTAL_VARIANTS_INVOLVED: 'Totale varianti coinvolte',
      CREATE_OPERATION_DESC: 'In questa sezione scegli l\'operazione che verrà eseguita sulla lista di varianti coinvolte',
      SELECT_OPERATION: 'Seleziona l\'operazione',

      CODE_TYPE: {
        BASIC_COLLECTION: 'Collezione',
        PRODUCT_CODE: 'Codice prodotto',
        PRODUCT_TEAM: 'Team del prodotto',
        PRODUCT_COLOR: 'Colore del prodotto',
        SKU_CODE: 'Codice SKU',
      },

      CODE_TYPE_TOOLTIP: {
        BASIC_COLLECTION: 'ID collezione base, Es. 12345',
        PRODUCT_CODE: 'Codice prodotto, i primi 7 caratteri del codice SKU, Es. 35124DW',
        PRODUCT_TEAM: 'Codice del team prodotto, i primi 10 caratteri del codice SKU, Es. 35124DWACF o 35124DW***',
        PRODUCT_COLOR: 'Codice colore del prodotto, i primi 13 caratteri del codice SKU, Es. 35124DW***A00 o 35124DW A00',
        SKU_CODE: 'Codice SKU, Es. 35124DW***A00L***** o 35124DW A00L',
      },

      REPORT_VALIDATION_MODAL: {
        TITLE: 'Report di validazione',
        VALIDATING: 'Validazione in corso...',
        ALERT_MESSAGE: 'Alcuni codici inseriti non risultano corretti ({{numberOfCodesInvalid}}), per poter proseguire rimuovili o correggili'
      },

      COLUMNS: {
        CODE: 'Codice',
        VARIANTS_NUMBER: 'Numero varianti',
        STATUS: 'Stato',
        INSERTED: 'Inseriti',
        INTERPRETED: 'Interpretati',
      },
      BUTTONS: {
        EDIT_CODES: 'Modifica codici',
        UNDO_EDITS: 'Annulla modifiche',
        ADD_ROW: 'Aggiungi riga',
        VALIDATE: 'Valida',
      },

      ALERT: {
        NO_VARIANTS_FOUND_PLEASE_CHECK_THE_CODES: 'Nessuna variante trovata, controlla i codici inseriti',
        OPERATION_CREATED_SUCCESSFULLY: 'Operazione #{{operationId}} creata con successo',
      },

      OPERATION_LABELS: {
        VISIBLE_IN_RE_ORDER: 'Visibile in re-order',
        VISIBLE_IN_PRE_ORDER: 'Visibile in pre-order',
        BLOCK_AUTOMATIC_PUBLISH_ON_RE_ORDER: 'Blocca pubblicazione automatica su re-order',
        BLANK_CELLS_END_DATE: 'Data di fine celle bianche',
        BLANK_CELLS_DELIVERY_DATE: 'Data di consegna celle bianche',
        INCLUDE_IN_TIER: 'Includi in tier',
        EXCLUDE_FROM_TIER: 'Escludi da tier',
        INCLUDE_IN_ASSORTMENT: 'Includi in assortment',
        EXCLUDE_FROM_ASSORTMENT: 'Escludi da assortment',
        INCLUDE_IN_PROMOTION: 'Includi in promozione',
        EXCLUDE_FROM_PROMOTION: 'Escludi da promozione',
        PALETTES_STOCK_LIMITS: 'Stock limit impostato: '
      },

      DETAIL_OPERATION_MODAL: {
        TITLE: 'Dettaglio operazione #{{operationId}}',
        MESSAGE: 'L\'<strong>operazione #{{operationId}}</strong> creato da <strong>{{userName}}</strong> in data <strong> {{date}}</strong> è in stato: <strong>{{status}}</strong > ',
        OPERATION_REQUESTED: 'Operazione richiesta: ',
        ERROR_FOUND: 'Errore riscontrato: ',
        ERRORS_FOUND: 'Errori riscontrati: ',

        COLUMNS: {
          VARIANT_SKU: 'SKU variante',
          ERRORS: 'Errori',
        },
      },
    },
    SUPPORT_BUTTON: {
      LABEL: 'ASSISTENZA',
      TITLE: 'Compila i campi per inviare una richiesta di supporto',
      SUCCESS_MESSAGE: 'Richiesta inviata con successo!',
      OBJECT: 'Oggetto',
      MESSAGE_BODY: 'Messaggio',
      BROWSE_FILE: 'Cerca...',
      FEEDBACK_MESSAGE_0: 'Ticket creato con identificativo #',
      FEEDBACK_MESSAGE: 'Risponderemo alla richiesta con una mail a',
      SEND_REQUEST: 'Invia richiesta',
      CHOOSE_FILE: 'Scegli un file',
    },
    PROMOTION_DETAIL: {
      NAME: 'Sconto automatico',
      EVALUATE_REQUIREMENTS_CONSIDERING_ENTIRE_ORDER: 'Valuta requisiti considerando l\'intero ordine',
      NEW_PROMOTION: 'Nuovo sconto automatico',
      BACK_TO_PROMOTIONS: 'Torna agli sconti automatici',
      PROMOTION_NAME: 'Nome',
      CODE: 'Codice',
      VALIDITY: 'Validità',
      VALID_FROM: 'Valido da',
      VALID_UNTIL: 'Valido fino a',
      VALID_ON: 'Valido su',
      REQUIREMENTS_AND_DISCOUNT: 'Requisiti e sconto',
      MINIMUM_QUANTITY: 'Quantità minima',
      MINIMUM_VALUE: 'Valore minimo',
      FROM: 'Da',
      TO: 'A',
      DISCOUNT: 'Sconto',
      INCLUDE_VARIANTS: 'Includi varianti',
      INCLUDED_VARIANTS: 'Varianti incluse',
      MESSAGE: 'Qualche variante non può essere selezionata perchè già presente in un\'altra promozione dello stesso tipo',
      VARIANTS: 'Varianti',
      ERROR_APPLICATION_RANGE: {
        RANGE_IS_INCORRECT_FROM_MUST_BE_LESS_THAN_TO: 'Il range è incorretto, "Da" deve essere minore di "A"',
        THE_INTERVAL_OVERLAPS_WITH_ANOTHER_INTERVAL: 'L\'intervallo si sovrappone ad un altro intervallo',
        THE_VALUE_FRO_THE_DISCOUNT_MUST_BE_BETWEEN_1_AND_100: 'Il valore per lo sconto deve essere compreso tra 1 e 100',
        THE_VALUE_FOR_TO_MUST_BE_GREATER_THAN_0_OR_EMPTY: 'Il valore per "A" deve essere maggiore di 0 o vuoto',
      },
      INFO_APPLICATION_RANGE: {
        THIS_INPUT_WHITEOUT_VALUE_WILL_BE_CONSIDERED_AS_INFINITY: 'Questo input senza valore sarà considerato come infinito',
      },
    },
    VOUCHER_DETAIL: {
      NAME: 'Voucher',
      NEW_VOUCHER: 'Nuovo voucher',
      NEW_VOUCHER_FOR: 'Nuovo voucher per',
      BACK_TO_VOUCHERS: 'Torna ai vouchers',
      VOUCHER_NAME: 'Nome',
      VALIDITY: 'Validità',
      CUSTOMER_TO_APPLY: 'Clienti a cui assegnare il voucher',
      CUSTOMER_APPLIED: 'Clienti a cui è stato assegnato il voucher',
      ADD_CUSTOMER: 'Aggiungi cliente',
      CUSTOMER: 'Cliente',
      SELECTED: 'Selezionato',
      DESELECT_ALL: 'Deseleziona tutto',
      NO_CUSTOMER_SELECTED: 'Nessun cliente selezionato',
      EXPIRED_VOUCHER: 'Il voucher selezionato è scaduto!',
      EDIT_DESCRIPTION: 'Modifica descrizione',
      RESIDUAL_AMOUNT: 'Importo residuo',
      SELECT_AT_LEAST_ONE_CUSTOMER: 'Seleziona almeno un cliente',
      FILL_IN_ALL_REQUIRED_FIELDS: 'Compila tutti i campi obbligatori',
      CHANGE_VOUCHER: 'Cambia voucher',
      APPLICABLE_AS_PARTIAL_PAYMENT: 'Applicabile come pagamento parziale',
      APPLICABLE_AS_PARTIAL_PAYMENT_MESSAGE: 'Se abilitato, il voucher sarà applicabile ad un ordine anche se il suo importo residuo non può coprire il totale wholesale scontato dell\'ordine.',
    },
    ASSIGN_VOUCHER: {
      SELECT_VOUCHER: 'Seleziona il voucher che vuoi applicare all\'ordine',
      SELECTION_MESSAGE: 'Applicando questo voucher, il totale dell\'ordine è ',
    },
    AGENCY_DETAIL: {
      TABS: {
        SUMMARY: 'Sintesi',
        CHECK_IN: 'Check-in',
        CUSTOMERS: 'Clienti',
        ORDERS: 'Ordini',
        AGENTS: 'Agenti',
      },
      PLEASE_INSERT_AGENCY_CODE_FOR_ALL_ACTIVE_STORES: 'Inserisci il codice agenzia per tutti i negozi attivi',
      AGENCY_CODES: 'Codici agenzia',
      BACK_TO_AGENCIES: 'Torna alle agenzie',
      AGENCY_INFORMATION: 'Informazioni agenzia',
      VAT: 'P.IVA',
      FISCAL_CODE: 'Codice fiscale',
      AGENCY_CODE: 'Codice agenzia',
      AGENCY_NAME: 'Nome agenzia',
      AGENCY_FORM: 'Forma agenzia',
      CANT_EDIT: {
        MESSAGE: 'Non puoi modificare le informazioni sull\'agenzia perché è in attesa di approvazione!',
      },
      SEND_TO_ERP: 'Invia a ERP',
      CONTACT_INFO: 'Informazioni di contatto',
      MODAL_ERP: {
        ARE_YOU_SURE: 'Sei sicuro?',
        ARE_YOU_SURE_YOU_WANT_TOSEND_TO_ERP: 'Sei sicuro di voler inviare a ERP?',
        SEND: 'Invia',
      }
    },
    ADDRESS_INFO: {
      SEARCH: 'Cerca',
      ADDRESS: 'Indirizzo',
      ALTERNATIVE_ADDRESS: 'Indirizzo alternativo',
      LABEL: 'Cerca indirizzo',
      BILLING_LABEL: 'Cerca indirizzo di fatturazione',
      STREET: 'Via',
      NUMBER: 'Numero',
      COUNTRY: 'Paese',
      PROVINCE: 'Provincia',
      CITY: 'Città',
      ZIP_CODE: 'CAP',
    },
    CONTACT_INFO: {
      DELETE_MODAL: {
        ARE_YOU_SURE: 'Sei sicuro?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: 'Sei sicuro di voler eliminare questo contatto?',
        DELETE: 'Elimina',
      },

      ADD_MODAL: {
        TITLE: 'Aggiungi contatto',
        TYPE: 'Tipo',
      },

      EDIT_MODAL: {
        TITLE: 'Modifica contatto',
      },

      INVALID_VALUE: 'Valore non valido per il tipo di contatto selezionato',

      CONTACT_TYPE: {
        ADMINISTRATIVE: 'Amministrativo',
        COMMERCIAL: 'Commerciale',
        EMAIL: 'Email',
        PEC: 'PEC',
        PHONE: 'Telefono',
        FAX: 'Fax',
        MOBILE: 'Cellulare',
        WEBSITE: 'Sito web',
        SOCIAL: 'Social',
        FACEBOOK: 'Facebook',
        TWITTER: 'Twitter',
        INSTAGRAM: 'Instagram',
        LINKEDIN: 'Linkedin',
      }
    },
    CUSTOMER_DETAIL: {
      BACK_TO_CUSTOMERS: 'Torna ai clienti',
      TABS: {
        SUMMARY: 'Summary',
        CHECK_IN: 'Check-in',
        LOCATIONS: 'Indirizzi',
        ORDERS: 'Ordini',
        DISCOUNTS: 'Sconti',
        USERS: 'Utenti',
        VOUCHERS: 'Vouchers',
        SETTINGS: 'Impostazioni',
      },

      ALLERT: {
        MESSAGE: 'Non puoi modificare le informazioni sul cliente perché è in attesa di approvazione!',
      },

      SEND_TO_ERP: 'Invia a ERP',

      CARDS: {
        COMPANY_INFO: 'Informazioni azienda',
        CONTACT_INFO: 'Informazioni contatto',
        COMPANY_FINANCIAL_STATUS: 'Stato finanziario',
        PAYMENT_INFO: 'Informazioni pagamento',
        COMMERCIAL_AGREEMENT: 'Accordo commerciale',
        CUSTOMER_DISCOUNT: 'Sconto cliente',
        CUSTOMER_COMMERCIAL_BLOCK: 'Blocco amministrativo cliente',
        BASIC_KUSTOM_DISCOUNT: 'Sconto kustom basic',
      },

      STATUS: {
        COMPLETED: 'Completato',
        NOT_COMPLETED: 'Non completato',
      },

      MODAL_ERP: {
        ARE_YOU_SURE_YOU_WANT_TO_SEND_TO_ERP: 'Sei sicuro di voler inviare a ERP?',
        MESSAGE: 'Confermando l’anagrafica verrà salvata e trasmessa ad ERP',
        SEND: 'Invia',
      },

      MODAL_SAVE: {
        ARE_YOU_SURE: 'Sei sicuro?',
        MESSAGE: 'Attenzione! salvando la modifica al cliente, verrà impostato con stato “da approvare”',
      },

      COMPANY_INFO: {
        PREFIX_VAT: 'Prefisso P.IVA',
        VAT_WHITHOUT_PREFIX: 'P.IVA senza prefisso',
        FISCAL_CODE: 'Codice fiscale',
        COMPANY_NAME: 'Nome azienda',
        AUTOCOMPLETE: 'Autocompletamento',
        COMPANY_FORM: 'Forma aziendale',
        COMPANY_CATEGORIES: 'Categorie aziendali',
        ITALIAN_DIGITAL_INVOICING_SYSTEM: 'Sistema elettronico fiscale italiano',
        SDI_CODE: 'Codice SDI',
        OFFICE_PA_CODE: 'Codice PA',
        PEC_EMAIL: 'PEC email',
        ERROR_YOU_CAN_NOT_ENTER_BOTH_PA_CODE_AND_SDI_CODE: 'Non puoi inserire contemporaneamente il codice PA e SDI',
        ERROR_CODE_MUST_BE_ALPHANUMERIC_CHARACTERS_WITHOUT_SPACES_AND_SPECIAL_CHARACTERS: 'Il codice {{codeName}} deve essere composto da {{numCharacters}} caratteri alfanumerici senza spazi e caratteri speciali',
      },

      FINANCIAL_STATUS: {
        ENTERPRISE_BOOL: 'Impresa attiva',
        MASTER_DATA_BOOL: 'Anagrafica corretta',
        ACTIVITY_BOOL: 'Attività conforme',
        REQUEST_NEW_REPORT: 'Richiedi nuovo rapporto',
        NO_DATA_TO_SHOW: 'Nessun rapporto esistente, richiedi un nuovo rapporto cliccando il pulsante sottostante',
        COLUMNS: {
          DATE: 'Data',
          CLASS: 'Classe',
          RISK_DESCRIPTION: 'Descrizione rischio',
          CREDIT_LIMIT: 'Limite credito',
          SCORE: 'Punteggio',
          REPORT: 'Rapporto',
        },
        REFRESH_MODAL: {
          ARE_YOU_SURE: 'Sei sicuro?',
          EACH_REFRESH_HAS_A_COST: 'Ogni aggiornamento ha un costo',
          REFRESH: 'Aggiorna',
        },
        PRINT: 'Stampa',
        SHARE: 'Condividi',
        VIEW_REPORT: 'Visualizza rapporto',
      },

      PAYMENT_INFO: {
        CHANNEL_PAYMENTS_TERM_INFO: 'Qui puoi aggiungere un termine di pagamento specifico per ogni canale di vendita. Se non viene specificato un termine di pagamento per un canale, verrà utilizzato il termine di pagamento predefinito.',
        ADD_PAYMENT_TERM: 'Aggiungi termine di pagamento',
        CHANNEL_PAYMENTS_TERM: 'Termini di pagamento per canale',
        PAYMENT_TERM: 'Termini di pagamento',
        DEFAULT_PAYMENT_TERM: 'Termine di pagamento predefinito',
        CHANNEL: 'Canale',
        BANCK_INFO: 'Informazioni bancarie',
        ABI: 'ABI',
        CAB: 'CAB',
        SWIFT: 'SWIFT',
      },

      COMMERCIAL_AGREEMENT: {
        COMMERCIAL_ALLOWANCE: 'Spesa commerciale',
      },

      COMMERCIAL_BLOCK: {
        COMMERCIAL_BLOCK: 'Blocco amministrativo',
        INFO: 'Attivando il blocco amministrativo sul cliente, nessuno tranne gli utenti con ruolo storeOwner, storeUser e admin potrà confermare il carrello.',
        BLOCKED_BY: 'Bloccato da: {{name}}',
        ALERT_COMMERCIAL_BLOCK_FROM_ERP: 'Questo blocco amministrativo è stato recepito dall\'erp',
      },
    },
    STATUS_LABLE: {
      CREATED_ON: 'Creato il',
      BY: 'Da',
      LAST_UPDATE_ON: 'Ultimo aggiornamento il',
      STATUS: 'Stato',
      FOR_CURRENT_STORE: 'per lo store corrente',
    },
    STATUS: {
      ALL: 'Tutti',
      ENABLED: 'Attivo',
      GOK: 'GOK',
      IS_DIRECT: 'Ordine diretto',
      NOT_GOK: 'Non GOK',
      VALID: 'Valido',
      INVALID: 'Non valido',
      TOAPPROVE: 'Da approvare',
      APPROVED: 'Approvato',
      APPROVED_BY_REQUESTING_USER: 'Approvato dal richiedente',
      APPROVED_GRAPHICALLY: 'Approvato graficamente',
      REJECTED: 'Rifiutato',
      ORDERED: 'Ordinato',
      EVO: 'Evo',
      SUBLI: 'Subli',
      COMMERCIALBLOCKED: 'Bloccato',
      BLOCKED: 'Bloccato',
      PARTIALLY_FULFILLED: 'Parzialmente evaso',
      ONHOLD: 'In attesa',
      BILLING: 'Fatturazione',
      SHIPPING: 'Spedizione',
      CUSTOMER: 'Cliente',
      AGENCY: 'Agenzia',
      ADMIN: 'Amministrativo',
      UNASSIGNED: 'Non assegnato',
      ACTIVE: 'Attivo',
      INVITED: 'Invitato',
      DISABLED: 'Disabilitato',
      DRAFT: 'Bozza',
      DRAFT_WITHOUT_NOTIFICATION: 'Bozza',
      DRAFT_WITH_NOTIFICATION: 'Bozza con notifica',
      CREATED: 'Creato',
      CONFIRMED: 'Pronto per l\'evasione',
      FAILED: 'Fallito',
      RE_ORDER: 'Re-order',
      RESTOCK: 'Riassortimento',
      ITEMEXCHANGE: 'Cambio merce',
      PRE_ORDER: 'Pre-order',
      BY_VALUE: 'Per valore',
      BY_QUANTITY: 'Per quantità',
      BOTH: 'Entrambi',
      EXTERNAL_ID: 'ID esterno',
      UNCONSTRAINED: 'Senza vincolo',
      BY_ORDER_TOTAL_AMOUNT: 'Spesa minima',
      BY_ORDER_TOTAL_QUANTITY: 'Quantità minima',
      DELIVERED: 'Consegnato',
      SHIPPED: 'Spedito',
      PENDING: 'In attesa',
      CANCELLED: 'Annullato',
      CONCLUDED: 'Evaso',
      PARTIAL: 'Parziale',
      EXPIRED: 'Scaduto',
      INACTIVE: 'Inattivo',
      AWAITING_PROCESSING: 'In attesa di elaborazione',
      TO_BE_PROCESSED: 'Da elaborare',
      PROCESSING: 'In elaborazione',
      PROCESSED: 'Elaborato',
      PROCESSED_WITH_ERRORS: 'Elaborato con errori',
      PROCESSED_WITH_ISSUES: 'Elaborato con problemi',
      PROCESSING_FAILURE: 'Elaborazione fallita',
      ARCHIVED: 'Archiviato',
      SYNCING: 'In sincronizzazione',
      SINGLE_ORDER: 'Ordine singolo',
      MULTIPLE_ORDERS: 'Ordini multipli',
    },
    PROJECT_TYPE: {
      ALL: 'Tutti',
      SUBLI: 'Subli',
      EVO: 'Evo',
    },
    CHANGES_HANDLER: {
      DATE_UNSAVE_CHANGES: 'Le modifiche non sono state salvate',
      UNDO: 'Annulla',
      SAVE: 'Salva',
      IF_YOU_HAVE_PENDING_CHANGES_YOU_WILL_LOSE_THEM: 'Se hai modifiche in sospeso, perderai le modifiche',
    },
    CART: {
      ERROR_DIALOG: {
        TITLE: 'Articoli non disponibili',
        UPDATE_DATES: 'Aggiorna date',
        UPDATE_DATES2: 'Aggiorna date e rimuovi varianti non disponibili',
        UPDATE_DATES3: 'Aggiorna solo le date',
        UPDATE_DATES4: 'Aggiorna le date e rimuovi varianti non disponibili',
        INVALID_DATES: 'Date non valide',
        VARIANT_UNAVAILABLE: 'Varianti non disponibili',
        DELETE_ITEMS: 'Rimuovi non disponibili',
        LIMIT: 'Limite',
        STOCK_QTY: 'Qty stock',
        ORDERED_QTY: 'Qty ordinata',
        AVAILABLE_QTY: 'Qty disponibile',
        CART_QTY: 'Qty nel carrello',
        POS_LIMIT: 'Limite del punto vendita',
        SKU: 'Sku code',
        COLOR: 'Colore',
        PRODUCT: 'Prodotto',
        SIZE: 'Taglia',
        NEW_DATE: 'Nuova data',
        MESSAGE1: 'I seguenti articoli non sono più disponibili per la data di consegna richiesta ma sono disponibili per una nuova data.',
        MESSAGE1_REORDER: 'I seguenti articoli hanno data di sconsegna scaduta.',
        MESSAGE1_REORDER2: 'I seguenti articoli non sono più disponibili per la data di consegna richiesta ma sono disponibili per una nuova data.',
        MESSAGE2: 'Vuoi aggiornare le date di consegna?',
        MESSAGE3: 'Alcuni articoli non sono più pubblicati o disponibili. Questi verranno rimossi dal carrello!',
        MESSAGE4: 'Attenzione! Hai superato il limite per le seguenti combinazioni style-color. Rivedi il tuo carrello per poterlo confermare.',
        MESSAGE5: 'Attenzione! Hai superato il limite relativo al punto vendita corrente! Rivedi il tuo carrello per poterlo confermare.',
        MESSAGE6: 'Vuoi aggiornare la data di consegna?',
        MESSAGE_MIN_QTY_PER_ORDER: 'Attenzione! Alcuni articoli nell\'ordine non raggiungono la quantità minima richiesta per quel determinato style-color!',
        MINIMUM: 'Minimo',
        ERROR_REASON: 'Motivo errore',
        REASON: {
          REQUESTED_QTY_NOT_AVAILABLE: 'Quantità richiesta non disponibile',
          VARIANT_NOT_AVAILABLE_IN_YOUR_TIER: 'Variante non disponibile nel tuo tier',
          VARIANT_NOT_AVAILABLE_IN_YOUR_CHANNEL: 'Variante non disponibile nel tuo canale',
          VARIANT_NO_LONGER_VISIBLE: 'Variante non più visibile',
          BLANK_CELL_DATE_NO_LONGER_ACTIVE: 'Data a cella bianca non più attiva',
        }
      },
      ATTENTION: 'Attenzione!',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_CUSTOMER_IS_NOT_APPROVED: 'Non puoi confermare questo carrello perché il cliente non è approvato',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_POINT_OF_SALE_IS_NOT_APPROVED: 'Non puoi confermare questo carrello perché il punto vendita non è approvato',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_LOWER_CART_VALUE: 'Non puoi confermare questo carrello perché il totale del carrello è inferiore al valore minimo consentito in questo negozio',
      THIS_CART_NOT_AVAILABLE: 'Questo carrello non è più disponibile',
      NO_PRODUCTS_IN_CART: 'Nessun prodotto nel carrello',
      COMMERCIAL_BLOCK_INFO: 'Sul cliente corrente è attivo un blocco amministrativo.',
      NO_CART_CONF: 'Questo carrello non può essere confermato.',
      DETAILS: {
        CUSTOMER: 'Cliente',
        GENERAL_INFO: 'Informazioni generali',
        DELIVERY_INFO: 'Info consegna',
        POS: 'Punto vendita',
        BILLING_ADDRESS: 'Indirizzo di fatturazione',
        SEASON_REFERENCE: 'Season reference',
        GOK: 'GOK',
        SHIPPING: 'Spedisci a',
        OVERVIEW: 'Panoramica',
        ALTERNATIVE: 'Seleziona indirizzo alternativo',
        REMOVE_CUSTOM: 'Rimuovi data di consegna custom',
        SET_CUSTOM: 'Imposta data di consegna custom',
        INVALID_SELECTION_FOR_CUSTOM_DATES: 'Non puoi impostare le stesse date di consegna personalizzate per stessi SkuCode ordinati con date di consegna suggerite diverse',
        CUSTOM_DATES: 'Date di consegna custom',
        SELECT_ALL: 'Seleziona tutto',
        DESELECT_ALL: 'Deseleziona tutto',
        SHIPPING_UPDATED: 'Indirizzo di spedizione aggiornato',
        NO_OTHER_SHIPPING_ADDRESS_AVAILABLE: 'Nessun altro indirizzo di spedizione disponibile',
        VARIANTS_ALREADY_ORDERED_WITH_REORDER_DATE: ' articoli non aggiunti perchè già in carrello con data scaduta. Vai al carrello per gestirli.',
        PLEASE_SAVE_OR_CANCEL_YOUR_ORDER_CHANGES: 'Salva o annulla le modifiche prima di confermare l\'ordine',
        STYLE_COLOR_QUANTITY_NOT_RESPECTED_MINIMUM: 'Uno o più articoli non rispettano il minimo ordinabile',
        TOTAL_COST: 'Totale costo',
        TOTAL_MARGIN: 'Totale margine',
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Sconto da retail',
        NOTE: 'Note'
      },
      CONTROLLERS: {
        DELETE: 'Elimina carrello',
        DUPLICATE: 'Duplica carrello',
        NOTES: 'Note',
        PRINT: 'Stampa',
        ACTIONS: 'Azioni',
        CONFIRM_ORDER: 'Conferma ordine',
        OPEN_IN_BACKOFFICE: 'Apri in backoffice',
        CANCEL_CHANGES: 'Annulla modifiche',
        SAVE_CHANGES: 'Salva modifiche',
        EDIT_QTY: 'Modifica quantità',
        COMMERCIAL_AGREEMENT: 'Accordo commerciale',
        VIEW_IN_BACK_OFFICE: 'Visualizza carrello nel Back Office'
      },
      SELECTORS: {
        SHIPPING: {
          TITLE: 'Spedizione',
          TEXT: 'Indirizzo di spedizione',
          INPUT: 'Seleziona un indirizzo',
          DELIVERY_DATES: 'Date di consegna spedizione'
        },
        DELIVERY: 'Data consegna',
        PRICE: {
          TITLE: 'Totali',
          TOT_WHOLESALE_GROSS: 'Wholesale Lordo',
          TOT_DISCOUNT: 'Sconto',
          TOT_DISCOUNT_PERC: 'Sconto %',
          COMM_AGR_DISCOUNT_PERC: 'Sconto acc. comm. %',
          TOT_WHOLESALE_NET: 'Wholesale Netto',
          TOT_RETAIL_NET: 'Retail',
          TOTAL_CART: 'Tot. carrello'
        },
        ADDING_INFO: 'Stai aggiungendo {{totalPcs}} pezzi, per un totale wholesale €{{totalWholesale}}',
        ADDING_INFO_LOADING: 'Stai aggiungendo...',
        QUANTITY: 'Quantità',
        DISCOUNT: {
          TITLE: 'Il tuo sconto',
          TEXT: 'Il tuo sconto'
        },
        PAYMENT: {
          TITLE: 'Pagamento',
          SUB_TITLE: 'Termine di pagamento'
        },
        BILLING: {
          TITLE: 'Info fatturazione',
          SUB_TITLE_CUSTOMER: 'Cliente',
          SUB_TITLE_ADDRESS: 'Indirizzo di fatturazione'
        }
      },
      PRODUCT: {
        TITLES: {
          NAME: 'Nome articolo',
          WHOLESALE: 'Tot. wholesale',
          QUANTITY: 'Tot. quantità'
        },
        DOT_MENU: {
          REMOVE: 'Rimuovi',
          REMOVE_LINE: 'Imposta a 0 le qty della riga'
        },
        ERRORS: {
          UNAVAILABLE: 'taglia non disponibile',
          UNAVAILABLES: 'taglie non disponibili'
        }
      },
      CHECKOUT: {
        YOUR_ORDER: 'Il tuo ordine',
        HAS_BEEN_CONFIRMED: 'è stato confermato',
        POINT_OF_SALE: 'Punto vendita',
      },
      PROMOTION: 'Promozioni utilizzate',
      ORDER_NOTES: 'Note dell\'ordine',
    },
    ON_BACK: {
      MODAL: {
        TITLE: 'Le modifiche non sono state salvate',
        MESSAGE: 'Se esci da questa pagina, tutte le modifiche non salvate andranno perse.',
        LEAVE_PAGE: 'Esci',
        CONTINUE: 'Continua',
      }
    },
    FINANTIAL_RISK: {
      FINANTIAL_RISK_CURRENT: 'Rischio finanziario corrente',
      FINANTIAL_RISK_PREVIUS: 'Rischio finanziario precedente',
      CLASS: 'Classe',
      SCORE: 'Punteggio',
      DESCRIPTION: 'Descrizione',
      SUMMARY: 'Riepilogo',
      CREDIT_LIMIT: 'Limite credito',
      INSOLVENCY: 'Insolvenza',
      COMPANY_INSOLVENCY: 'Insolvenza aziendale',
      PROTESTI: 'Protesti',
      PREJUDICIALS: 'Pregiudiziali',
      NAME: 'Nome',
      LEGAL_FORM: 'Forma giuridica',
      TAX_CODE: 'Codice fiscale',
      VAT_CODE: 'Partita IVA',
      COMPANY_NUMBER: 'Numero società',
      EMAIL: 'Email',
      COUNTRY: 'Paese',
      COMPANY_REG_NUMBER: 'Numero di registrazione',
      PUBLIC_REG_SECTION: 'Sezione registro pubblico',
      INCORPORATION_DATE: 'Data di costituzione',
      REA_REGISTRATION_DATE: 'Data di registrazione REA',
      STATUS: 'Stato',
      STATUS_DESCRIPTION: 'Descrizione stato',
      EMPLOYESS: 'Dipendenti',
      TURNOVER: 'Fatturato',
      ACTIVITY_CODE: 'Codice attività',
      ACTIVITY_DESCRIPTION: 'Descrizione attività',
      COMPANY_DETAILS: 'Dettagli società',
      STATUS_AND_KEY_FIGURES: 'Stato e dati chiave',
      ACTIVITY_DETAILS: 'Dettagli attività',
      TELEPHONE: 'Telefono',
      ADDRESS: 'Indirizzo',
      LAST_RATING_CHANGE_AT: 'Ultimo aggiornamento punteggio',
      TYPE: 'Tipo',
    },
    IMPORT_PRODUCT_MODAL: {
      RETAIL_DISCOUNT_PERCENTAGE: 'Percentuale di sconto da retail',
      DISCOUNT_REQUIRED: 'Sconto obbligatorio',
      MAX_DISCOUNT_ALLOWED: 'Sconto massimo consentito {{value}}%',
    },
    LOCALIZED_TEXT_EDITOR: {
      ACTIONS: 'Azioni',
      ACTION: {
        SET_DEFAULT: 'Imposta predefinito',
      },
      DEFAULT_LANGUAGE: 'Lingua predefinita',
    },
    OPERATION_LOG: {
      TITLE: 'Log operazioni da ERP per {{value}}',
      OPERATION_LOGS: 'Log operazioni',
      ORDER: 'ordine #{{value}}',
      FULFILLMENT: 'evasione #{{value}}',
      LOG_DESCRIPTION: 'Descrizione log',
      COLUMNS: {
        CREATION_DATE: 'Data creazione',
        OPERATION_TYPE: 'Tipo operazione',
        OUTCOME: 'Esito',
      },
      OPERATION_TYPE_STATUS: {
        CONFRIMED_ORDER: 'Ordine confermato',
        FULFILLMENT_CANCELED: 'Evasione annullata',
        ORDER_ITEMS_INSERTED: 'Articoli inseriti',
        ORDER_ITEMS_UPDATED: 'Articoli aggiornati',
        ORDER_UPDATED: 'Ordine aggiornato',
        SERVICE_ITEM_INSERTED: 'Servizio inserito',
        SERVICE_ITEM_UPDATED: 'Servizio aggiornato',
        SERVICE_ITEM_DELETED: 'Servizio eliminato',
        FULFILLMENT_CREATED: 'Evasione creata',
        FULFILLMENT_UPDATED: 'Evasione aggiornata',
        FULFILLMENT_PACKAGE_CREATED: 'Collo creato',
        FULFILLMENT_PACKAGE_ITEM_CREATED: 'Articolo aggiunto al collo',
        ORDER_HEADER_UPDATED: 'Testata d\'ordine aggiornata',
        BULK_ADD_ITEMS: 'Articoli aggiunti',
        BULK_CHANGE_QTY: 'Modificata quanità',
        BULK_REPLACE_ITEMS: 'Articoli sostituiti',
        BULK_CHANGE_WHOLESALE: 'Prezzi modificati',
        BULK_CHANGE_DELIVERY_DATE: 'Data consegna modificata',
        WEBHOOK_NOTIFICATION: 'Webhook inoltrato verso l\'ERP',
        ORDER_SYNC_STATUS: 'Stato dell\'ordine aggiornato',
        CHANGE_CUSTOMER_OR_POS: 'Modificato cliente/punto vendita',
        BULK_CANCEL_ORDER: 'Ordini annullati',
        BULK_OPERATION_ROLLBACK: 'Rollback operazione',
        BULK_REMOVE_ITEMS: 'Articoli rimossi',
      },
      OUTCOME_STATUS: {
        SUCCESS: 'Successo',
        FAILED: 'Fallito',
      },
    },
    CUSTOMIZATION_REQUEST: {
      EXCEL_IMPORT: {
        UPLOAD_FROM_EXCEL: "Carica da Excel",
        MODAL_TITLE: "Carica varianti da Excel",
        INSTRUCTIONS: "Un file per tutta la richiesta — una riga = un capo. Scaricalo, scrivi la quantità in QTY, e lascia NUMBER e JERSEY TEXT vuoti per i capi senza personalizzazione. Per personalizzare un capo, aggiungi una riga compilando NUMBER e/o JERSEY TEXT e ripetendo STYLE CODE, CR STYLE NAME, COLOR e SIZE — con QTY a 1. Puoi aggiungere taglie non elencate, purché esistano per quel prodotto. Lascia QTY vuota sulle taglie che non vuoi ordinare. Non rinominare né duplicare le intestazioni, non modificare SIZE GROUP precompilato, e tieni NUMBER formattato come testo così valori come 07 non vengono alterati da Excel.",
        INSTRUCTIONS_TEAMS: "Stessa squadra su più prodotti? Copia le righe e cambia CR STYLE NAME e COLOR.",
        UPLOAD: "Carica",
        FILE_REJECTED: "File non accettato",
        UPLOAD_FAILED: "Non è stato possibile leggere il file",
        REVIEW_TITLE: "Revisione varianti importate",
        REVIEW_SUBTITLE: "Controlla i dati letti dal file, correggili se serve, poi conferma.",
        REPORT: "{{total}} righe lette · {{imported}} importate · {{ignored}} lasciate vuote",
        WARNINGS_TITLE: "Da controllare",
        SAVE_SUCCESS: "Dati importati salvati ({{count}} taglie)",
        PARTIAL_SAVE: "Salvataggio parziale",
      },
      CREATE_NEW_CART: 'Crea nuovo carrello da CR',
      PLAYERS: 'Info giocatori',
      NO_PLAYERS: 'Nessuna informazione sul giocatore è stata inserita per questa richiesta di personalizzazione',
      NO_PLAYERS_TO_EDIT: 'Non ci sono player da modificare per questo prodotto.',
      TITLE: 'Richiesta di personalizzazione: {{name}}',
      SUCCESSFULLY_SAVED: 'Configurazione salvata con successo',
      HEADER: {
        TITLE: 'Titolo',
        CUSTOMER: 'Cliente',
        REQUESTER: 'Richiedente',
        CUSTOMER_REQUESTER: 'Richiedente Cliente',
        AGENCY_REQUESTER: 'Richiedente Agenzia',
        DESIGNER: 'Grafico',
        POINT_OF_SALE: 'Punto vendita',
        CUSTOMIZATION_REQUEST_CREATION: 'Creazione RP',
        PERSONALIZED_COST: 'Costo della personalizazzione',
        SHIPPING_COST: 'Costo spedizione',
        DISCOUNT: 'Percentuale di sconto che verrà applicata al carrello',
        ENDORSEMENT_REQUESTER: 'Approvazione richiedente',
        ENDORSEMENT_DESIGNER: 'Approvazione grafica',
        ENDORSEMENT_COMMERCIAL: 'Approvazione commerciale',
        ORDER_CREATED: 'Ordine creato',
        REQUEST_REJECTED: 'Rifiutata',
        APPROVED_BY_AT: 'Approvato da {{name}} il {{date}}',
        REJECTED_BY_AT: 'Rifiutata da {{name}} il {{date}}',
        PENDING: 'Pendente',
        SUPPORT_PHONE: 'Telefono di supporto',
        POS_PHONE: 'Telefono del POS',
        SUPPORT_EMAIL: 'E-mail di supporto',
        TOTAL_QUANTITY: 'Quantità totale',
        DELIVERY_DATE: 'Data consegna',
        LAST_DESIGNER_NOTIFICATION: 'Ultima notifica al grafico',
        TITLE_UPDATED_SUCCESSFULLY: 'Titolo aggiornato con successo',
        REQUESTER_UPDATED_SUCCESSFULLY: 'Richiedente aggiornato con successo',
        DESIGNER_UPDATED_SUCCESSFULLY: 'Grafico aggiornato con successo',
        POINT_OF_SALE_UPDATED_SUCCESSFULLY: 'Punto vendita aggiornato con successo',
        ARE_YOU_SURE_DUPLICATE: 'Sicuro di voler duplicare la richiesta di personalizzazione',
      },
      REQUESTER_APPROVAL: {
        CHOOSE_TITLE: "Vuoi inserire le informazioni dei giocatori della tua squadra?",
        CHOOSE_DONT_CUSTOMIZE: "No, non voglio personalizzare",
        CHOOSE_CUSTOMIZE: "Si, voglio inserire i nomi e i numeri dei miei giocatori (opzionale)",
        HOW_MANY: "Quanti giocatori vuoi inserire?",
        SIZES_TITLE: "Inserisci le quantità per ogni prodotto. Ricorda, hai un minimo di {{min}} pezzi per ogni prodotto",
        EXTRA_SIZES_TITLE: "Inserisci le quantità extra non personalizzate",
        EXTRA_SIZES_TITLE2: " (opzionale)",
        EXTRA_SIZES_TITLE3: ". Ci sono {{n}} prodotti in cui non hai raggiunto la quantità minima di acquisto ({{min}} pezzi). Inserisci quantità per raggiungere il minimo di acquisto per ogni prodotto.",
        PLAYERS_TITLE: "Seleziona un font ed inserisci, per ogni giocatore, nome (opzionale) e numero (obbligatorio), e seleziona la taglia per ogni articolo che vuoi legare a quel giocatore.",
        NUMBER: "Numero",
        JERSEY_TEXT: "Nome",
        DUPLICATE_PRODUCT: "Duplica prodotto",
        DUPLICATE_ARE_YOU_SURE: "Sei sicuro di voler duplicare questo prodotto nella tua richiesta di personalizzazione? Se sì. inserisci il nome del prodotto nella richiesta e conferma",
        SHOW_PLAYERS_INFO: "Mostra info giocatori",
        FONTS: "Fonts",
      },

      NEW_REQUESTER_APPROVAL: {
        MODAL_TITLE: "Approvazione richiesta personalizzazione",
        MODAL_SUBTITLE: "Definisci le quantità del prodotto ed eventuali personalizzazioni aggiuntive.",
        ALERT_INFO: "Questa richiesta include più prodotti. Per completare la richiesta è necessario inserire le quantità per ogni prodotto. Le personalizzazioni sono facoltative. Ricorda, hai un minimo di {{min}} pezzi per ogni prodotto.",
        PRODUCTS: "Prodotti",
        INCOMPLETE: "Incompleto",
        COMPLETE: "Completo",
        TOTAL_PIECES: "Totale pezzi",
        TOTAL_PIECES_RECAP_TITLE: "Riepilogo quantità",
        TOTAL_PIECES_PER_PRODUCT_TITLE: "Riepilogo quantità per prodotto",
        CUSTOMIZED: "Personalizzati",
        WITH_CUSTOMIZATION: "Con Personalizzazione",
        WITHOUT_CUSTOMIZATION: "Senza Personalizzazione",
        QUANTITY_WITHOUT_CUSTOMIZATION: "Quantità prodotto senza personalizzazione",
        SIZE: "Taglia",
        QUANTITY: "Quantità",
        WS_UNIT: "WS unit",
        CUST_UNIT: "Pers. Unit",
        WS_TOT: "WS tot",
        INSERT: "Inserisci",
        CUSTOMIZATION: "Quantità prodotto con personalizzazione",
        FONTS: "Fonts",
        LOADING_FONTS: "Caricamento fonts...",
        NUMBER: "Numero",
        NAME: "Nome",
        ADD_PLAYER: "Aggiungi Player",
        IMPORT_PLAYERS: "Importa giocatori",
        IMPORT_PLAYERS_HINT: "Importa numero e nome dai giocatori già configurati",
        IMPORT_LAST_CUSTOMIZATION: "Compila con utimi dati inseriti",
        IMPORT_LAST_CUSTOMIZATION_TOOLTIP: "Se presenti, puoi importare numero e nome degli ultimi player inseriti",
        SAVE_APPROVAL: "Salva approvazione",
        CHECK_QUANTITIES_AND_PLAYERS: "Controlla le quantità e i players inseriti prima di procedere con la conferma",
        NO_SUMMARY_ROWS: "Nessuna riga di riepilogo.",
        BACK_TO_CUSTOMIZATION_REQUEST: "Torna alla richiesta di personalizzazione",
        SIZE_GROUP: {
          ADULT: "Adult",
          YOUTH: "Youth",
          KIDS: "Kids",
        }
      },

      GRAPHICAL_APPROVAL: {
        COLOR_NAME: "Nome colore",
        COLOR_NAME_TOOLTIP: 'Esempio: nome del club {{currentYear}} + scopo (partita, allenamento...)',
        COLOR_NAME_ERROR: 'Questo nome colore è già presente in un altro prodotto.',
      },

      ACTION: {
        APPROVE: 'Approva',
        CREATE_NEW_CART: 'Crea nuovo carrello',
        EDIT_CUSTOMIZATION_REQUEST_NAME: 'Modifica nome richiesta di personalizzazione',
        EDIT_CR_PRODUCT_NAME: 'Modifica nome prodotto nella CR',
        BACK: 'Indietro',
        NEXT: 'Prossimo',
        APPROVE_GRAPHICALLY: 'Approva graficamente',
        APPROVE_COMMERCIAL: 'Approva commercialmente',
        LOCK_CONFIGURATOR: 'Blocca configuratore',
        UNLOCK_CONFIGURATOR: 'Sblocca configuratore',
        REJECT: 'Rifiuta',
        DELETE: 'Elimina',
        DOWNLOAD_REPORT: 'Scarica report',
        DOWNLOAD_COLOR_REPORT: 'Scarica report colore',
        DOWNLOAD_STORE_ORDERS_ITEMS_REPORT: 'Scarica report righe d\'ordine',
        DOWNLOAD_STORE_ORDERS_REPORT: 'Scarica report ordini',
        DOWNLOAD_POINTS_OF_SALE_REPORT: 'Scarica report punto vendita',

        DUPLICATE_CUSTOMIZATION_REQUEST: 'Duplica richiesta di personalizzazione',
        CUSTOMIZATION_REQUEST_ENDORSEMENT: 'Approvazione richiesta di personalizzazione',
        DELETE_CUSTOMIZATION_REQUEST: 'Elimina la richiesta di personalizzazione',
        REJECT_CUSTOMIZATION_REQUEST: 'Rifiuta la richiesta di personalizzazione',
        INSERT_REJECTION_REASON: 'Inserisci il motivo del rifiuto',
        ARE_YOU_SURE: 'Sei sicuro?',
        ARE_YOU_SURE_YOU_WANT_TO_LOCK_CONFIGURATOR: 'Sei sicuro di voler bloccare il configuratore?',
        ARE_YOU_SURE_YOU_WANT_TO_UNLOCK_CONFIGURATOR: 'Sei sicuro di voler sbloccare il configuratore?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: 'Sei sicuro di voler eliminare la richiesta di personalizzazione?',

        DELIVERY_DATE: 'Data di consegna',
        FINANCIAL_DISCOUNT: 'Sconto finanziario',
        ADDITIONAL_CUSTOMIZATION_COST: 'Costo di personalizzazione su questa richiesta (opzionale)',
        CUSTOMIZATION_REQUEST_APPROVED_SUCCESSFULLY: 'Richiesta di personalizzazione approvata con successo',
        CONFIGURATOR_LOCKED_SUCCESSFULLY: 'Configuratore bloccato con successo',
        CONFIGURATOR_UNLOCKED_SUCCESSFULLY: 'Configuratore sbloccato con successo',
        CUSTOMIZATION_REQUEST_REJECTED_SUCCESSFULLY: 'Richiesta di personalizzazione rifiutata con successo',
        CUSTOMIZATION_REQUEST_DELETED_SUCCESSFULLY: 'Richiesta di personalizzazione eliminata con successo',
        CUSTOMIZATION_REQUEST_DUPLICATED_SUCCESSFULLY: 'Richiesta di personalizzazione duplicata con successo',
        REVERT_TO_DRAFT: 'Riconverti in bozza',
        REVERT_TO_DRAFT_SUCCESSFULLY: 'Lo stato della richiesta di personalizzazione è stato cambiato con successo',
        NOTIFY_DESIGNER_READY: 'Notifica Designer',
        DESIGNER_NOTIFIED_SUCCESSFULLY: 'Designer notificato con successo',
      },
      DETAIL: {
        BACK_TO_CUSTOMIZATION_REQUESTS: 'Torna alle richieste di personalizzazione',
        ORDER: 'Ordine',
        GO_TO_ORDER: 'Vai all\'ordine',
        READ_ONLY_BANNER: 'Questa richiesta non è di tua proprietà: puoi consultarla in sola lettura',
        DETAIL: 'Dettaglio',
        TIMELINE: 'Timeline',
        MEDIA: 'Media',
        CHANNEL_NAME: 'Nome canale',
        STATUS: 'Stato',
        CONFIGURATOR_LOCKED: 'Configuratore bloccato',
        CUSTOMIZED_PRODUCTS: 'Prodotti personalizzati',
        ADD_PRODUCT: 'Aggiungi prodotto',
        SELECT_PRODUCT: 'Seleziona prodotto'
      },
      MEDIA: {
        FILE_NAME: 'Nome file',
        USER_NAME: 'Nome utente',
        USER_ROLE: 'Ruolo utente',
        DOCUMENT_GRAPHICAL_APPROVAL: 'Documenti approvazione grafica',
        DOWNLOAD_DOCUMENT: 'Scarica documento',
        ATTACHMENTS_OF_CUSTOMIZATION_REQUEST: 'Allegati della richiesta di personalizzazione',
        DOWNLOAD_ALL: 'Scarica tutti',
      },
      UPLOAD_FILE: {
        ERROR_FILE_MAX_SIZE: '<strong>Errore! </strong> Il file supera la dimensione massima consentita di {{maxSize}}',
        ERROR_FILE_TYPE: '<strong>Errore! </strong>Il file non è di un tipo consentito, i tipi consentiti sono: {{allowedTypes}}',
        ATTACH_DOCUMENT: 'Allega documento',
        ATTACH_IMAGE: 'Allega immagine',
        ATTACHMENT: 'Allegato',
        BROWSE: 'Sfoglia',
        CHOSE_DOCUMENT: 'Scegli documento',
        CHOSE_IMAGE: 'Scegli immagine',
      },

      CUSTOMIZATION_PRODUCT: {
        PRODUCT_DELETED_SUCCESSFULLY: 'Prodotto eliminato con successo',
        PERSONALIZE: 'Personalizza',
        COLOR_NAME: 'Nome colore',
        COLOR_CODE: 'Codice colore',
        START_3D_VIEWER: 'Start 3D viewer',

        SKU: 'Codice prodotto',
        PRODUCT_NAME: 'Nome prodotto',
        TEMPLATE_ID: 'ID template',
        ID: 'ID',
        WHOLESALE_TOTAL_PRICE: 'Wholesale tot.',

        TABLE: {
          SIZE: 'Taglia',
          QUANTITY: 'Quantità',
          WHOLESALE_UNIT_PRICE: 'Wholesale unit.',
          CUSTOMIZATION_UNIT_PRICE: 'Personalizzazione unit.',
          WHOLESALE_TOTAL_PRICE: 'Wholesale tot.',
        }
      },

      TIMELINE: {
        CUSTOMIZATION_REQUEST_CREATED: 'Richiesta di personalizzazione creata',
        CUSTOMIZATION_REQUEST_REJECTED: 'Richiesta di personalizzazione rifiutata',
        PRODUCT_ADDED: 'Prodotto aggiunto',
        PRODUCT_DELETED: 'Prodotto eliminato',
        POINT_OF_SALE_UPDATED: 'Punto vendita aggiornato',
        CONFIGURATOR_LOCKED: 'Configuratore bloccato',
        CONFIGURATOR_UNLOCKED: 'Configuratore sbloccato',
        STATUS_RESET_TO_DRAFT: 'Stato resettato a bozza',
        APPROVED_BY_REQUESTER: 'Approvato dal richiedente',
        APPROVED_GRAPHICALLY: 'Approvato graficamente',
        APPROVED_COMMERCIAL: 'Approvato commercialmente',
        DEFAULT_DESIGNER_ASSIGNED: 'Grafico predefinito assegnato',
        DESIGNER_REASSIGNED: 'Grafico riassegnato',
        REQUESTER_REASSIGNED: 'Richiedente riassegnato',
        CUSTOMER_REQUESTER_REASSIGNED: 'Richiedente cliente riassegnato',
        AGENCY_REQUESTER_REASSIGNED: 'Richiedente agenzia riassegnato',
        MESSAGE_ADDED: 'Messaggio aggiunto',
        MEDIA_ADDED: 'Media aggiunti',
        DESIGNER_NOTIFIED: 'Grafico notificato',
        ORDER_ISSUED: 'Richiesta di personalizzazione ordinata',
        BY: 'da {{name}}',
        HIDE_MESSAGE_FROM_REQUESTER: 'Nascondi messaggio al richiedente',
        READ_MORE: 'Leggi di più',
        READ_LESS: 'Leggi meno',
        FOR_CR_PRODUCT: 'per prodotto: #{{value}}',
        REQUESTING_NEW_DESIGN: 'con richiesta di nuovo design',
        TRANSLATE_MESSAGE: 'Traduci messaggio',
        SHOW_ORIGINAL_MESSAGE: 'Mostra messaggio originale',
      },
      CONFIGURATOR: {
        BACK_TO_CUSTOMIZATION_REQUEST: 'Torna alla richiesta di personalizzazione',
        PRODUCT_CONFIGURATOR: 'Configuratore prodotto #{{sku}} - {{title}}',
      },
      INHERIT_OR_RESET_SIZES_FROM_CR: 'Riutilizza o reimposta taglie dalla CR',
      INHERIT_OR_RESET_SIZES_FROM_CR_DESCRIPTION: 'Vuoi riutilizzare le taglie dalla richiesta di personalizzazione precedente o reimpostarle?',
      RESET_SIZES: 'Reimposta taglie',
      INHERIT_SIZES: 'Riutilizza taglie',
    },
    // TRADUZIONI CROSS FRONT / BACK OFFICE
    DUPLICATE_CART: {
      TITLE: 'Duplica carrello',
      CUSTOMER: 'Cliente',
      POINT_OF_SALES: 'Punto vendita',
      CART_NAME: 'Nome carrello',
      ALTERNATIVE_SHIPPING_ADDRESS: 'Indirizzo di spedizione alternativo',
      SUCCESS_CART_DUPLICATED: 'Carrello duplicato con successo',
      ERROR_CART_DUPLICATED: 'Errore durante la duplicazione di uno o più prodotti',
      DUPLICATE_CART: 'Duplica carrello',
      AGENCY: 'Agenzia',
      SET_REQUEST_DELIVERY_DATE: 'Imposta data di consegna',
      CART_DUPLICATED_PARTIALLY: 'Carrello duplicato parzialmente',
      CART_NOT_DUPLICATED: 'Carrello non duplicato',
      VARIANTS_NOT_ADDED: 'Varianti non aggiunte',
      VARIANT: 'Variante',
      VARIANT_NOT_AVAILABLE: 'variante non disponibili',
      QUANTITY_INSUFFICIENT: 'quantità insufficiente',
      REQUESTED_QUANTITY: 'quantità richiesta',
      AVAILABLE_QUANTITY: 'quantità disponibile',
      MANUAL_DISCOUNT: 'Includi sconti manuali applicati',
      PENDING_FULFILLMENT: 'Duplica solo gli articoli dell\'ordine non evasi',
      OPTION_DUPLICATE_ORDER: 'Opzioni duplicazione ordine',
      INCLUDE_CUSTOM_DELIVERIES: 'Includi date di consegna personalizzate',
      SKIP_CHECKS: 'Escludi controlli di visibilità e quantità',
    },
    CHANNEL: {
      BROWSE: 'Naviga',
      TITLE: 'Channel',
    },

    CONFIRM_CART_MODAL: {
      TITLE: 'Conferma carrello',
      SUB_TITLE: 'Stai confermando il carrello',
      ATTENTION_THIS_CUSTOMER_HAVE_A_COMMERCIAL_BLOCK_ACTIVE: 'Questo cliente ha il blocco amministrativo attivo. Sei sicuro di voler confermare ugualmente l\'ordine?',
      YOU_HAVE_VOUCHERS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'Hai dei voucher disponibili che puoi applicare a questo carrello',
      NO_ENTERED_ATTACHMENTS: 'Nessun attachment inserito',
      SELECT_VOUCHER: 'Seleziona voucher',
      RESIDUAL_VOUCHER_VALUE: 'Valore residuo voucher: {{value}}',
      TOTAL_CART: 'Totale carrello: {{value}}',
      TERMS_AND_CONDITIONS: 'Termini e condizioni',
      ACCEPT_TERMS_AND_CONDITIONS: 'Accetto i termini e le condizioni',
      NO_VOUCHERS_AVAILABLE: 'Nessun voucher disponibile',
      VOUCHERS_UNAVAILABLE: 'Funzionalità vouchers momentaneamente non disponibile',
      CONFIRM: 'Conferma',
      COMMERCIAL_AGREEMENT: 'Accordo commerciale',
      YOU_HAVE_COMMERCIAL_AGREEMENTS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'Hai degli accordi commerciali disponibili che puoi applicare a questo carrello',
      SELECT_COMMERCIAL_AGREEMENT: 'Seleziona accordo commerciale',
      DISCOUNT: 'Sconto',
      COMMERCIAL_AGREEMENT_ID_IS_NOT_VALID: 'L\'accordo commerciale precedentemente associato a questo carrello non è più valido. Selezionane un\'altro o rimuovi quello vecchio',
      REMOVE_COMMERCIAL_AGREEMENT: 'Rimuovi accordo commerciale',
      YOU_DONT_HAVE_COMMERCIAL_AGREEMENTS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'Non hai accordi commerciali disponibili che puoi applicare a questo carrello',
      SAVE: 'Salva',
      MANAGE_DELIVERY_DATES: 'Gestisci date di consegna',
      OPTION_TITLE: 'Opzioni di conferma',
      EXCLUDE_CONTROLS: 'Escludi controlli di visibilità e quantità',
      INFO_EXCLUDE_CONTROLS: 'Escludendo i controlli di visibilità e quantità, è possibile confermare il carrello anche se gli articoli non sono visibili o se la quantità richiesta non è disponibile.',
      DONT_SENT_EMAIL: 'Non mandare email di conferma',
      POPULATE_DEFAULT_RECIPIENTS: 'Popola con destinatari di default',
    },

    PAGINATION: {
      ITEM_FOR_PAGE: 'Elementi per pagina',
      PAGE: 'Pagina',
      OF: 'di',
    },

    EVALUATE_CART_SALE_CAMPAIGN_CONSTRAINT: {
      COMMERCIAL_RULES: 'Regole commerciali',
      ALERT: {
        TITLE: 'Attenzione!',
        MESSAGE: 'Su questo carrello è attiva la regola commerciale "{{commercialRuleName}}" per la campagna vendita "{{saleCampaignName}}". ',
        MORE_INFO: 'Visualizza dettagli',
        CLICK_HERE_FOR_MORE_INFO: 'Clicca qui per visualizzare i dettagli',
        CART_NOT_CONFIRMABLE: 'Su questo carrello è attiva una regola commerciale di cui uno o più vincoli non sono soddisfatti',
        FOR_CONFIRM_CART: ',per poterlo confermare è necessario che tutti i vincoli siano soddisfatti.',
        ROLE_BYPASS: 'Il tuo ruolo ti permette confermare il carrello anche se non tutti i vincoli sono soddisfatti.',
        CONSTRAINTS_IS_SATISFIED: 'Su questo carrello è attiva una regola commerciale ed i suoi vincoli sono soddisfatti',
      },

      MODAL: {
        DETAIL_COMMERCIAL_RULE: 'Dettaglio regola commerciale: {{commercialRuleName}}',
        MISSING_ITEMS_OF_PRODUCTS: 'Ti mancano {{missingNumberOfItems}} pezzi tra i prodotti: {{stylesCode}}',
        VALUE_CONSTRAINT_NOT_REACHED: 'Gli articoli di questo assortimento non raggiungono la percentuale minima rispetto al totale wholesale considerando anche i precedenti ordini effettuati nella campagna vendita corrente (totale wholesale {{computedTotalWholesaleForMatchedItems}}€, corrispondente al: {{computedPercentageOfTotalWholesaleForMatchedItems}}%, mentre la soglia è del {{constrainedTotalWholesaleMinimumPercentage}}%; mancano €{{missingWholasale}})',
        VALUE_CONSTRAINT_REACHED: 'Vincolo a valore soddisfatto',
        VALUE_CONSTRAINT: '({{computedTotalWholesaleForMatchedItems}}€, corrispondente al {{computedPercentageOfTotalWholesaleForMatchedItems}}%)',
        ALL_PACKAGE_CONSTRAINTS_ARE_SATISFIED: 'Vincoli di pacchetto soddisfatti',
        CONSTRAINTS_ON_ASSORTMENT: 'Vincoli su assortimento: {{assortmentName}}',
      },
    },

    CUSTOM_SHIP_DATES: {
      ITEMS_WITH_NO_STOCK1: 'Alcune date non sono state aggiunte: ',
      ITEMS_WITH_NO_STOCK2: ' articoli non hanno quantità in stock disponibili',
      TITLE: 'Date di spedizione personalizzate',
      SELECT_ALL: 'Seleziona tutto',
      UNSELECT_ALL: 'Deseleziona tutto',
      BULK_PERSONALIZED_DATE: 'Personalizza data di consegna ({{numberOfItems}})',
      VIEW_SELECTION: '({{n}}) articoli selezionati',
      CUSTOM_DATE: 'Data personalizzata',
      DATE_NOT_SELECTABLE: 'Data non selezionabile',
      REMOVE_ALL_CUSTOM_DATES: 'Rimuovi date personalizzate',
      DATE_OVER_MAX_DATE: 'Uno o più articoli presentano una data personalizzata che supera la data di personalizzazione massima impostata in questo negozio',
      REQUESTED_DATE_OVER_MAX_DATE: 'Uno o più articoli selezionati non sono personalizzabili in quanto la data di consegna richiesta originale supera la data di personalizzazione massima impostata in questo negozio',
      ON: 'il',
      FROM: 'dal',
      TO: 'al',
      ADD_NEW_DATE: 'Aggiungi nuova data',
      EDIT_DATE: 'Modifica data',
      DATE: 'Data',
      QTY: 'Q.ty',
      ERROR_THE_SUM_OF_THE_QUANTITIES_FOR_CUSTOM_DATES_IS_GREATER_THAN_THE_QUANTITY_ORDERED: 'Errore! La somma delle quantità per le date personalizzate è maggiore della quantità ordinata',
      ERROR_THE_SUM_OF_THE_QUANTITIES_FOR_CUSTOM_DATES_IS_LESS_THAN_THE_QUANTITY_ORDERED: 'Errore! La somma delle quantità per le date personalizzate è minore della quantità ordinata',
      ERROR_THERE_ARE_DUPLICATE_DATES: 'Errore! Ci sono date duplicate',
      ERROR_THE_CURRENT_DATE_IS_OVER_THE_MAX_DATE: 'Errore! La data corrente è maggiore della data massima',
      INFO_MODAL_TITLE: 'Nuova modalità per la personalizzazione delle date di consegna',
      INFO_MODAL_CONTENT: 'La personalizzazione delle date di consegna degli articoli all\'interno di un carrello è ora disponibile tramite la finestra di conferma ordine (vedi screenshot sotto). Non sarà più possibile effettuare tale operazione tramite le azioni fino ad ora utilizzate.',
      OK: 'Ho capito',
      COL_ORDER_ITEM: 'Articolo ordine',
      N_ORDER_ITEMS: 'N° articoli ordine',
      ORIGINAL_DATE: 'Data originale',
    },


    CUSTOMIZATION_REQUEST_CREATOR: {
      PERSONALIZE: 'Personalizza',
      BACK: 'Indietro',
      CONFIRM: 'Conferma',
      REQUEST_CONFIGURATION: 'Richiedi nuovo design',
      DOWNLOAD_THUMBNAIL: 'Scarica l\'immagine',
      SAVE: 'Salva',
      CHANGE_TEMPLATE: 'Cambia template',
      CREATED_SUCCESSFULLY: 'Richiesta di personalizzazione creata con successo',
      PRODUCT_ADDED_SUCCESSFULLY: 'Prodotto aggiunto con successo',
      STEP_1: {
        TITLE: 'Nuova personalizzazione',
        MESSAGE: 'Vuoi creare una nuova richiesta di personalizzazione o usarne una già esistente?',
        NEW_CR: 'Nuova richiesta',
        EXISTING_CR: 'Richiesta esistente',
      },
      STEP_2: {
        TITLE: 'Nuova richiesta di personalizzazione',
        SELECT_REQUESTER: 'Seleziona almeno un richiedente. Puoi selezionare un cliente e/o un agente',
        SELECT_REQUESTER_2: 'Come utente di un\'agenzia, puoi legare questa richiesta di personalizzazione anche ad un cliente',
        SELECT_REQUESTER_3: 'Come utente di un cliente, puoi legare questa richiesta di personalizzazione anche ad un agente, se il tuo punto vendita è seguito da un\'agenzia',
        TITLE_REQUEST: 'Titolo richiesta',
        TITLE_REQUEST_TOOLTIP: 'Esempio: nome del club {{currentYear}}.',
        COMMENTS: 'Nome del prodotto nella richiesta',
        COMMENTS_TOOLTIP: 'Esempio: nome del club + scopo (partita, allenamento...)',
        POS_PHONE: 'Numero di telefono del punto vendita',
        POS_PHONE_TOOLTIP: 'Numero di telefono associato al punto vendita. Se già presente, verrà pre-compilato.',
        POS_PHONE_EXAMPLES_TITLE: 'Esempi per paese:',
      },
      STEP_3: {
        TITLE: 'Seleziona la richiesta di personalizzazione',
        SELECT_REQUEST: 'Seleziona richiesta',
      },
      STEP_4: {
        TITLE: 'Seleziona un template base',
        DESCRIPTION: 'Richiesta di personalizzazione: {{name}}',
      },
      STEP_5: {
        TITLE: 'Richiedi configurazione per la personalizzazione: {{name}}',
        DESCRIPTION: 'Template #{{expiviId}}',
      },
      STEP_6: {
        TITLE: 'Configurazione per la richiesta: {{name}}',
        DESCRIPTION: 'Template #{{expiviId}}',
      },

      CONFIGURATION_MESSAGE: {
        PLACEHOLDER: 'Descrivi il prodotto che vorresti richiedere',
        MESSAGE_OF_REQUEST: 'Messaggio di richiesta',
        ATTACHMENTS: {
          TITLE: 'Allegati',
          ADD: 'Aggiungi allegato',
        },
      },

      VALIDATION: {
        AT_LEAST_ONE_REQUESTER: 'Seleziona almeno un richiedente (Cliente o Agenzia)',
        REQUESTERS_MUST_BE_DIFFERENT: 'Il richiedente Cliente e il richiedente Agenzia devono essere utenti diversi',
        PHONE_REQUIRED: 'Il numero di telefono è obbligatorio',
      },

    },
    BASIC_KUSTOM_REQUESTER: {
      CUSTOMER: 'Cliente',
      AGENT: 'Agente',
      CUSTOMER_REQUESTER: 'Richiedente Cliente',
      SELECT_AGENCY: 'Seleziona agenzia',
      SELECT_AGENT: 'Seleziona agente',
      THIS_POINT_OF_SALES_DOES_NOT_HAVE_ANY_AGENCY: 'Questo punto vendita non ha nessuna agenzia',
      SECTION_CLIENTE: 'Cliente',
      SECTION_USER: 'Utente',
      POINT_OF_SALE: 'Punto vendita',
    },

    //shop

    POS_STOCK_INFO: {
      TITLE: 'Info sullo stock del punto vendita',
      LOADING: 'Caricamento stock info..',
      ORDERABLE_QTY: 'Quantità ordinabile per il punto vendita corrente',
      ORDERABLE_QTY2: 'Nel carrello corrente puoi aggiungere ancora',
      CART_QTY: 'Quantità nel carrello corrente',
      TOTAL: 'Totale'
    },
    COMMON: {
      SET: 'Imposta',
      SAVE: 'Salva',
      MIN: 'Min',
      MAX: 'Max',
      FROM: 'Da',
      TO: 'A',
      SHOW: 'Mostra',
      ONLY: 'solo',
      IN: 'in',
      SHOW_ONLY: 'Mostra solo',
      SHOW_MORE: 'Mostra altro',
      SUGG_RETAIL: 'Retail sugg.',
      SEARCH: 'Cerca',
      DATES_CHECKBOX: 'Mostra solo settimane con disponibilità',
      DELIVERY_DATES: 'Date consegna',
      PCS: 'pcs',
      WHOLESALE: 'Wholesale',
      SUGGESTED: 'Suggerito',
      VALID: 'Valido',
      TYPE: 'Tipo',
      EXPAND_ALL: 'Espandi tutto',
      COLLAPSE_ALL: 'Comprimi tutto',
      PRODUCTS: 'Prodotti',
      COMMERCIAL_BLOCK_ACTIVE: 'Blocco amministrativo attivo',
      MAN: 'Uomo',
      WOMAN: 'Donna',
      UNISEX: 'Unisex',
    },
    HEADER: {
      PRE_ORDER: 'Pre-order',
      RE_ORDER: 'Re-order',
      MY_CARTS: 'I miei carrelli',
      CART: 'Carrello',
      CARTS: 'Carrelli',
      SELECT_CHANNEL: 'Seleziona channel'
    },
    ACCOUNT_POPUP: {
      MY_ACCOUNT: 'Account',
      BACK_OFFICE: 'Back-office',
      LOGOUT: 'Logout',
      SWITCH_TENANT: 'Cambia paese',
      CHANGE_LINGUAGE: 'Cambia lingua',
      SHOW_ONLY_RETAIL_PRICES: 'Mostra solo prezzi retail',
    },
    DIALOGS: {
      USE_TIER_FILTER: 'Imposta un filtro su impostazione tier',
      NO_TIER: 'Informazioni legate a nessun tier',
      SELECT_TIER: 'Informazioni legate ad un determinato tier',
      ARE_YOU_SURE_YOU_WANT_TO_CONFIRM_THIS_CART_BLOCKED: 'Attenzione! questo cliente ha il blocco amministrativo attivo. Sei sicuro di voler confermare ugualmente l\'ordine?',
      DO_YOU_WANT_TO_LOGOUT: 'Vuoi effettuare il logout?',
      DO_YOU_WANT_TO_DELETE_THIS_CART: 'Vuoi eliminare questo carrello?',
      DO_YOU_WANT_TO_CONFIRM_THIS_ORDER: 'Vuoi confermare questo ordine?',
      DO_YOU_WANT_TO_DELETE: 'Vuoi eliminare',
      CREATE_NEW_CART: 'Crea nuovo carrello',
      EDIT_CART: 'Modifica carrello',
      CREATE_CART: 'Crea carrello',
      COPY_CART: 'Copia carrello',
      TYPE_A_NEW_CART_NAME: 'Scrivi...',
      AGENCY: 'Agenzia',
      NEW_CART_NAME: 'Nome carrello',
      NO_SEASON_REFERENCE_AVAILABLE: 'Nessuna season reference disponibile',
      CANT_CONFIRM_THIS_ORDER: 'Impossibile confermare questo ordine',
      CANCEL: 'Annulla',
      CONFIRM: 'Conferma',
      SAVE: 'Salva',
      GOK_MODE: 'GOK',
      GOK_CART: 'Carrello Gok',
      CREATE_PRICE_LIST: 'Crea listino prezzi',
      EDIT_PRICE_LIST: 'Modifica listino prezzi',
      DELETE_PRICE_LIST: 'Elimina listino prezzi',
      DELETE_PRICE_LIST_CONFIRM: 'Sei sicuro di voler eliminare questo listino prezzi?',
      ASSOCIATE_CUSTOMERS: 'Associa clienti',
    },
    FOOTER: {
      COPYRIGHT: 'Copyright BasicGroup 2025',
      PRIVACY_POLICY: 'Privacy policy',
      TERMS: 'Termini e condizioni',
      TERMS_NOT_FOUND: 'Termini e condizioni non trovati',
      FOR_CLUBS: 'For clubs',
      NO_DATA: 'Non ci sono dati da visualizzare, contattare l\'amministratore.',
      RESET: 'Reset password',
      TEXT: 'BasicItalia S.r.l. - Strada della Cebrosa 106, 10100 Torino, Italy - P.IVA e CF IT1234567890',
      BUTTON: 'Aiuto'
    },
    CART_POPUP: {
      CLOSE: 'Chiudi',
      PIECES: 'Pezzi',
      PRODUCTS: 'Prodotti',
      RE_ORDER_CARTS: 'RE-ORDER',
      PRE_ORDER_CARTS: 'PRE-ORDER',
      SELECTED_CURRENT: 'Il carrello selezionato è quello a cui aggiungi la merce',
      SELECTED: 'Selezionato',
      NAVIGATE: 'Vai al carrello',
      WHOLESALE_PRICE: 'Prezzo wholesale',
      CREATED: 'Creato',
      DELIVERY_DATES: 'Consegna il',
      CONTROLLERS: {
        DELETE: 'Elimina carrello',
        CREATE: 'Crea nuovo',
        GO_TO_CHECKOUT: 'Vai al checkout',
        NO_CARTS: 'Nessun carrello, creane uno.'
      }
    },
    FILTERS: {
      STRATEGIC: 'Strategic',
      PROMO: 'In promo',
      CUSTOMIZABLE: 'Personalizzabili',
      AVAILABLE_NOW: 'Disponibile ora',
      GENDER: 'Genere',
      SIZE_GROUP: 'Size group',
      STYLE_GROUP: 'Style group',
      COLLECTIONS: 'Collezioni',
      COLORS: 'Colore',
      CATEGORY: 'Categoria',
      PURPOSE: 'Purpose',
      ASSORTMENTS: 'Assortment',
      TEAM: 'Team',
      SEASON: 'Stagione',
      AVAILABILITY: 'Disponibilità',
      WHOLESALE_PRICE: 'Wholesale',
      SUGGESTED_RETAIL_PRICE: 'Retail suggerito',
      NO_DATA: 'Nessun dato',
      TAGS: 'Tags',
      APPLAY_FILTERS: 'Applica filtri',
      CLEAR_ALL: 'Cancella tutti',
    },
    SIZE_GROUPS: {
      ADULT: 'Adulto',
      YOUTH: 'Youth',
      KID: 'Kid',
      INFANT: 'Infant'
    },
    SIZES_TABS: {
      LIMIT: 'Limite',
      COLOR: 'Colore',
      PRICE: 'Prezzo',
      DOT_MENU: {
        COPY: 'Copia',
        PASTE: 'Incolla',
        CLEAR_ALL: 'Pulisci tutti',
        REMOVE_ALL: 'Rimuovi tutti'
      },
      ADD: 'Aggiungi',
      TOT_PCS: 'Tot pz.',
      MAX_QTY_REACHED: 'Quantità massima raggiunta',
      QTY_NOT_AVAILABLE: 'Quantità non disponibile'
    },
    BREADCRUMBS: {
      HOME: 'Home',
      RE_ORDER: 're-order',
      PRE_ORDER: 'pre-order',
      CATALOG: 'Catalogo',
    },
    HOME: {
      SHOP: {
        CATCATALOG: 'Esplora tutto il catalogo',
        BROWSE: 'Naviga per',
      },
      CATEGORIES: {
        TITLE: 'Categorie',
        TEXT: 'Scopri i prodotti di ciascuna categoria\n e inoltra il tuo ordine in pochi clic',
        BUTTON: 'Scopri tutti i prodotti'
      },
      VIDEO: {
        TITLE: 'Quali sono novità?',
        TEXT: 'Scopri cosa c\'è di nuovo questa stagione. Tessuti, modelli, colori e tanto altro.'
      },
      COLLECTIONS: {
        TITLE: 'Assortimenti',
        TEXT: 'Esplora i prodotti nei nostri negli assortment che abbiamo creato per te.',
        EXPLORE: 'Scopri tutti gli assortment',
      },
      PRODUCTS: {
        TITLE: 'I prodotti chiave',
        TEXT: 'Scopri i must have della prossima stagione',
        BUTTON: 'Scopri ora',
        ADD_TO_CART: 'Aggiungi al carrello'
      },
      PROMOTIONS: {
        TITLE: 'Promozioni',
        EXPLORE: 'Scopri tutte le promozioni',
      },
      SHOWCASE: {
        ALL: 'Tutti',
        EXPLORE: 'Esplora il catalogo {{name}}',
        SHOP_NOW: 'Acquista ora',
        DISCOVER_MORE: 'Scopri tutti i prodotti per {{name}}',
      }
    },
    PRODUCTS: {
      LIST: {
        FILTERS: 'Filtri',
        ACTIVE_FILTERS: 'Filtri attivi',
        BROWSE_BY: 'Sfoglia per',
        ITEMS: 'Articoli',
        ORDER_BY: 'Ordina per',
        NO_PRODUCTS: 'Nessun articolo',
        NO_ASSORTMENTS: 'Nessun assortment',
        VIEW: 'Vista',
        GRID: 'Griglia',
        LIST: 'Lista'
      },
      DETAIL: {
        ERROR_VARIANTS_ALREADY_PRESENT: 'Le seguenti varianti sono già nel carrello con data di consegna richiesta diversa da quella selezionata ({{date}}):',
        STYLE_COLOR_QUANTITY_LIMIT_EXCEEDED: 'Stai superando il limite di quantità style-color',
        STYLE_COLOR_QUANTITY_NOT_RESPECTED_MINIMUM: 'Stai provando ad aggiungere uno o più articoli che non rispettano il minimo ordinabile',
        PROMO: {
          ORDER: 'Ordina',
          MORE_OF: 'Articolo in più per avere il',
          MORE_MORE_OF: 'Articoli in più per avere il',
          MORE_OF_VALUE: '€ Di articoli in più, per avere il',
          DISCOUNT: 'Sconto',
          QUANTITY: 'Quantità',
          PRICE: 'Prezzo',
          VIEW_PROMO: 'Scopri promo',
          TITLE: 'Promozioni',
          PROMOTION_NAME: 'Nome',
          RANGE: 'Intervallo di validità',
          TYPE: 'Tipo di promo',
          VALIDITY_PERIOD: 'Periodo di validità',
          ITEM_IN_YOUR_CART: 'Prodotti nel tuo carrello',
          VALUE_IN_YOUR_CART: 'Valore nel tuo carrello',
          INFO_ALLERT: 'Attenzione! Le promozioni non verranno applicate sulle varianti che dispongono di uno sconto per canale',
        },
        INFO: {
          SHOP_SELLING_PERIOD: 'In negozio da/a',
          PRICE_LIST: 'Listino'
        },
        ADDITIONAL: {
          PRODUCT_DESCRIPTION: 'Descrizione',
          PRODUCT_INFO: 'Info prodotto',
          PURPOSE: 'Purpose',
          DESCRIPTION: 'Model ID',
          SEASON: 'Stagione',
          GENDER: 'Genere',
        },
        CS: {
          TITLE: 'Taglie e colori',
          DELIVERY_DATE: 'Data \n consegna',
          PLACEHOLDER: 'Cerca colore'
        },
        CONTROLLERS: {
          CLEAR_ALL: 'Pulisci quantità',
          ADD_ALL: 'Aggiungi tutto',
          COMPRESS: 'Comprimi',
          EXPAND: 'Espandi',
        },
        NO_AVAILABLE: {
          TEXT: 'Questo prodotto non è più disponibile in pre-order. Utilizza il catalogo re-order.',
          BUTTON: {
            PRE_ORDER: 'Acquista in pre-order',
            RE_ORDER: 'Acquista in re-order'
          }
        },
        SAME: 'Articoli nello stesso assortment',
        SIMILAR: 'Articoli simili',
        NO_VARIANTS_PUBLISHED: 'NESSUNA VARIANTE PUBBLICATA PER IL GRUPPO TAGLIA CORRENTE È DISPONIBILE PER LA DATA SELEZIONATA',
        ERROR_QUANTITY: 'Attenzione! Quantità richiesta non disponibile. Impostata quantità massima disponibile',
      },
      CARD: {
        WHOLESALE: 'Wholesale',
        RETAIL: 'Retail',
        AVAILABILITY: 'pezzi in stock'
      }
    },
    ORDER_CHECKOUT: {
      LIMITED_REORDER_PIECES_VIOLATION_TITLE: 'Limite pezzi riordinabili superato',
    },
    ERRORS: {
      TITLE: 'Messaggio di errore',
      PRODUCT_LOADING: 'Si è verificato un errore durante il carimento del prodotto',
      INVALID_ORDER: 'L\'ordine non è valido',
      DEFAULT_MESSAGE: 'Qualcosa è andato storto. Contatta l\'assistenza utilizzando il tasto "Aiuto" in basso a destra.'
    },
    COLLECTION_CARD: {
      SHOP_ASSORTMENT: 'Scopri assortment'
    },
    PROMOTION_CARD: {
      SHOP_PROMO: 'Scopri promozioni'
    },

    VARIANT_GRID: {
      CUSTOMER_DISCOUNT: "Il cliente per cui stai comprando possiede per lo store corrente uno sconto del",
      USE_ACTION: "Usa azione",
      USING_PERC: "applicando direttamente lo sconto del",
      ADD_DELIVERY_WITH_STOCK: 'Aggiungi una consegna con quantità in stock',
      ADD_DATE_WITH_STOCK: 'Aggiungi una data con quantità in stock',
      QTY_AVAILABLE_IN_STOCK: 'Qtà disp. in stock',
      USE_OLD_VERSION: 'Usa versione precedente',
      USE_NEW_VERSION: 'Usa la nuova versione',
      NEW_SIZE_GRID_NOTICE: 'È disponibile la nuova griglia taglie. Da qui puoi scegliere quale versione usare.',
      A_CUSTOM_DELIVERY: 'una consegna personalizzata',
      REORDER_SECTION: 'sezione re-order',
      SELECT_COLORS: 'Seleziona i colori per vedere date e quantità',
      ADD_DELIVERY: 'Aggiungi consegna personalizzata',
      ON_DATE: 'In questa data',
      COLORS: 'Colori',
      PCS_ORDERED: 'Pezzi ordinati',
      CUSTOM_ADD: 'Aggiunta personalizzata',
      ADD_QTY: 'Aggiungi quantità',
      SELECT_CUSTOM_DELIVERY: 'Seleziona la tua consegna personalizzata',
      ADD_ITEMS_CUSTOM: 'Aggiungi articoli con opzioni personalizzate',
      CANT_MANAGE_DATES: 'Non puoi gestire le date di consegna in',
      DISCOUNT_APPLIED_ALL: 'Lo sconto sarà applicato a ogni articolo che stai aggiungendo, inclusi quelli per cui le quantità erano già state inserite.',
      DIFF_PRICE_WARNING: 'Stai aggiungendo articoli con prezzi diversi, quindi non puoi impostare un prezzo all\'ingrosso desiderato per calcolare lo sconto.',
      PERCENTAGE: 'Percentuale',
      DISCOUNT_NAME: 'Nome sconto',
      DISCOUNT_TYPE: 'Tipo di sconto',
      DESIRED_WHOLESALE: 'Prezzo wholesale desiderato',
      DISCOUNT_PCT: 'Percentuale di sconto',
      CLEAR_QUANTITY: 'Pulisci quantità',
      ADD_ALL: 'Aggiungi tutto',
      ADD: 'Aggiungi',
      PRE_COMPILE_WITH_AVAILABLE_QTY: 'Precompila con quantità disponibili',
      PRECOMPILE: 'Precompila',
      COPY: 'Copia i valori degli input',
      PASTE: 'Incolla i valori copiati',
      COPIED: 'Valori copiati!',
      PASTED: 'Valori incollati!',
      ADD_AVAILABLE_QUANTITY: 'Aggiungi quantità disponibili',
      QTY_AVAILABLE: 'Quantità disponibili',
      QTY_IN_CART: 'Quantità nel carrello',
      THERE_ARE_NO_AVAILABLE_QUANTITIES_TO_ADD: 'Non ci sono quantità disponibili da aggiungere',
      MAX_QTY_REACHED: 'Quantità massima raggiunta',
      QTY_NOT_AVAILABLE: 'Quantità non disponibile',
      QTY_NOT_AVAILABLE_BY_CLICKING_SAVE_THE_VARIANT_WILL_BE_REMOVED: 'Quantità non disponibile. Cliccando su "Salva" la variante verrà rimossa',
      LIMIT_EXCEEDED_FOR_PALETTE: 'Limite superato per il colore: {{paletteCode}}',
      HAVE_BEEN_PRECOMPILED_CLICK_ON_ADD_TO_ADD_THEM_TO_YOUR_CART: 'Le quantità del colore <b>{{colorCode}}</b> sono state precompilate. Clicca su "Aggiungi" per aggiungerle al carrello',
      HAVE_BEEN_PRECOMPILED_CLICK_ON_ADD_TO_ADD_THEM_TO_YOUR_CART_ALL: 'Le quantità disponibili sono state precompilate. Clicca su "Aggiungi tutto" per aggiungerle al carrello',
      INPUTS_RESET_TO_ZERO: 'Input reimpostati a 0.',
      ITEMS_ADDED_TO_CART: '<b>{{sumQtyAdded}}</b> pezzi aggiunti al carrello.',
      NO_QUANTITIES_TO_ADD: 'Non ci sono quantità da aggiungere.',
      RESET_QUANTITIES_INPUTS: 'Azzera input quantità',
      NO_COLORS_FOUND: 'Nessun colore trovato',
      NO_COLORS_FOUND_HINT: 'Per vedere le varianti, crea un carrello e assicurati che ci sia una sales campaign attiva.',
      NO_AVAILABLE_DATES: 'Nessuna data di consegna disponibile',
      CHOOSE_DELIVERY_DATE: 'Data di consegna',
      DATES: '({{numberDate}} disponibili)',
      SUGG_RETAIL: 'Sugg retail',
      MAX: 'Max',
      SUGG: 'Sugg',
      PROMOTION_TABLE: 'Mostra promozioni',
      PRICE_TABLE: 'Mostra prezzi',
      PRICE_TABLE_TITLE: 'Tabella prezzi',
      PROMOTION_TABLE_TITLE: 'Tabella promozioni',
      BY_VALUE: 'Per valore acquistato',
      BY_QUANTITY: 'Per quantità acquistata',
      QUANTITY: 'Quantità',
      MIN_QTY_ERROR: 'La quantità minima non è stata rispettata'
    },

    MODAL_ATTENTION_CHANGE_ORDER_QTY: {
      LOSE_CUSTOM_DELIVERY_DATES: 'Modificando le quantità, perderai le date personalizzate impostate! Ricorda di reimpostarla in fase di conferma d\'ordine!',
      ARE_YOU_SURE: 'Sei sicuro?',
      CONFIRM: 'Conferma',
    },


    PROMOTION_STEPS: {
      ITEMS_IN_THE_CART: 'Articoli nel carrello {{products}}',
      PROMOTION_DISCOUNT: 'Sconto promozione {{discount}}%',
      ADD_PCS_FOR_REACH_PROMO_DISCOUNT: 'Aggiungi {{pcs}} pezzi per raggiungere lo sconto promozione',
      CART_VALUE: 'Valore carrello {{value}}',
      ADD_VALUE_FOR_REACH_PROMO_DISCOUNT: 'Aggiungi {{value}} per raggiungere lo sconto promozione',
      PROMOTION: 'Promozione',
    },
    BULK_OPERATIONS: {
      STATUS: {
        AWAITINGPROCESSING: 'In attesa di elaborazione',
        PROCESSING: 'In elaborazione',
        PROCESSEDWITHOUTISSUES: 'Elaborato',
        PROCESSEDWITHISSUES: 'Elaborato con problemi',
        PROCESSINGFAILURE: 'Elaborazione fallita',
      },
      TYPES: {
        ADDNEWITEMS: 'Aggiungi nuovi articoli',
        REMOVEITEMS: 'Rimuovi articoli',
        REPLACEITEMS: 'Sostituisci articoli',
        EDITQUANTITY: 'Cambia quantità',
        CHANGEITEMSDELIVERYDATE: 'Cambia data consegna',
        EDITWHOLESALEPRICE: 'Cambia prezzo netto',
        CHANGERETAILPRICE: 'Cambia prezzo retail',
        UPDATEERPSERVICEITEMS: 'Costi extra aggiornati',
        CHANGECUSTOMERANDSHIPPINGADDRESS: 'Cambia cliente e punto di vendita',
        CANCELORDER: 'Annulla ordini',
        UPDATEFROMTEMPLATE: 'Aggiorna da template',
        UPDATEORDERHEADER: 'Aggiorna header ordine',
      },
      SCOPES:{
        SINGLEORDER: 'Ordine singolo',
        MULTIPLEORDERS: 'Ordini multipli',
      },
      MODAL : {
        TITLE: 'Dettagli operazione',
        TAB1_TITLE: 'Log ERP',
        TAB2_TITLE: 'Issues',
      },
      FILTER: {
        ALL: 'Tutte le operazioni bulk',
        ONLY_MINE: 'Le tue operazioni bulk',
      },
      BACK_TO_BULK_OPERATIONS: 'Operazioni',
      PROCESSED_ORDER_ITEMS_COUNT: 'Item Lavorati',
      PROCESSED_WITH_ISSUES_COUNT: 'Issues',
      PENDING_OPERATIONS: 'Operazioni in attesa',
      LOADING_OPERATIONS: 'Caricamento operazioni...',
      NO_PENDING_OPERATIONS: 'Nessuna operazione in attesa',
      NO_PENDING_OPERATIONS_DESC: 'Tutte le operazioni per questo ordine sono state processate.',
      TOTAL_OPERATIONS: 'Totale {{count}} operazioni in attesa',
      VIEW_DETAILS: 'Visualizza dettagli',
      VIEW_PENDING_OPERATIONS: 'Visualizza operazioni in attesa',
      CREATED_BY: 'Creato da',
      AFFECTED_ITEMS: 'Articoli interessati',
      ADD_NEW_ITEMS: 'Aggiungi nuovi articoli',
      REMOVE_ITEMS: 'Rimuovi articoli',
      REPLACE_ITEMS: 'Sostituisci articoli',
      CHANGE_QUANTITY: 'Cambia quantità',
      CHANGE_DELIVERY_DATE: 'Cambia data consegna',
      ADD_DELIVERIES: 'Aggiungi consegne',
      DELIVERIES_TO_ADD: 'Consegne da aggiungere',
      CHANGE_WHOLESALE_PRICE: 'Cambia prezzo netto',
      CHANGE_RETAIL_PRICE: 'Cambia prezzo retail',
      UPDATE_SERVICE_ITEMS: 'Costi extra aggiornati',
      CHANGE_CUSTOMER_AND_POS: 'Cambia cliente e punto di vendita',
      CANCEL_ORDERS: 'Annulla ordini',
      UPDATEFROMTEMPLATE: 'Aggiorna da template',
      UPDATE_ORDER_HEADER: 'Aggiorna header ordine',
      SINGLE_ORDER: 'Ordine singolo',
      MULTIPLE_ORDERS: 'Ordini multipli',
      PRODUCT: 'SKU Code-EAN',
      DELIVERY_DATE: 'Data consegna',
      UNKNOWN: 'Sconosciuto',
      UNKNOWN_SCOPE: 'Scope sconosciuto',
      ITEMS_TO_ADD: 'Articoli da aggiungere',
      ITEMS_TO_REMOVE: 'Articoli da rimuovere',
      ITEMS_TO_REPLACE: 'Articoli da sostituire',
      QUANTITY_CHANGES: 'Modifiche quantità',
      DELIVERY_DATE_CHANGES: 'Modifiche data consegna',
      PRICE_CHANGES: 'Modifiche prezzo',
      CUSTOMER_AND_POS_CHANGES: 'Modifiche cliente e punto di vendita',
      CUSTOMER: 'Cliente',
      POINT_OF_SALE: 'Punto di vendita',
      ORDER_CANCELLATION: 'Annulla ordine',
      OLD_PRODUCT: 'Vecchio SKU Code-EAN',
      UPDATE_FROM_TEMPLATE: 'Aggiorna da template',
      NEW_PRODUCT: 'Nuovo SKU Code-EAN',
      NEW_PRICE: 'Nuovo prezzo',
      OLD_QUANTITY: 'Vecchia quantità',
      NEW_QUANTITY: 'Nuova quantità',
      OLD_DATE: 'Vecchia data',
      NEW_DATE: 'Nuova data',
      OLD_PRICE: 'Vecchio prezzo',
      FROM: 'Da',
      TO: 'A',
      CANCELLATION_REASON_ID: 'ID motivo annullazione',
      QUANTITY: 'Quantità',
      DELIVERY: 'Consegna',
      REASON: 'Motivo',
      PRICE: 'Prezzo',
      TYPE: 'Tipo operazione',
      ERP_SERVICE_TYPE: 'Tipo di costo',
      ERP_SERVICE_VALUE: 'Nuovo valore'
    },
    REPORTS: {
      STORE_VARIANTS: 'Varianti prodotto',
      STORE_ORDERS: 'Ordini prodotto',
      STORE_ORDERS_ITEMS: 'Articoli ordine',
    },
    GRID: {
      RESET_COLUMN_ORDER: 'Ripristina ordine colonne',
    },
    ORDER_GRID: {
      BULK_EDIT: {
        SYNC_LATER_SUCCESS: '{{count}} ordine/i salvato/i: la modifica bulk è in coda e verrà sincronizzata in seguito.',
        SYNC_NOW_SUCCESS: '{{count}} ordine/i salvato/i: la modifica bulk è in fase di sincronizzazione.',
      },
      BULK_DELETE: {
        SYNC_LATER_SUCCESS: '{{count}} ordine/i in coda per la cancellazione e verranno sincronizzati in seguito.',
        SYNC_NOW_SUCCESS: '{{count}} ordine/i in coda per la cancellazione, la sincronizzazione è in elaborazione.',
      },
    },
    PENDING_BULK: {
      SYNC_SELECTED: 'Sincronizza operazioni selezionate ({{count}})',
      SYNC_ALL: 'Sincronizza tutte le operazioni in attesa',
      INFO_MESSAGE: 'Stai visualizzando tutti i tuoi bulk in attesa.',
      ONLY_YOU: 'Solo tu',
      YOU_AND_OTHERS: 'Tu e altri utenti',
      SYNC: 'Sincronizza',
      GO_TO_ORDER: 'Vai all\'ordine',
      VIEW_ALL_BULK_OPERATIONS: 'Visualizza tutte le operazioni bulk',
      PENDING: 'In attesa',
      SYNCED: 'Sincronizzato',
      TAB: {
        EDIT_ORDERS: 'Modifica ordini',
        VIEW_PENDING_BULK: 'Visualizza operazioni bulk in attesa',
      },
      MINES: 'I miei',
      OTHERS: 'Altri',
      OTHER_USERS: 'Altri utenti',
      FILTER: {
        VISIBILITY: 'Mostra',
        ALL_USERS: 'Tutti gli utenti',
        ONLY_MINE: 'Solo i miei',
      },
      SYNC_SUCCESS: 'Sincronizzazione avviata con successo',
      SYNC_ALL_SUCCESS: 'Sincronizzazione avviata per tutte le operazioni in attesa',
      COLUMNS: {
        PENDING_OPERATIONS: 'N operazioni in attesa',
        HANDLED_BY: 'Operazioni in attesa gestite da',
      },
      CONFIRM_MODAL: {
        SINGLE_TITLE: 'Sincronizzare le operazioni in attesa?',
        ONLY_YOU_MESSAGE: 'Stai per sincronizzare le operazioni in attesa per gli ordini selezionati. Ricorda: non potrai eseguire altre operazioni su questi ordini finché la sincronizzazione non sarà completata.',
        WITH_OTHERS_MESSAGE: 'Questo ordine è attualmente in modifica da parte di altri membri del team. La sincronizzazione includerà anche le operazioni in attesa degli altri utenti. Come vuoi procedere? Ricorda: non potrai eseguire altre operazioni su questo ordine finché la sincronizzazione non sarà completata.',
        SYNC_ALL_MESSAGE: 'Stai per sincronizzare tutte le operazioni in attesa per questo ordine. Nessuno potrà eseguire altre operazioni finché la sincronizzazione non sarà completata.',
        MIXED_SELECTION_MESSAGE: 'Alcuni ordini nella selezione sono attualmente in modifica da parte di altri membri del team. La sincronizzazione includerà anche le operazioni in attesa degli altri utenti. Come vuoi procedere? Ricorda: nessuno potrà eseguire altre operazioni su questi ordini finché la sincronizzazione non sarà completata.',
        EXCLUDE_IN_USE_BTN: 'Escludi ordini in uso',
        SYNC_ALL_BTN: 'Sincronizza tutti',
      },
    },
    POWER_BI: {
      LOAD_ERROR: 'Impossibile caricare i report Power BI. Riprova più tardi.',
      FILTERS_TITLE: 'Filtri',
      FILTER_PLACEHOLDER: 'Seleziona...',
      CANCEL: 'Annulla',
      APPLY: 'Applica',
      MONTH: 'Mese',
      CAMPAIGN: 'Campagna',
      SEASON: 'Stagione',
      POINT_OF_SALE: 'Punto vendita',
      CUSTOMER: 'Cliente',
      AGENCY: 'Agenzia',
    },
  },
};
